(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajax-cart-new"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('.new-cart')) {
    // Classes
    const acNewCls = 'ac-new';
    const acNewActiveCls = 'ac-new--active';
    const acNewBoxCls = 'ac-new__box';
    const acNewLoadingCls = 'ac-new__loading';
    const acNewLoadingActiveCls = 'ac-new__loading--active';
    const acNewHeaderCloseCls = 'ac-new-header__close';
    const acNewMainCls = 'ac-new__main';
    const acNewItemsCls = 'ac-new__items';
    const acNewFooterCls = 'ac-new-footer';
    const acNewPairingCls = 'ac-new-pairing';
    const acNewPairingImgCls = 'ac-new-pairing__img';
    const acNewPairingPriceCls = 'ac-new-pairing__price';
    const acNewPairingSelectCls = 'ac-new-pairing__select';
    const acNewPairingAddCls = 'ac-new-pairing__add';
    const acNewPairingFormCls = 'ac-new-pairing__main-bottom';
    const acNewRemoveCls = 'ac-new-item__remove';
    const acNewQuantityUpCls = 'ac-new-selector__plus';
    const acNewQuantityDownCls = 'ac-new-selector__minus';
    const acNewSelectorCls = 'ac-new-selector';
    const acNewSelectorInputCls = 'ac-new-selector__input';
    const acNewFooterShippingCls = 'ac-new-footer__row--shipping';
    const acNewFooterShippingActiveCls = 'ac-new-footer__row--active';
    const acNewAnnouncementTextCls = 'ac-new-announcement__text';
    const acDiscountCodeCls = 'ac-new-discount-code';
    const acDiscountCodeRemoveCls = 'ac-new-discount-code__remove';
    const acDiscountCodeNameCls = 'ac-new-discount-code__name';
    const acSubmitCodeFormCls = 'ac-new-discounts__form';
    const acSubmitCodeFormInputCls = 'ac-new-discounts__input';
    const acSubmitCodeFormButtonCls = 'ac-new-discounts__button';
    const acSubmitCodeFormErrorCls = 'ac-new-discounts__error';
    const acSubmitCodeFormErrorActiveCls = 'ac-new-discounts__error--active';
    const acNewGwCls = 'ac-new-giftwrap';
    const acNewGwActiveCls = 'ac-new-giftwrap--active';
    const acNewGwHeaderCls = 'ac-new-giftwrap__header';
    const acNewGwBodyCls = 'ac-new-giftwrap__body';
    const acNewGwMinusCls = 'ac-new-gw-selector__minus';
    const acNewGwPlusCls = 'ac-new-gw-selector__plus';
    const acNewGwInputCls = 'ac-new-gw-selector__input';
    const acNewGwFormCls = 'ac-new-giftwrap-prod__bottom';
    const acNewGnCls = 'ac-new-giftnote';
    const acNewGnActiveCls = 'ac-new-giftnote--active';
    const acNewGnHeaderCls = 'ac-new-giftnote__header';
    const acNewGnBodyCls = 'ac-new-giftnote__body';
    const acNewGnNoteCls = 'ac-new-giftnote__note';

    let letterTeetherGiftSyncing = false;
    let letterTeetherGiftConfig = null;
    let bogosCheckoutPrepared = false;
    let acCartRefreshing = false;

    try {
      const letterTeetherGiftConfigEl = document.getElementById('letter-teether-gift-config');
      if (letterTeetherGiftConfigEl) {
        letterTeetherGiftConfig = JSON.parse(letterTeetherGiftConfigEl.textContent);
      }
    } catch (err) {
      console.error('Failed to parse letter teether gift config', err);
    }

    function isBogosGiftLine(item) {
      if (!item) return false;
      const props = item.properties || {};
      if (Object.keys(props).some((key) => key.toLowerCase().includes('bogos'))) return true;
      const giftHandles = ['the-letter-teether', 'the-teether'];
      if (giftHandles.includes(item.handle) && item.final_line_price === 0) return true;
      const title = `${item.product_title || ''} ${item.title || ''}`.toLowerCase();
      return title.includes('100% off');
    }

    function getLetterTeetherLines(cart) {
      if (!letterTeetherGiftConfig?.productId) return [];

      return cart.items.filter((item) => item.product_id === letterTeetherGiftConfig.productId);
    }

    function getLetterTeetherGiftLines(cart) {
      return getLetterTeetherLines(cart).filter((item) => isBogosGiftLine(item));
    }

    function getInvalidLetterTeetherGiftLines(cart) {
      return getLetterTeetherLines(cart).filter((item) => !isBogosGiftLine(item));
    }

    async function enforceBogosGiftQuantity(cart) {
      const overflow = cart.items.filter((item) => isBogosGiftLine(item) && item.quantity > 1);
      if (!overflow.length) return false;

      const updates = {};
      overflow.forEach((item) => {
        updates[item.key] = 1;
      });

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!res.ok) {
        throw new Error(`Failed to enforce free gift quantity: ${res.status}`);
      }

      return true;
    }

    function getQualifyingSubtotal(cart) {
      const excludedProductIds = new Set([8352906051650, 8352906018882]);

      return cart.items
        .filter((item) => item.product_id !== letterTeetherGiftConfig?.productId)
        .filter((item) => !excludedProductIds.has(item.product_id))
        .reduce((sum, item) => sum + item.original_line_price, 0);
    }

    function triggerBogosGifts(cart) {
      document.dispatchEvent(new CustomEvent('bogos:cart-change', { detail: cart }));
      document.dispatchEvent(new CustomEvent('bogos:fetch-cart', { detail: cart }));
      document.dispatchEvent(new CustomEvent('bogos:gifts', { detail: cart }));
    }

    async function removeLetterTeetherLines(cart, lines = getLetterTeetherLines(cart)) {
      if (!lines.length) return false;

      const updates = {};
      lines.forEach((line) => {
        updates[line.key] = 0;
      });

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!res.ok) {
        throw new Error(`Failed to remove letter teether gift: ${res.status}`);
      }

      return true;
    }

    async function syncLetterTeetherGiftThreshold() {
      if (!letterTeetherGiftConfig?.enabled || letterTeetherGiftSyncing) return;

      letterTeetherGiftSyncing = true;

      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const qualifyingSubtotal = getQualifyingSubtotal(cart);
        const giftLines = getLetterTeetherGiftLines(cart);
        const invalidGiftLines = getInvalidLetterTeetherGiftLines(cart);
        let shouldRefresh = false;

        if (await enforceBogosGiftQuantity(cart)) {
          shouldRefresh = true;
        }

        if (invalidGiftLines.length) {
          acLoadingOn();
          await removeLetterTeetherLines(cart, invalidGiftLines);
          shouldRefresh = true;
        }

        if (qualifyingSubtotal < letterTeetherGiftConfig.threshold && giftLines.length) {
          acLoadingOn();
          await removeLetterTeetherLines(cart, giftLines);
          shouldRefresh = true;
        }

        triggerBogosGifts(await fetch('/cart.js').then((r) => r.json()));

        if (shouldRefresh) {
          await acUpdateContent();
        }
      } catch (err) {
        console.error('Error syncing letter teether gift threshold:', err);
      } finally {
        letterTeetherGiftSyncing = false;
        acLoadingOff();
      }
    }

    function setupBogosGiftIntegration() {
      document.addEventListener('fg-gifts:updated', () => {
        if (!acRoot?.classList.contains(acNewActiveCls)) return;
        if (acCartRefreshing || letterTeetherGiftSyncing) return;
        acUpdateContent();
      });

      document.addEventListener('fg-cart:auto-updated', () => {
        if (!acRoot?.classList.contains(acNewActiveCls)) return;
        if (acCartRefreshing || letterTeetherGiftSyncing) return;
        acUpdateContent();
      });
    }

    function setupCheckoutBogos() {
      if (acRoot.dataset.bogosCheckoutBound === 'true') return;

      acRoot.dataset.bogosCheckoutBound = 'true';
      acRoot.addEventListener('submit', async (event) => {
        const checkoutForm = event.target.closest('form[action="/cart"]');
        if (!checkoutForm || !acRoot.contains(checkoutForm)) return;
        if (event.submitter?.name !== 'checkout') return;
        if (bogosCheckoutPrepared) return;

        const needsBogos = !!window.BOGOS_CORE?.helper?.gift?.prepareCheckout;
        const needsScrub = typeof window.tbRemoveBlockedBundleParents === 'function';
        if (!needsBogos && !needsScrub) return;

        event.preventDefault();
        bogosCheckoutPrepared = true;

        try {
          if (needsScrub) {
            await window.tbRemoveBlockedBundleParents();
          }
          if (needsBogos) {
            await window.BOGOS_CORE.helper.gift.prepareCheckout();
          }
          checkoutForm.requestSubmit(event.submitter);
        } catch (err) {
          console.error('Checkout prepare failed:', err);
          checkoutForm.requestSubmit(event.submitter);
        } finally {
          bogosCheckoutPrepared = false;
        }
      });
    }

    setupBogosGiftIntegration();

    const AC_EMBROIDERY_VARIANT_ID = 40890756530242;

    const acRoot = document.querySelector(`.${acNewCls}`);
    setupCheckoutBogos();
    const acCartAnchors = document.querySelectorAll('a[href^="/cart"]');
    const acProductForms = document.querySelectorAll(':not(.ac-new) form[action^="/cart/add"]');
    const headerCount = document.querySelector('#header-cart-count');
    const acAnnouncementText = acRoot.querySelector(`.${acNewAnnouncementTextCls}`);

    // Data
    const acMoneyFormat = acRoot.getAttribute('data-money-format');
    const acMoneyFormatExample = acRoot.getAttribute('data-money-format-example');
    const acCountry = acRoot.getAttribute('data-country');
    const acSectionId = acRoot.getAttribute('data-section-id') || 'ajax-cart-new';

    // State
    const acDebounceTimers = {};
    let acScrollPosition = 0;

    // Temp selectors
    let acClose,
      acMain,
      acItems,
      acFooter,
      acPairings,
      acBox,
      acRemoves,
      acLoading,
      acQuantityUps,
      acQuantityDowns,
      acDiscountCodes,
      acSubmitCodeForm,
      acSubmitCodeFormInput,
      acSubmitCodeFormButton,
      acSubmitCodeError,
      acNewGw,
      acNewGwHeader,
      acNewGwBody,
      acNewGwMinus,
      acNewGwPlus,
      acNewGwInput,
      acNewGwForm,
      acNewGn,
      acNewGnHeader,
      acNewGnBody,
      acNewGnNote;

    // Assign event listeners
    acRoot.addEventListener('click', (e) => acCloseCart());
    // acCartAnchors.forEach((el) => {
    //   el.addEventListener('click', (e) => {
    //     e.preventDefault()
    //     acOpenCart()
    //   })
    // })

    acProductForms.forEach((form) => {
      form.dataset.acBound = 'true';
      form.addEventListener('submit', (e) => acHandleAdd(e));
    });

    // Forms rendered after load (quick shop, re-rendered sections) never got the
    // listener above, so their embroidery add-on was skipped. Catch them here.
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLElement)) return;
      if (!form.matches('form[action^="/cart/add"]')) return;
      if (form.dataset.acBound === 'true') return;
      if (form.closest(`.${acNewCls}`)) return;

      acHandleAdd(e);
    });

    // Stylux cart refresh listener
    document.addEventListener('stylux:cart:refresh', (e) => {
      acUpdateContent();

      acOpenCart();
    });

    document.addEventListener('mouseup', (e) => {
      if (
        e.target.matches('.bndlr-add-to-cart') ||
        e.target.matches('.bndlr-add-bundle-to-cart') ||
        e.target.matches('.bndlr-add-sectioned-bundle-to-cart')
      ) {
        acOpenCart();

        setTimeout(() => {
          acUpdateContent();
        }, 600);

        setTimeout(() => {
          acUpdateContent();
        }, 1200);
      }
    });

    // Assign temp event listeners
    setSelectorsAndEvents();

    // Update the bundlr total
    document.addEventListener('bundler:loaded', () => {
      try {
        if (acRoot.getAttribute('data-bundle')) window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }
    });

    // Methods
    function setupGiftnote() {
      acNewGn = acRoot.querySelector(`.${acNewGnCls}`);

      if (acNewGn) {
        acNewGnHeader = acNewGn.querySelector(`.${acNewGnHeaderCls}`);
        acNewGnBody = acNewGn.querySelector(`.${acNewGnBodyCls}`);
        acNewGnNote = acNewGn.querySelector(`.${acNewGnNoteCls}`);

        acNewGnHeader.setAttribute('role', 'button');
        acNewGnHeader.setAttribute('tabindex', '0');
        acNewGnHeader.setAttribute('aria-expanded', 'false');

        // Slide toggle
        acNewGnHeader.addEventListener('click', () => {
          acNewGn.classList.toggle(acNewGnActiveCls);

          if (acNewGn.classList.contains(acNewGnActiveCls)) {
            acNewGnBody.style.maxHeight = acNewGnBody.scrollHeight + 'px';
            acNewGnHeader.setAttribute('aria-expanded', 'true');

            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGnBody.style.maxHeight = '0px';
            acNewGnHeader.setAttribute('aria-expanded', 'false');
          }
        });

        acNewGnHeader.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            acNewGnHeader.click();
          }
        });

        //set note
        let noteTimer;
        acNewGnNote.addEventListener('keyup', (e) => {
          clearTimeout(noteTimer);

          noteTimer = setTimeout(() => {
            const noteText = acNewGnNote.value.trim();

            fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ note: noteText }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`Failed to update cart note: ${res.status}`);
              })
              .catch((err) => {
                console.error('Cart note update error:', err);
              });
          }, 500);
        });
      }
    }

    function setupGiftwrap() {
      acNewGw = acRoot.querySelector(`.${acNewGwCls}`);

      if (acNewGw) {
        acNewGwHeader = acNewGw.querySelector(`.${acNewGwHeaderCls}`);
        acNewGwBody = acNewGw.querySelector(`.${acNewGwBodyCls}`);
        acNewGwMinus = acNewGw.querySelector(`.${acNewGwMinusCls}`);
        acNewGwPlus = acNewGw.querySelector(`.${acNewGwPlusCls}`);
        acNewGwInput = acNewGw.querySelector(`.${acNewGwInputCls}`);
        acNewGwForm = acNewGw.querySelector(`.${acNewGwFormCls}`);

        acNewGwHeader.setAttribute('role', 'button');
        acNewGwHeader.setAttribute('tabindex', '0');
        acNewGwHeader.setAttribute('aria-expanded', 'false');

        // Slide toggle
        acNewGwHeader.addEventListener('click', () => {
          acNewGw.classList.toggle(acNewGwActiveCls);

          if (acNewGw.classList.contains(acNewGwActiveCls)) {
            acNewGwBody.style.maxHeight = acNewGwBody.scrollHeight + 'px';
            acNewGwHeader.setAttribute('aria-expanded', 'true');
            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGwBody.style.maxHeight = '0px';
            acNewGwHeader.setAttribute('aria-expanded', 'false');
          }
        });

        acNewGwHeader.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            acNewGwHeader.click();
          }
        });

        // Down
        acNewGwMinus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          if (val > 1) {
            acNewGwInput.value = val - 1;
          }
        });

        // Up
        acNewGwPlus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          acNewGwInput.value = val + 1;
        });

        // Add
        acNewGwForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          acLoadingOn();

          const variantId = acNewGwForm.querySelector('input[name="id"]').value;
          const quantity = parseInt(acNewGwInput.value, 10) || 1;
          const productId = acNewGwForm.querySelector('input[name="product-id"]').value;

          try {
            const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: quantity,
                  },
                ],
              }),
            });

            if (!res.ok) {
              throw new Error(`Giftwrap add failed: ${res.status}`);
            }

            await acUpdateContent();
            acOpenCart();

            try {
              const formData = new FormData(form);
              const id = formData.get('id');
              wunderkindSDK('addToCart', { 'item:id': `${productId}` });
            } catch (err) {
              console.log('Failed to send wunderkind data', err);
            }
          } catch (err) {
            console.error('Error adding giftwrap:', err);
          } finally {
            acLoadingOff();
          }
        });
      }
    }

    function positionCartSavings() {
      const savings = acRoot.querySelector('.ac-new-footer__savings');
      const checkoutBtn = acRoot.querySelector('.ac-new-footer button[name="checkout"]');
      if (!savings || !checkoutBtn) return;
      checkoutBtn.parentNode.insertBefore(savings, checkoutBtn);
    }

    function setSelectorsAndEvents() {
      // Set selectors
      acBox = document.querySelector(`.${acNewBoxCls}`);
      acMain = acBox.querySelector(`.${acNewMainCls}`);
      acClose = acBox.querySelector(`.${acNewHeaderCloseCls}`);
      acItems = acBox.querySelector(`.${acNewItemsCls}`);
      acFooter = acBox.querySelector(`.${acNewFooterCls}`);
      acRemoves = acBox.querySelectorAll(`.${acNewRemoveCls}`);
      acPairings = acBox.querySelectorAll(`.${acNewPairingCls}`);
      acLoading = acBox.querySelector(`.${acNewLoadingCls}`);
      acQuantityUps = acBox.querySelectorAll(`.${acNewQuantityUpCls}`);
      acQuantityDowns = acBox.querySelectorAll(`.${acNewQuantityDownCls}`);
      acDiscountCodes = acBox.querySelectorAll(`.${acDiscountCodeCls}`);
      acSubmitCodeForm = acBox.querySelector(`.${acSubmitCodeFormCls}`);
      acSubmitCodeFormButton = acBox.querySelector(`.${acSubmitCodeFormButtonCls}`);
      acSubmitCodeFormInput = acBox.querySelector(`.${acSubmitCodeFormInputCls}`);
      acSubmitCodeError = acBox.querySelector(`.${acSubmitCodeFormErrorCls}`);

      // Set event listeners
      acBox.addEventListener('click', (e) => e.stopPropagation());
      acClose.addEventListener('click', (e) => acCloseCart());

      acRemoves.forEach((remove) => {
        remove.addEventListener('click', (e) => acHandleRemove(e));
      });

      acQuantityUps.forEach((up) => {
        up.addEventListener('click', (e) => acHandleQuantityChange(e, false));
      });

      acQuantityDowns.forEach((down) => {
        down.addEventListener('click', (e) => acHandleQuantityChange(e, true));
      });

      acPairings.forEach((pairing) => {
        const acPairingSelect = pairing.querySelector(`.${acNewPairingSelectCls}`);
        const acPairingForm = pairing.querySelector(`.${acNewPairingFormCls}`);

        acPairingSelect.addEventListener('change', (e) => acHandlePairingVariantChange(e, pairing));
        acPairingForm.addEventListener('submit', (e) => acHandleAdd(e));
      });

      acDiscountCodes.forEach((codeEl) => {
        const nameEl = codeEl.querySelector(`.${acDiscountCodeNameCls}`);
        const removeBtn = codeEl.querySelector(`.${acDiscountCodeRemoveCls}`);
        if (!nameEl || !removeBtn) return;

        const codeToRemove = nameEl.textContent.trim().toUpperCase();

        removeBtn.addEventListener('click', () => acRemoveDiscountCode(codeToRemove));
      });

      if (acSubmitCodeFormButton && acSubmitCodeFormInput) {
        acSubmitCodeForm.addEventListener('submit', (e) => acAddDiscountCode(e));
      }

      setupGiftwrap();
      setupGiftnote();

      positionCartSavings();
      requestAnimationFrame(positionCartSavings);
      setTimeout(positionCartSavings, 300);
      setTimeout(positionCartSavings, 1000);
    }

    async function acAddDiscountCode(e) {
      e.preventDefault();

      const newCode = acSubmitCodeFormInput.value.trim().toUpperCase();
      if (!newCode) return;

      try {
        acLoadingOn();

        // Clear previous error
        acSubmitCodeError.textContent = '';
        acSubmitCodeError.classList.remove(acSubmitCodeFormErrorActiveCls);

        // Collect existing codes from DOM
        const existingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter(Boolean);

        // Avoid duplicate application
        if (existingCodes.includes(newCode)) {
          acSubmitCodeError.textContent = 'Code already applied';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        // 3. Combine and apply all codes
        const allCodes = [...existingCodes, newCode];

        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes.join(',') }),
        });

        const json = await res.json();

        //  Check if the new code was actually applied
        const applied = json.discount_codes?.find((d) => d.code.toUpperCase() === newCode && d.applicable);

        if (!applied) {
          acSubmitCodeError.textContent = 'Code already applied or invalid';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        await acUpdateContent();
      } catch (err) {
        acSubmitCodeError.textContent = 'Failed to apply discount code';
        acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
        acLoadingOff();
      }
    }

    async function acRemoveDiscountCode(codeToRemove) {
      try {
        // Get remaining codes
        const remainingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter((code) => code && code !== codeToRemove);

        // Send the post to remove
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });

        // Update ui
        await acUpdateContent();
      } catch (err) {
        console.error('Failed to update discount codes:', err);
      }
    }

    window.acOpenCart = function acOpenCart() {
      acScrollPosition = window.scrollY || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${acScrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      acRoot.classList.add(acNewActiveCls);
      acRoot.setAttribute('aria-hidden', 'false');
      acRoot.removeAttribute('inert');
      const cartDialog = acRoot.querySelector(`.${acNewBoxCls}`);
      if (cartDialog) cartDialog.setAttribute('aria-hidden', 'false');
      const closeButton = acRoot.querySelector(`.${acNewHeaderCloseCls}`);
      if (closeButton) closeButton.focus();
    };

    function acCloseCart() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, acScrollPosition);
      acRoot.classList.remove(acNewActiveCls);
      acRoot.setAttribute('aria-hidden', 'true');
      acRoot.setAttribute('inert', '');
      const cartDialog = acRoot.querySelector(`.${acNewBoxCls}`);
      if (cartDialog) cartDialog.setAttribute('aria-hidden', 'true');
      const cartTrigger = document.getElementById('header-cart');
      if (cartTrigger) cartTrigger.focus();
    }

    function acLoadingOn() {
      acLoading.classList.add(acNewLoadingActiveCls);
    }

    function acLoadingOff() {
      acLoading.classList.remove(acNewLoadingActiveCls);
    }

    async function acHandleQuantityChange(e, isDown) {
      e.preventDefault();

      const root = e.target.closest('.ac-new-item');
      if (root?.hasAttribute('data-letter-teether-gift')) return;

      acLoadingOn();
      const key = root.getAttribute('data-key');
      const embroideryKey = root.getAttribute('data-embroidery-key'); // same key on every embroidered row
      const selector = e.target.closest(`.${acNewSelectorCls}`);
      const input = selector.querySelector(`.${acNewSelectorInputCls}`);
      const currentValue = Number(input.value);
      let newValue = isDown ? currentValue - 1 : currentValue + 1;

      if (newValue < 0) newValue = 0;

      // Update the input right away
      input.value = newValue;

      // If there is an existing timer, clear it
      if (acDebounceTimers[key]) {
        clearTimeout(acDebounceTimers[key]);
      }

      // Start a new debounce timer
      acDebounceTimers[key] = setTimeout(async () => {
        try {
          const updates = {
            [key]: newValue,
          };

          // ──> compute the combined embroidery qty across the whole cart
          if (embroideryKey) {
            let combinedEmbQty = 0;
            document.querySelectorAll('.ac-new-item[data-has-embroidery]').forEach((item) => {
              const qtyInput = item.querySelector(`.${acNewSelectorInputCls}`);
              if (qtyInput) combinedEmbQty += Number(qtyInput.value);
            });
            updates[embroideryKey] = combinedEmbQty;
          }

          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });

          if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
          }

          // Refresh cart UI
          acUpdateContent();
        } catch (err) {
          console.error('Error updating quantity:', err);
        } finally {
          // Clean up the timer
          delete acDebounceTimers[key];
        }
      }, 400); // 400ms debounce
    }

    // The $12 add-on is a separate line item, so its quantity must always equal the
    // total quantity of line items carrying embroidery properties.
    async function acReconcileEmbroidery() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());

        let requiredQty = 0;
        let currentQty = 0;

        cart.items.forEach((item) => {
          if (item.id === AC_EMBROIDERY_VARIANT_ID) {
            currentQty += item.quantity;
          } else if (item.properties && item.properties['Embroidery font']) {
            requiredQty += item.quantity;
          }
        });

        if (requiredQty === currentQty) return;

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [AC_EMBROIDERY_VARIANT_ID]: requiredQty } }),
        });
      } catch (err) {
        console.error('Error reconciling embroidery quantity:', err);
      }
    }

    window.acUpdateContent = async function acUpdateContent() {
      if (acCartRefreshing) return;
      acCartRefreshing = true;

      try {
      await acReconcileEmbroidery();
      // Check current cart for things
      const gwIsOpen = acNewGw ? acNewGw.classList.contains(acNewGwActiveCls) : false;
      const gnIsOpen = acNewGn ? acNewGn.classList.contains(acNewGnActiveCls) : false;

      // Fetch new cart section
      const html = await fetch(
        '/?section_id=' + encodeURIComponent(acSectionId) + '&country=' + acCountry
      ).then((r) => r.text());

      // Created a dom
      const dom = document.createElement('div');
      dom.innerHTML = html;

      // update cart count
      const root = dom.querySelector(`.${acNewCls}`);
      const cartCount = root.getAttribute('data-cart-count');
      headerCount.textContent = cartCount;

      // Copy announcement text
      const announcementText = root.querySelector(`.${acNewAnnouncementTextCls}`);
      if (announcementText) announcementText.innerHTML = acAnnouncementText.innerHTML;

      // International changes
      // if (acInUs) {
      //   const shippingRow = dom.querySelector(`.${acNewFooterShippingCls}`)
      //   if (shippingRow) shippingRow.classList.remove(acNewFooterShippingActiveCls)
      // } else {
      //   const progressEl = dom.querySelector(`.${acNewProgressCls}`)
      //   if (progressEl) {
      //     progressEl.remove()
      //   }
      // }

      // If the giftwrap was open open on new
      if (acNewGw && gwIsOpen) {
        const gw = dom.querySelector(`.${acNewGwCls}`);
        const gwBody = dom.querySelector(`.${acNewGwBodyCls}`);
        if (gw && gwBody) {
          gw.classList.add(acNewGwActiveCls);
          gwBody.style.maxHeight = '100px';
        }
      }

      if (acNewGn && gnIsOpen) {
        const gn = dom.querySelector(`.${acNewGnCls}`);
        const gnBody = dom.querySelector(`.${acNewGnBodyCls}`);
        if (gn && gnBody) {
          gn.classList.add(acNewGnActiveCls);
          gnBody.style.maxHeight = '120px';
        }
      }

      // Swap content
      // ─────────────────────────────────────────────
      // Preserve BOGOs progress before DOM replacement
      // ─────────────────────────────────────────────
      const existingBogosHTML = acRoot.querySelector('.ac-new-gift-progress')?.innerHTML || null;

      // Swap content
      const box = acRoot.querySelector(`.${acNewBoxCls}`);
      const newBox = dom.querySelector(`.${acNewBoxCls}`);
      if (!box || !newBox) return;

      box.innerHTML = newBox.innerHTML;

      // ─────────────────────────────────────────────
      // Restore BOGOs progress after DOM replacement
      // ─────────────────────────────────────────────
      if (existingBogosHTML) {
        const newBogosContainer = acRoot.querySelector('.ac-new-gift-progress');
        if (newBogosContainer) {
          newBogosContainer.innerHTML = existingBogosHTML;
        }
      }

      // Set new event listeners
      setSelectorsAndEvents();

      acLoadingOff();

      const latestCart = await fetch('/cart.js').then((r) => r.json());
      triggerBogosGifts(latestCart);
      await syncLetterTeetherGiftThreshold();

      // Update bundler discounts
      try {
        window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }

      // Send wunderkind event
      try {
        const empty = document.querySelector('.ac-new-empty');
        if (empty) wunderkindSDK('emptyCart', {});
      } catch (err) {
        console.log('Failed to send wunderkind data', err);
      }
      } finally {
        acCartRefreshing = false;
      }
    };

    async function acHandleAdd(e) {
      e.preventDefault();

      acLoadingOn();

      const form = e.target;
      const formData = new FormData(form);
      const sellingPlanId = formData.get('selling_plan');

      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        // --- Extract line item properties ONLY ---
        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && value) {
            const propertyName = key.slice(11, -1); // properties[Name] → Name
            properties[propertyName] = value;
          }
        }

        // --- Detect embroidery based on properties ---
        const embroideryCheckbox = document.getElementById('embroidery__checkbox');
        const hasEmbroidery =
          (embroideryCheckbox && embroideryCheckbox.checked) ||
          properties['Embroidery'] === 'Yes' ||
          Boolean(properties['Embroidery Text']) ||
          Boolean(properties['Embroidery text']) ||
          Boolean(properties['Embroidery font']);

        const items = [];

        // --- Main product ---
        items.push({
          id: Number(formData.get('id')),
          quantity: 1,
          ...(sellingPlanId && { selling_plan: Number(sellingPlanId) }),
          ...(Object.keys(properties).length && { properties }),
        });

        // --- Embroidery add-on ---
        if (hasEmbroidery) {
          items.push({
            id: AC_EMBROIDERY_VARIANT_ID,
            quantity: 1,
          });
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          throw new Error(`Request failed (${response.status})`);
        }

        acOpenCart();
        acUpdateContent();

        // --- Wunderkind ---
        try {
          const productId = formData.get('product-id');
          if (productId) {
            wunderkindSDK('addToCart', { 'item:id': `${productId}` });
          }
        } catch (err) {
          console.log('Failed to send wunderkind data', err);
        }
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        if (submitButton) submitButton.disabled = false;
        acLoadingOff?.();
      }
    }

    async function acHandleRemove(e) {
      // Stop default
      e.preventDefault();

      // Show spinner
      acLoadingOn();

      try {
        // Get the key
        const root = e.target.closest('.ac-new-item');
        const key = root.getAttribute('data-key');

        // Remove from the dom
        root.remove();

        // Send the req
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        acUpdateContent();
      } catch (err) {
        console.log(err);
      }
    }

    function acHandlePairingVariantChange(e, pairing) {
      e.preventDefault();

      try {
        const newValue = e.target.value;
        const acPairingJsonRaw = pairing.getAttribute('data-json');
        const acPairingJson = JSON.parse(acPairingJsonRaw);
        const acPairingImg = pairing.querySelector(`.${acNewPairingImgCls}`);
        const acPairingPrice = pairing.querySelector(`.${acNewPairingPriceCls}`);
        const acPairingAdd = pairing.querySelector(`.${acNewPairingAddCls}`);
        const newVariant = acPairingJson.variants.find((v) => v.id === Number(newValue));
        if (!newVariant) return;

        // Update image
        if (newVariant.featured_image) {
          acPairingImg.src = newVariant.featured_image.src + '&width=130';
        } else {
          acPairingImg.src = acPairingJson.featured_image + '&width=130';
        }

        // Update price
        const newPrice = fmoney(acMoneyFormat, acMoneyFormatExample, newVariant.price);
        acPairingPrice.textContent = newPrice;

        // Update add
        if (newVariant.available) {
          acPairingAdd.disabled = false;
          acPairingAdd.textContent = 'Add';
        } else {
          acPairingAdd.disabled = true;
          acPairingAdd.textContent = 'Unavailable';
        }
      } catch (err) {
        console.log(err);
      }
    }

    function fmoney(moneyFormatString, moneyFormatExample, cents, removeTrailingZeros = true) {
      // Calculate raw amount
      const amount = (cents / 100).toFixed(2);
      const amount_no_decimals = Math.round(cents / 100).toString();

      // Extract separators from example (e.g. "12,345,678.90" or "12.345.678,90")
      const match = moneyFormatExample.match(/(\d{2,3})([^0-9])(\d{3})([^0-9])\d{2}$/);

      let thousandsSep = ',';
      let decimalSep = '.';

      if (match) {
        thousandsSep = match[2];
        decimalSep = match[4];
      } else {
        // Fallback in case example isn't in expected form
        console.log('Could not parse moneyFormatExample, using defaults');
      }

      // Helper to format amount with correct separators
      function formatAmount(amountStr) {
        let [intPart, decPart] = amountStr.split('.');
        const intWithSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

        if (removeTrailingZeros && decPart !== undefined) {
          decPart = decPart.replace(/0+$/, ''); // Remove trailing zeros
          if (decPart === '') {
            return intWithSep; // No decimal part left
          }
        }

        return decPart !== undefined ? intWithSep + decimalSep + decPart : intWithSep;
      }

      const formattedAmount = formatAmount(amount);
      const formattedAmountNoDecimals = formatAmount(amount_no_decimals);

      // Replace placeholders
      return moneyFormatString
        .replace('{{amount}}', formattedAmount)
        .replace('{{amount_no_decimals}}', formattedAmountNoDecimals);
    }

    // Bogos booster position
    try {
      Shopify.scaHandleConfigValue = {
        bogos_progressing_bar_query: '.ac-new-gift-progress',
        bogos_custom_progress_position: 'in', //before/in/after,
      };

      Shopify.reRenderCartCustom = function reRenderCartCustom() {
        acUpdateContent();
      };
    } catch (err) {}
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajax-cart"]) return;
  try {
    
  /* ---------- Cached DOM nodes ---------- */
  const ajaxCart = document.querySelector('.ajax-cart')
  const ajaxCartBox = document.querySelector('.ajax-cart-box')

  if (!ajaxCartBox) {
    // No cart on this template – stop here.
    return
  }

  const { cartUrl, cartChangeUrl, cartAddUrl, cartUpdateUrl } = ajaxCartBox.dataset

  /* ---------- Scroll helpers ---------- */
  function lockScroll() {
    const pos = window.scrollY
    document.body.dataset.position = pos
    document.body.classList.add('lock-scroll')
    document.body.style.top = `-${pos}px`
  }

  function unlockScroll() {
    const pos = Number(document.body.dataset.position || 0)
    document.body.classList.remove('lock-scroll')
    document.body.style.top = ''
    delete document.body.dataset.position
    window.scrollTo(0, pos)
  }

  function formatMoneyL(t, e = '${{amount}}') {
    'string' == typeof t && (t = t.replace('.', ''))
    let n = /\{\{\s*(\w+)\s*\}\}/,
      o = e
    function a(t, e) {
      return void 0 === t ? e : t
    }
    function r(t, e, n, o) {
      if (((e = a(e, 2)), (n = a(n, ',')), (o = a(o, '.')), isNaN(t) || null == t)) return 0
      t = (t / 100).toFixed(e)
      let [r, m = ''] = t.split('.'),
        u = r.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + n)
      return u + (m ? o + m : '')
    }
    let m = o.match(n)[1],
      u = (
        {
          amount: () => r(t, 2),
          amount_no_decimals: () => r(t, 0),
          amount_with_comma_separator: () => r(t, 2, '.', ','),
          amount_no_decimals_with_comma_separator: () => r(t, 0, '.', ','),
        }[m] || (() => t)
      )()
    return o.replace(n, u)
  }

  /* ---------- Cart open / close ---------- */
  function openCart() {
    ajaxCart.classList.add('ajax-cart--active')
    lockScroll()
  }
  function closeCart() {
    ajaxCart.classList.remove('ajax-cart--active')
    unlockScroll()
  }

  /* ---------- Core cart refresh ---------- */
  async function updateCart() {
    if (!ajaxCartBox) return

    try {
      /* Pull fresh cart section HTML */
      const html = await fetch('/?section_id=ajax-cart').then((r) => r.text())
      const doc = new DOMParser().parseFromString(html, 'text/html')

      const newBox = doc.querySelector('.ajax-cart-box')
      const itemCount = newBox.dataset.itemCount || '0'

      /* Replace current markup */
      ajaxCart.innerHTML = newBox.outerHTML || ''

      /* Header count */
      const headerCount = document.getElementById('header-cart-count')
      if (headerCount) headerCount.textContent = itemCount

      /* Maintain scroll position inside the drawer */
      const savedY = Number(document.body.getAttribute('cart-scroll-y') || 0)
      ajaxCart.querySelector('.ajax-cart-form-flex').scrollTo(0, savedY)
      document.body.removeAttribute('cart-scroll-y')

      /* ---- Embroidery sync (unchanged logic, but with Fetch) ---- */
      const cart = await fetch('/cart.json').then((r) => r.json())
      let totalEmbroideryLines = 0
      let embroideryTotal = 0

      cart.items.forEach((item) => {
        if (item.properties && item.properties['Embroidery text']) {
          totalEmbroideryLines += item.quantity
        } else if (item.id === 40890756530242) {
          embroideryTotal += item.quantity
        }
      })

      if (totalEmbroideryLines !== embroideryTotal) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { 40890756530242: totalEmbroideryLines } }),
        })
      }

      /* Re-open and run bundle discount refresh if available */
      setTimeout(() => {
        openCart()
        try {
          window.bndlr.updateCartDiscounts()
        } catch (e) {
          console.info(e)
        }
      }, 10)
    } catch (err) {
      console.error('updateCart error:', err)
    }
  }

  /* ---------- Utility: delegate ---------- */
  const delegate = (eventType, selector, handler, opts) => {
    document.addEventListener(
      eventType,
      (e) => {
        const target = e.target.closest(selector)
        if (target) handler(e, target)
      },
      opts
    )
  }

  /* ---------- Event wiring ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    /* Cart link opens drawer */
    delegate('click', `[href="${cartUrl}"]`, (e) => {
      e.preventDefault()
      openCart()
    })

    /* Close cart on dim-layer click or header close */
    delegate('click', '.ajax-cart', (e, overlay) => {
      const cartBox = overlay.querySelector('.ajax-cart-box')
      const closeBtn = e.target.closest('.ajax-cart-header-close')

      // Only close if clicking the overlay (outside the cart box) or on the close button
      if (!cartBox.contains(e.target) || closeBtn) {
        closeCart()
      }
    })

    /* -------- Add-to-cart form (product page) -------- */
    document.querySelectorAll('[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const url = `${form.getAttribute('action')}.js`
        const method = form.method.toUpperCase()
        const body = new URLSearchParams(new FormData(form))

        try {
          const res = await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
          })
          if (!res.ok) throw res
          await updateCart()
        } catch (err) {
          if (err.status === 422) {
            document.querySelector('.product-form-error').classList.remove('hidden')
          } else {
            console.error('Add-to-cart error:', err)
          }
        }
      })
    })

    /* -------- Quick-add buttons -------- */
    delegate('click', '.quick-add-button', async (e, btn) => {
      e.preventDefault()
      const id = Number(btn.getAttribute('href').split('/').pop())
      await fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 }),
      })
      updateCart()
    })

    /* -------- Bundle buttons (outside cart) -------- */
    delegate('mouseup', '.bndlr-add-to-cart, .bndlr-add-bundle-to-cart, .bndlr-add-sectioned-bundle-to-cart', () => {
      setTimeout(updateCart, 1200)
      setTimeout(updateCart, 2000)
    })

    /* -------- Quantity + remove inside cart -------- */
    delegate('click', '.ajax-cart .quantity-selector button, .ajax-cart-item-remove', async (e, btn) => {
      e.preventDefault()
      const item = btn.closest('.ajax-cart-item')
      if (!item) return

      const id = item.dataset.lineItemKey
      const isDown = btn.classList.contains('quantity-selector-down')
      const isRemove = btn.classList.contains('ajax-cart-item-remove')
      const currentQuantity = Number(item.querySelector('.quantity-selector input').value)

      /* Remember scroll position */
      document.body.setAttribute('cart-scroll-y', ajaxCart.querySelector('.ajax-cart-form-flex').scrollTop || 0)

      if (isDown && currentQuantity === 0) return

      const quantity = isRemove ? 0 : currentQuantity + (isDown ? -1 : 1)

      await fetch(`${cartChangeUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      })
      updateCart()
    })

    /* -------- Recommended products in drawer -------- */
    delegate('click', '.ajax-cart-rec .ajax-cart-rec-item-add', async (e, btn) => {
      e.preventDefault()
      const id = Number(btn.closest('.ajax-cart-rec-item').querySelector('[name="id"]').value)
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      })
      updateCart()
    })

    /* Variant dropdown in recommended products */
    delegate('change', '.ajax-cart-rec select', (e, select) => {
      const root = select.closest('.ajax-cart-rec-item')
      const productJson = JSON.parse(root.dataset.product)
      const variantId = Number(select.value)
      const variant = productJson.variants.find((v) => v.id === variantId)
      const priceElement = root.querySelector('.ajax-cart-rec-item-price')

      if (variant.featured_image) root.querySelector('img').src = variant.featured_image.src
      priceElement.textContent = formatMoneyL(variant.price).replace('.00', '')
    })

    /* -------- Gift-wrap accordion + qty -------- */
    delegate('click', '.ajax-cart-giftwrap-header', (e, hdr) => {
      hdr.nextElementSibling.classList.toggle('hidden')
      hdr.parentElement.classList.toggle('ajax-cart-giftwrap--active')
    })

    delegate('click', '.ajax-cart-giftwrap .quantity-selector button', (e, btn) => {
      const up = btn.classList.contains('quantity-selector-up')
      const input = btn.parentElement.querySelector('input')
      const current = Number(input.value)
      input.value = up ? current + 1 : Math.max(current - 1, 1)
    })

    delegate('click', '.ajax-cart-giftwrap-product-right button', async (e, btn) => {
      const root = btn.closest('.ajax-cart-giftwrap')
      const id = root.dataset.id
      const quantity = Number(root.querySelector('.quantity-selector input').value)
      await fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      })
      updateCart()
    })

    /* -------- Gift note accordion -------- */
    delegate('click', '.ajax-cart-note-header', (e, hdr) => {
      hdr.nextElementSibling.classList.toggle('hidden')
      hdr.parentElement.classList.toggle('ajax-cart-note--active')
    })

    delegate('keyup', '.ajax-cart-note-note', (e, input) => {
      fetch(`${cartUpdateUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: input.value }),
      })
    })
  })

  /* Optionally keep the 2-second auto-refresh (disabled in your source) */
  // setInterval(updateCart, 2000)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baby-stage-product-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.bs-feature');
    if (!section) return;

    var lightbox = section.querySelector('[data-bs-feature-lightbox]');
    if (!lightbox) return;

    if (!lightbox.dataset.portaled) {
      document.body.appendChild(lightbox);
      lightbox.dataset.portaled = '1';
    }

    var imageEl = lightbox.querySelector('[data-bs-feature-lightbox-image]');
    var lastFocus = null;

    function openLightbox(src, alt) {
      if (!src || !imageEl) return;
      lastFocus = document.activeElement;
      imageEl.src = src;
      imageEl.alt = alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('.bs-feature-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      imageEl.removeAttribute('src');
      imageEl.alt = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bs-feature-zoom]');
      if (!trigger || !section.contains(trigger)) return;
      event.preventDefault();
      openLightbox(trigger.getAttribute('data-zoom-src'), trigger.getAttribute('data-zoom-alt'));
    });

    lightbox.querySelectorAll('[data-bs-feature-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-variant-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';

  document.querySelectorAll('[data-fall-atc]').forEach(function (btn) {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var prev = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        var res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        });
        if (!res.ok) {
          var payload = await res.json().catch(function () { return {}; });
          throw new Error(payload.description || payload.message || 'Add to cart failed');
        }
        document.dispatchEvent(new CustomEvent('stylux:cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.textContent = 'Added!';
        setTimeout(function () {
          btn.textContent = prev;
          btn.disabled = false;
        }, 1500);
      } catch (err) {
        btn.textContent = prev;
        btn.disabled = false;
        alert(err.message || 'Something went wrong.');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-new"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question')

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header')
    const body = faq.querySelector('.faq-new-question__body')
    const bodyInner = faq.querySelector('.faq-new-question__body-inner')

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active')

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active')
        f.querySelector('.faq-new-question__body').style.maxHeight = '0'
      })

      if (!isActive) {
        faq.classList.add('faq-new-question--active')
        body.style.maxHeight = bodyInner.scrollHeight + 'px'
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-right-carriers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function optNorm(value) {
      return value == null ? '' : String(value).trim();
    }

    function initCard(card) {
      if (card.dataset.frcBound === '1') return;
      var modal = card.querySelector('[data-frc-modal]');
      var trigger = card.querySelector('[data-frc-quick-shop]');
      if (!modal || !trigger) return;
      card.dataset.frcBound = '1';

      if (!modal.dataset.frcPortaled) {
        document.body.appendChild(modal);
        modal.dataset.frcPortaled = '1';
      }

      var dialog = modal.querySelector('.frc-quick-shop__dialog');
      var imageEl = modal.querySelector('[data-frc-modal-image]');
      var priceEl = modal.querySelector('[data-frc-modal-price]');
      var compareEl = modal.querySelector('[data-frc-modal-compare]');
      var errorEl = modal.querySelector('[data-frc-modal-error]');
      var addBtn = modal.querySelector('[data-frc-modal-add]');
      var swatchEls = Array.prototype.slice.call(modal.querySelectorAll('[data-frc-swatch]'));
      var groupValueEls = Array.prototype.slice.call(modal.querySelectorAll('[data-frc-group-value]'));

      var variants = [];
      var scriptEl = modal.querySelector('[data-frc-variants]');
      if (scriptEl) {
        try {
          variants = JSON.parse(scriptEl.textContent);
        } catch (err) {
          variants = [];
        }
      }

      var selected = [];

      var optionIndices = [];
      swatchEls.forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-option-idx'), 10);
        if (optionIndices.indexOf(i) === -1) optionIndices.push(i);
      });
      optionIndices.sort(function (a, b) {
        return a - b;
      });

      function showError(message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function clearError() {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var opts = variants[i].options || [];
          var match = true;
          for (var k = 0; k < optionIndices.length; k++) {
            var oi = optionIndices[k];
            if (optNorm(opts[oi]) !== optNorm(values[oi])) {
              match = false;
              break;
            }
          }
          if (match) return variants[i];
        }
        return null;
      }

      function getSelectedVariant() {
        return findVariant(selected);
      }

      // Whether a variant matches selected values for all option indices before idx.
      function matchesPrior(variant, idx) {
        var opts = variant.options || [];
        for (var k = 0; k < optionIndices.length; k++) {
          var oi = optionIndices[k];
          if (oi >= idx) break;
          if (selected[oi] != null && optNorm(opts[oi]) !== optNorm(selected[oi])) {
            return false;
          }
        }
        return true;
      }

      // A value exists if some variant (constrained by earlier selections) has it.
      function valueExists(idx, value, requireAvailable) {
        return variants.some(function (v) {
          if (!matchesPrior(v, idx)) return false;
          if (optNorm((v.options || [])[idx]) !== optNorm(value)) return false;
          return requireAvailable ? !!v.available : true;
        });
      }

      function firstValidValue(idx) {
        var anyValue = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!matchesPrior(v, idx)) continue;
          var val = (v.options || [])[idx];
          if (anyValue == null) anyValue = val;
          if (v.available) return val;
        }
        return anyValue;
      }

      function displayNameFor(idx, value) {
        for (var i = 0; i < swatchEls.length; i++) {
          var btn = swatchEls[i];
          if (parseInt(btn.getAttribute('data-option-idx'), 10) !== idx) continue;
          if (optNorm(btn.getAttribute('data-option-value')) !== optNorm(value)) continue;
          return btn.getAttribute('data-display-value') || value || '';
        }
        return value || '';
      }

      function render() {
        var variant = getSelectedVariant();

        if (variant) {
          priceEl.textContent = variant.price || '';
          priceEl.classList.toggle('frc-quick-shop__price--sale', !!variant.compare);
          compareEl.textContent = variant.compare || '';
          if (variant.image) imageEl.src = variant.image;
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }

        groupValueEls.forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-frc-group-value'), 10);
          el.textContent = displayNameFor(idx, selected[idx]);
        });

        swatchEls.forEach(function (btn) {
          var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
          var value = btn.getAttribute('data-option-value');

          var active = optNorm(selected[idx]) === optNorm(value);
          btn.classList.toggle('frc-quick-shop__swatch--active', active);
          btn.setAttribute('aria-checked', active ? 'true' : 'false');

          var exists = valueExists(idx, value, false);
          var hasStock = exists && valueExists(idx, value, true);
          btn.classList.toggle('frc-quick-shop__swatch--disabled', !exists);
          btn.classList.toggle('frc-quick-shop__swatch--sold-out', exists && !hasStock);
          if (!exists) {
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('aria-disabled');
          }
        });
      }

      function selectValue(idx, value) {
        clearError();
        if (!valueExists(idx, value, false)) return;
        selected[idx] = value;
        // Re-validate later options against the new selection; reset invalid ones.
        for (var k = 0; k < optionIndices.length; k++) {
          var oi = optionIndices[k];
          if (oi <= idx) continue;
          if (!valueExists(oi, selected[oi], false)) {
            selected[oi] = firstValidValue(oi);
          }
        }
        render();
      }

      function initSelection() {
        var first = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) {
            first = variants[i];
            break;
          }
        }
        if (!first) first = variants[0];
        selected = first && first.options ? first.options.slice() : [];
      }

      function closeAllModals() {
        document.querySelectorAll('[data-frc-modal]').forEach(function (m) {
          m.classList.remove('is-open');
          m.setAttribute('aria-hidden', 'true');
          m.hidden = true;
        });
        document.body.classList.remove('frc-quick-shop-open');
      }

      function openModal() {
        clearError();
        initSelection();
        render();
        closeAllModals();
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('frc-quick-shop-open');
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        if (dialog) dialog.focus();
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('frc-quick-shop-open');
        window.setTimeout(function () {
          modal.hidden = true;
        }, 250);
        if (trigger && typeof trigger.focus === 'function') trigger.focus();
      }

      async function addToCart() {
        var variant = getSelectedVariant();
        if (!variant || !variant.available) return;
        clearError();
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        var previousLabel = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        try {
          var res = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
          });
          if (!res.ok) {
            var payload = await res.json().catch(function () {
              return {};
            });
            throw new Error(payload.description || payload.message || 'Add to cart failed');
          }
          document.dispatchEvent(new CustomEvent('stylux:cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          closeModal();
        } catch (err) {
          showError(err.message || 'Something went wrong. Please try again.');
          addBtn.textContent = previousLabel;
        } finally {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        }
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (!variants.length) return;
        openModal();
      });

      swatchEls.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('frc-quick-shop__swatch--disabled')) return;
          var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
          selectValue(idx, btn.getAttribute('data-option-value'));
        });
      });

      modal.querySelectorAll('[data-frc-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      addBtn.addEventListener('click', addToCart);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    function initSection(section) {
      section.querySelectorAll('[data-frc-card]').forEach(initCard);
    }

    document.querySelectorAll('.find-right-carriers').forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.find-right-carriers');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // The Babylist widget is lazy-loaded, so its global may not exist yet when the
  // button is clicked. Load it on demand and fall back to the Babylist link if the
  // widget is unavailable (blocked by an extension, offline, etc).
  (function () {
    var trigger = document.getElementById('AddToBabylist');
    if (!trigger) return;

    var SCRIPT_SRC = 'https://www.babylist.com/add.js';
    var WAIT_MS = 5000;

    function widgetReady() {
      return Boolean(window.bl && typeof window.bl.addToRegistry === 'function');
    }

    function ensureScript() {
      if (widgetReady()) return;
      if (document.querySelector('script[src*="babylist.com/add.js"]')) return;

      var script = document.createElement('script');
      script.src = SCRIPT_SRC;
      document.head.appendChild(script);
    }

    function waitForWidget() {
      return new Promise(function (resolve, reject) {
        var deadline = Date.now() + WAIT_MS;

        (function check() {
          if (widgetReady()) return resolve();
          if (Date.now() > deadline) return reject(new Error('Babylist widget unavailable'));
          setTimeout(check, 100);
        })();
      });
    }

    // Babylist's own add-item page, so the fallback still carries the product details.
    function bookmarkletUrl() {
      var params = new URLSearchParams({
        title: trigger.dataset.blTitle || '',
        url: trigger.dataset.blUrl || '',
        price: trigger.dataset.blPrice || '',
      });

      if (trigger.dataset.blImage) params.append('imgs[]', trigger.dataset.blImage);

      return 'https://www.babylist.com/bookmarklet/?' + params.toString();
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      ensureScript();

      waitForWidget()
        .then(function () {
          window.bl.addToRegistry({
            images: trigger.dataset.blImage,
            price: trigger.dataset.blPrice,
            title: trigger.dataset.blTitle,
            url: trigger.dataset.blUrl,
          });
        })
        .catch(function (err) {
          console.error(err);
          window.open(bookmarkletUrl(), '_blank', 'noopener');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question');

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header');
    const body = faq.querySelector('.faq-new-question__body');
    const bodyInner = faq.querySelector('.faq-new-question__body-inner');

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active');

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active');
        f.querySelector('.faq-new-question__body').style.maxHeight = '0';
      });

      if (!isActive) {
        faq.classList.add('faq-new-question--active');
        body.style.maxHeight = bodyInner.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-drawer"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const drawer = document.querySelector('.gift-drawer')
    const form = document.querySelector('.gift-drawer__box')
    const closeBtn = document.querySelector('.gift-drawer__close')
    const contactFieldWrapper = document.querySelector('.gift-drawer-field--contact')
    const contactInput = document.querySelector('#contact')
    const errorP = document.querySelector('.gift-drawer__error')
    const successP = document.querySelector('.gift-drawer__success')

    if (!drawer || !form) return

    const FORMSPARK_URL = 'https://submit-form.com/I1uVyIlrS'
    let previousFocus = null

    function getFocusableElements() {
      return Array.from(
        form.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.offsetParent !== null)
    }

    /* ---------------------------
     OPEN/CLOSE HELPERS
  --------------------------- */
    function openDrawer() {
      previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null
      drawer.classList.add('gift-drawer--active')
      drawer.setAttribute('aria-hidden', 'false')
      drawer.removeAttribute('inert')
      requestAnimationFrame(() => closeBtn?.focus())
    }

    function closeDrawer() {
      drawer.classList.remove('gift-drawer--active')
      drawer.setAttribute('aria-hidden', 'true')
      drawer.setAttribute('inert', '')
      if (previousFocus) previousFocus.focus()
      previousFocus = null
    }

    /* ---------------------------
     OPEN ON .open-gift-drawer CLICK
  --------------------------- */
    document.querySelectorAll('.open-gift-drawer').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        openDrawer()
      })
    })

    /* ---------------------------
     CLICK OUTSIDE → CLOSE
  --------------------------- */
    drawer.addEventListener('click', (e) => {
      if (!form.contains(e.target)) {
        closeDrawer()
      }
    })

    /* ---------------------------
     X BUTTON → CLOSE
  --------------------------- */
    closeBtn.addEventListener('click', () => {
      closeDrawer()
    })

    form.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault()
        closeDrawer()
        return
      }

      if (e.key !== 'Tab') return
      const focusable = getFocusableElements()
      if (!focusable.length) return
      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    })

    /* ---------------------------
     CONTACT METHOD SWITCHER
  --------------------------- */
    const contactMethodInputs = document.querySelectorAll("input[name='contact-method']")
    contactMethodInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        const value = e.target.value

        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        if (value === 'Mobile') {
          contactFieldWrapper.classList.add('gift-drawer-field--mobile')
          contactInput.type = 'tel'
          contactInput.autocomplete = 'tel'
        } else if (value === 'Email') {
          contactFieldWrapper.classList.add('gift-drawer-field--email')
          contactInput.type = 'email'
          contactInput.autocomplete = 'email'
        }
      })
    })

    /* ---------------------------
     AJAX SUBMIT → FORM SPARK
  --------------------------- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault()

      // Reset success message from previous submissions
      successP.classList.remove('gift-drawer__success--active')

      // Clear old error
      errorP.textContent = ''
      errorP.classList.remove('gift-drawer__error--active')

      // Gather values
      const selectedFor = form.querySelector("input[name='for']:checked")
      const selectedAge = form.querySelector("input[name='age']:checked")
      const selectedContactMethod = form.querySelector("input[name='contact-method']:checked")
      const occasion = form.querySelector('#occasion').value
      const budget = form.querySelector("input[name='budget']:checked")?.value || ''
      const contactValue = contactInput.value.trim()
      const firstName = form.querySelector('#first_name').value.trim()
      const lastName = form.querySelector('#last_name').value.trim()

      // Validation
      if (
        !firstName ||
        !lastName ||
        !selectedFor ||
        !selectedAge ||
        !occasion ||
        !selectedContactMethod ||
        !contactValue
      ) {
        errorP.textContent = 'Please complete all required fields.'
        errorP.classList.add('gift-drawer__error--active')
        return
      }

      // Build form data
      const payload = {
        'First Name': firstName,
        'Last Name': lastName,
        'Gift For': selectedFor.value,
        'Baby Age': selectedAge.value,
        'Gifting Occasion': occasion,
        Budget: budget,
        'Contact Method': selectedContactMethod.value,
        Contact: contactValue,
      }

      try {
        const response = await fetch(FORMSPARK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })

        if (!response.ok) {
          throw new Error('FormSpark submission failed')
        }

        /* ---------------------------
         SUCCESS → RESET + SHOW MESSAGE
      --------------------------- */
        form.reset()
        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        successP.classList.add('gift-drawer__success--active')
      } catch (error) {
        errorP.textContent = 'Something went wrong. Please try again.'
        errorP.classList.add('gift-drawer__error--active')
        console.error(error)
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const mobileNav = document.querySelector('[data-mobile-nav]')

  const resetMobileNav = () => {
    if (!mobileNav) return

    const triggers = mobileNav.querySelectorAll('[data-mobile-panel]')
    const panels = mobileNav.querySelectorAll('[data-mobile-panel-target]')
    const shopCats = mobileNav.querySelector('[data-mobile-shop-cats]')
    const shopCatBtns = mobileNav.querySelectorAll('[data-shop-panel]')
    const shopPanels = mobileNav.querySelectorAll('[data-mobile-shop-panel]')

    const activateMobilePanel = (panelId) => {
      triggers.forEach((trigger) => {
        const active = trigger.dataset.mobilePanel === panelId
        trigger.classList.toggle('is-active', active)
        trigger.setAttribute('aria-expanded', active ? 'true' : 'false')
      })

      panels.forEach((panel) => {
        const active = panel.dataset.mobilePanelTarget === panelId
        panel.classList.toggle('is-active', active)
      })

      if (shopCats) {
        if (panelId === 'shop') {
          shopCats.classList.add('is-open')
        } else {
          shopCats.classList.remove('is-open')
        }
      }

    }

    const activateShopCategory = (panelId) => {
      shopCatBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.shopPanel === panelId)
      })

      shopPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === panelId)
      })
    }

    mobileNav.querySelectorAll('[data-mobile-accordion]').forEach((trigger) => {
      trigger.classList.remove('is-active')
      trigger.setAttribute('aria-expanded', 'false')
    })
    mobileNav.querySelectorAll('[data-mobile-more-links]').forEach((list) => {
      list.classList.remove('is-open')
    })

    const defaultTrigger =
      mobileNav.querySelector('[data-mobile-panel="shop"]') || triggers[0]
    if (defaultTrigger) {
      activateMobilePanel(defaultTrigger.dataset.mobilePanel)
    }

    const firstShopCat = shopCatBtns[0]
    if (firstShopCat) {
      activateShopCategory(firstShopCat.dataset.shopPanel)
    }
  }

  if (mobileNav) {
    const mobileTriggers = mobileNav.querySelectorAll('[data-mobile-panel]')
    const mobilePanels = mobileNav.querySelectorAll('[data-mobile-panel-target]')
    const mobileShopCats = mobileNav.querySelector('[data-mobile-shop-cats]')
    const mobileShopCatBtns = mobileNav.querySelectorAll('[data-shop-panel]')
    const mobileShopPanels = mobileNav.querySelectorAll('[data-mobile-shop-panel]')
    const mobileAccordionTriggers = mobileNav.querySelectorAll('[data-mobile-accordion]')
    const mobileShopTrigger = mobileNav.querySelector('[data-mobile-panel="shop"]')

    const closeMobileAccordions = () => {
      mobileAccordionTriggers.forEach((trigger) => {
        trigger.classList.remove('is-active')
        trigger.setAttribute('aria-expanded', 'false')
      })

      mobileNav.querySelectorAll('[data-mobile-more-links]').forEach((list) => {
        list.classList.remove('is-open')
      })
    }

    const syncShopTriggerExpanded = () => {
      if (!mobileShopTrigger) return

      const isShopActive = mobileShopTrigger.classList.contains('is-active')
      const isShopOpen = mobileShopCats ? mobileShopCats.classList.contains('is-open') : false
      mobileShopTrigger.setAttribute('aria-expanded', isShopActive && isShopOpen ? 'true' : 'false')
    }

    const activateMobilePanel = (panelId) => {
      mobileTriggers.forEach((trigger) => {
        const active = trigger.dataset.mobilePanel === panelId
        trigger.classList.toggle('is-active', active)
        trigger.setAttribute('aria-expanded', active ? 'true' : 'false')
      })

      mobilePanels.forEach((panel) => {
        const active = panel.dataset.mobilePanelTarget === panelId
        panel.classList.toggle('is-active', active)
      })

      if (mobileShopCats) {
        if (panelId === 'shop') {
          mobileShopCats.classList.add('is-open')
        } else {
          mobileShopCats.classList.remove('is-open')
        }
      }

      syncShopTriggerExpanded()
      closeMobileAccordions()
    }

    const activateShopCategory = (panelId) => {
      mobileShopCatBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.shopPanel === panelId)
      })

      mobileShopPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === panelId)
      })
    }

    const toggleMobileAccordion = (trigger) => {
      const list = mobileNav.querySelector('[data-mobile-more-links]')
      const willOpen = !trigger.classList.contains('is-active')

      closeMobileAccordions()

      if (willOpen) {
        trigger.classList.add('is-active')
        trigger.setAttribute('aria-expanded', 'true')
        if (list) {
          list.classList.add('is-open')
        }
      }
    }

    mobileTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation()
        const panelId = trigger.dataset.mobilePanel

        if (
          panelId === 'shop' &&
          trigger.classList.contains('is-active') &&
          mobileShopCats
        ) {
          mobileShopCats.classList.toggle('is-open')
          syncShopTriggerExpanded()
          return
        }

        activateMobilePanel(panelId)
      })
    })

    mobileShopCatBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation()
        activateMobilePanel('shop')
        activateShopCategory(btn.dataset.shopPanel)
      })
    })

    mobileAccordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation()
        toggleMobileAccordion(trigger)
      })
    })
  }

  const hamburgerBtn = document.querySelector('.hamburger')
  const primaryDrawer = document.querySelector('.nav-drawer--primary')
  let navDrawerScrollY = 0

  const lockPageScroll = () => {
    navDrawerScrollY = window.scrollY || window.pageYOffset || 0
    document.documentElement.classList.add('nav-drawer-open')
    document.body.style.top = `-${navDrawerScrollY}px`
  }

  const unlockPageScroll = () => {
    if (!document.documentElement.classList.contains('nav-drawer-open')) return
    document.documentElement.classList.remove('nav-drawer-open')
    document.body.style.top = ''
    window.scrollTo(0, navDrawerScrollY)
  }

  const openPrimaryDrawer = () => {
    if (!primaryDrawer) return
    if (primaryDrawer.classList.contains('nav-drawer--active')) return
    primaryDrawer.classList.add('nav-drawer--active')
    primaryDrawer.setAttribute('aria-hidden', 'false')
    primaryDrawer.removeAttribute('inert')
    hamburgerBtn?.setAttribute('aria-expanded', 'true')
    lockPageScroll()
    resetMobileNav()
    // Move focus into the drawer for keyboard/screen-reader users
    const closeBtn = primaryDrawer.querySelector('.nav-drawer__close')
    if (closeBtn) requestAnimationFrame(() => closeBtn.focus())
  }

  const closePrimaryDrawer = ({ returnFocus = false } = {}) => {
    if (!primaryDrawer) return
    if (!primaryDrawer.classList.contains('nav-drawer--active')) return
    primaryDrawer.classList.remove('nav-drawer--active')
    primaryDrawer.setAttribute('aria-hidden', 'true')
    primaryDrawer.setAttribute('inert', '')
    hamburgerBtn?.setAttribute('aria-expanded', 'false')
    unlockPageScroll()
    if (returnFocus) hamburgerBtn?.focus()
  }

  // Open drawer on hamburger click (ignore when desktop mega-nav is active)
  hamburgerBtn?.addEventListener(
    'click',
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (window.matchMedia('(min-width: 1024px)').matches) return
      if (primaryDrawer?.classList.contains('nav-drawer--active')) {
        closePrimaryDrawer({ returnFocus: true })
        return
      }
      openPrimaryDrawer()
    },
    { passive: false }
  )

  // Close drawer when clicking outside the drawer content
  document.querySelectorAll('.nav-drawer').forEach((drawer) => {
    drawer.addEventListener('click', (e) => {
      // Only backdrop clicks (not bubbled from children that forgot stopPropagation)
      if (e.target !== drawer) return
      if (drawer.classList.contains('nav-drawer--primary')) {
        closePrimaryDrawer()
      } else {
        drawer.classList.remove('nav-drawer--active')
        drawer.setAttribute('aria-hidden', 'true')
        drawer.setAttribute('inert', '')
      }
    })
  })

  // Prevent closing when clicking inside the drawer content
  document.querySelectorAll('.nav-drawer__box').forEach((box) => {
    box.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  // Close drawer when clicking the close button
  document.querySelectorAll('.nav-drawer__close').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const drawer = btn.closest('.nav-drawer')
      if (drawer && drawer.classList.contains('nav-drawer--primary')) {
        closePrimaryDrawer({ returnFocus: true })
      } else if (drawer) {
        drawer.classList.remove('nav-drawer--active')
        drawer.setAttribute('aria-hidden', 'true')
        drawer.setAttribute('inert', '')
      }
    })
  })

  // Close the mobile drawer with the Escape key and return focus to the toggle
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    if (primaryDrawer?.classList.contains('nav-drawer--active')) {
      closePrimaryDrawer({ returnFocus: true })
    }
  })

  document.querySelectorAll('.nav-drawer-section__header').forEach((header, index) => {
    const sectionBody = header.closest('.nav-drawer-section')?.querySelector('.nav-drawer-section__body')
    if (sectionBody) {
      if (!sectionBody.id) sectionBody.id = `nav-drawer-section-panel-${index + 1}`
      header.setAttribute('aria-controls', sectionBody.id)
      header.setAttribute('aria-expanded', 'false')
      sectionBody.setAttribute('aria-hidden', 'true')
      sectionBody.setAttribute('inert', '')
    }

    header.addEventListener('click', (e) => {
      const section = header.closest('.nav-drawer-section')
      const body = section.querySelector('.nav-drawer-section__body')
      const image = header.querySelector('.nav-drawer-section__image')

      // If no body or we're on desktop (image is hidden), follow the link
      const href = header.getAttribute('href')
      const isImageHidden = image && window.getComputedStyle(image).display === 'none'

      if (!body || isImageHidden) {
        if (href && href !== '#') {
          window.location.href = href
        }
        return
      }

      // On mobile: handle slide toggle behavior
      e.preventDefault()

      const isOpen = body.classList.contains('open')

      // Collapse all others
      document.querySelectorAll('.nav-drawer-section').forEach((sec) => {
        const bodyEl = sec.querySelector('.nav-drawer-section__body')
        if (!bodyEl) return

        sec.classList.remove('nav-drawer-section--active')
        bodyEl.style.maxHeight = '0px'
        bodyEl.classList.remove('open')
        bodyEl.setAttribute('aria-hidden', 'true')
        bodyEl.setAttribute('inert', '')
        const sectionHeader = sec.querySelector('.nav-drawer-section__header')
        sectionHeader?.setAttribute('aria-expanded', 'false')
      })

      // Expand if not already open
      if (!isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px'
        body.classList.add('open')
        body.setAttribute('aria-hidden', 'false')
        body.removeAttribute('inert')
        header.setAttribute('aria-expanded', 'true')
        section.classList.add('nav-drawer-section--active')
      }
    })
  })

  const header = document.querySelector('.header')
  const navDrawerPrimary = document.querySelector('.nav-drawer--primary')
  const navDrawerBundles = document.querySelector('.nav-drawer--bundles')
  const navDrawerGiftSets = document.querySelector('.nav-drawer--gift-sets')
  const navDrawerBestSellers = document.querySelector('.nav-drawer--best-sellers')
  const navDrawerNewArrivals = document.querySelector('.nav-drawer--new-arrivals')
  const navDrawerBackToSchool = document.querySelector('.nav-drawer--back-to-school')
  const navDrawerBabyStage = document.querySelector('.nav-drawer--baby-stage')

  const megaDrawers = [
    navDrawerPrimary,
    navDrawerBundles,
    navDrawerGiftSets,
    navDrawerBestSellers,
    navDrawerNewArrivals,
    navDrawerBackToSchool,
    navDrawerBabyStage
  ].filter(Boolean)

  const isDesktopNav = () => window.matchMedia('(min-width: 1024px)').matches

  const MEGA_MENU_BOTTOM_BUFFER = 80

  const flyoutSubMenus = document.querySelectorAll('.header-sub-menu')
  const flyoutMenuItems = document.querySelectorAll('.header-menu-item:has(.header-sub-menu)')

  const constrainDropdownHeight = (element) => {
    if (!element || !isDesktopNav()) return
    const top = element.getBoundingClientRect().top
    const available = Math.round(window.innerHeight - top - MEGA_MENU_BOTTOM_BUFFER)
    if (available > 0) {
      element.style.maxHeight = available + 'px'
    }
  }

  // Cap the open drawer panel below the header and leave a strip of page visible so
  // shoppers can click outside to dismiss on short windows.
  const constrainDrawerHeight = (drawer) => {
    if (!drawer || !isDesktopNav()) return
    const box = drawer.querySelector('.nav-drawer__box') || drawer
    constrainDropdownHeight(box)
  }

  const clearDrawerHeights = () => {
    megaDrawers.forEach((drawer) => {
      drawer.style.maxHeight = ''
      const box = drawer.querySelector('.nav-drawer__box')
      if (box) box.style.maxHeight = ''
    })
  }

  const openMegaDrawer = (drawer) => {
    if (!drawer) return
    drawer.classList.add('nav-drawer--active')
    drawer.setAttribute('aria-hidden', 'false')
    drawer.removeAttribute('inert')
    window.requestAnimationFrame(() => {
      constrainDrawerHeight(drawer)
    })
  }

  const constrainFlyoutSubMenuHeight = (subMenu) => {
    constrainDropdownHeight(subMenu)
  }

  const clearFlyoutSubMenuHeights = () => {
    flyoutSubMenus.forEach((subMenu) => {
      subMenu.style.maxHeight = ''
    })
  }

  const dismissFlyoutSubMenus = () => {
    flyoutMenuItems.forEach((item) => {
      item.classList.add('header-menu-item--submenu-dismissed')
      item.classList.remove('header-menu-item--submenu-open')
    })
  }

  const clearFlyoutSubMenuDismissals = () => {
    flyoutMenuItems.forEach((item) => {
      item.classList.remove('header-menu-item--submenu-dismissed')
    })
  }

  const clearFlyoutSubMenuOpens = () => {
    flyoutMenuItems.forEach((item) => {
      item.classList.remove('header-menu-item--submenu-open')
    })
  }

  const constrainActiveDrawer = () => {
    megaDrawers.forEach((drawer) => {
      if (drawer.classList.contains('nav-drawer--active')) {
        constrainDrawerHeight(drawer)
      }
    })

    flyoutSubMenus.forEach((subMenu) => {
      const item = subMenu.closest('.header-menu-item')
      if (item && item.classList.contains('header-menu-item--submenu-open')) {
        constrainFlyoutSubMenuHeight(subMenu)
      }
    })
  }

  const NAV_OPEN_DELAY_MS = 220
  const NAV_OPEN_SWITCH_DELAY_MS = 100
  const NAV_CLOSE_DELAY_MS = 280
  const SHOP_TAB_SWITCH_DELAY_MS = 160

  let drawerOpenTimer = null
  let drawerHideTimer = null
  let shopTabSwitchTimer = null

  const clearDrawerOpenTimer = () => {
    window.clearTimeout(drawerOpenTimer)
    drawerOpenTimer = null
  }

  const clearDrawerHideTimer = () => {
    window.clearTimeout(drawerHideTimer)
    drawerHideTimer = null
  }

  const clearShopTabSwitchTimer = () => {
    window.clearTimeout(shopTabSwitchTimer)
    shopTabSwitchTimer = null
  }

  const hasActiveMegaDrawer = () =>
    megaDrawers.some((drawer) => drawer.classList.contains('nav-drawer--active'))

  const hasOpenFlyoutMenu = () =>
    Array.from(flyoutMenuItems).some((item) =>
      item.classList.contains('header-menu-item--submenu-open')
    )

  const getNavOpenDelay = () =>
    hasActiveMegaDrawer() || hasOpenFlyoutMenu() ? NAV_OPEN_SWITCH_DELAY_MS : NAV_OPEN_DELAY_MS

  // Get nav links
  const allMenuLinks = document.querySelectorAll('.header-menu-link')

  // Utility to deactivate all drawers
  function hideAllDrawers() {
    megaDrawers.forEach((drawer) => {
      drawer.classList.remove('nav-drawer--active')
      drawer.setAttribute('aria-hidden', 'true')
      drawer.setAttribute('inert', '')
    })
    document.querySelectorAll('.header-menu-link[aria-expanded]').forEach((link) => {
      link.setAttribute('aria-expanded', 'false')
    })
    clearDrawerHeights()
    clearFlyoutSubMenuHeights()
  }

  const closeAllDesktopNavDropdowns = () => {
    clearDrawerOpenTimer()
    clearDrawerHideTimer()
    clearShopTabSwitchTimer()
    hideAllDrawers()
    clearFlyoutSubMenuOpens()
    dismissFlyoutSubMenus()
  }

  const activateFlyoutSubMenu = (item, subMenu) => {
    hideAllDrawers()
    flyoutMenuItems.forEach((other) => {
      if (other === item) {
        other.classList.remove('header-menu-item--submenu-dismissed')
        other.classList.add('header-menu-item--submenu-open')
      } else {
        other.classList.add('header-menu-item--submenu-dismissed')
        other.classList.remove('header-menu-item--submenu-open')
      }
    })
    window.requestAnimationFrame(() => {
      constrainFlyoutSubMenuHeight(subMenu)
    })
  }

  const activateMegaDrawerFromLink = (link) => {
    const href = link.getAttribute('href') || ''
    const labelEl = link.querySelector('span')
    const label = (labelEl ? labelEl.textContent : link.textContent).trim().replace(/\u2122/g, '')
    const megaMenu = link.dataset.megaMenu
    const menuItem = link.closest('.header-menu-item')
    const flyoutSubMenu =
      link.nextElementSibling?.classList?.contains('header-sub-menu') ? link.nextElementSibling : null
    const hasFlyoutSubMenu = Boolean(flyoutSubMenu)

    hideAllDrawers()

    const opensMegaDrawer =
      megaMenu === 'shop' ||
      href === '/collections/all-items' ||
      label === 'Shop' ||
      label === 'Bundle' ||
      label === 'Bundles' ||
      (megaMenu === 'bundles' && navDrawerBundles) ||
      (megaMenu === 'gift-sets' && navDrawerGiftSets) ||
      (megaMenu === 'best-sellers' && navDrawerBestSellers) ||
      (megaMenu === 'new-arrivals' && navDrawerNewArrivals) ||
      (megaMenu === 'back-to-school' && navDrawerBackToSchool) ||
      (megaMenu === 'baby-stage' && navDrawerBabyStage) ||
      (label === 'Best Sellers' && navDrawerBestSellers) ||
      (label === 'New Arrivals' && navDrawerNewArrivals) ||
      (label === 'Back To School Sale' && navDrawerBackToSchool) ||
      (label === "By Baby's Stage" && navDrawerBabyStage)

    if (opensMegaDrawer) {
      dismissFlyoutSubMenus()
    } else if (hasFlyoutSubMenu) {
      activateFlyoutSubMenu(menuItem, flyoutSubMenu)
      return
    } else {
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
    }

    if (megaMenu === 'shop' || href === '/collections/all-items' || label === 'Shop') {
      openMegaDrawer(navDrawerPrimary)
    } else if ((megaMenu === 'bundles' || label === 'Bundle' || label === 'Bundles') && navDrawerBundles) {
      openMegaDrawer(navDrawerBundles)
      navDrawerBundles.setAttribute('aria-hidden', 'false')
      link.setAttribute('aria-expanded', 'true')
    } else if (megaMenu === 'gift-sets' && navDrawerGiftSets) {
      openMegaDrawer(navDrawerGiftSets)
      navDrawerGiftSets.setAttribute('aria-hidden', 'false')
      link.setAttribute('aria-expanded', 'true')
    } else if (megaMenu === 'best-sellers' && navDrawerBestSellers) {
      openMegaDrawer(navDrawerBestSellers)
    } else if (megaMenu === 'new-arrivals' && navDrawerNewArrivals) {
      openMegaDrawer(navDrawerNewArrivals)
    } else if (megaMenu === 'back-to-school' && navDrawerBackToSchool) {
      openMegaDrawer(navDrawerBackToSchool)
    } else if (megaMenu === 'baby-stage' && navDrawerBabyStage) {
      openMegaDrawer(navDrawerBabyStage)
    } else if (label === 'Best Sellers' && navDrawerBestSellers) {
      openMegaDrawer(navDrawerBestSellers)
    } else if (label === 'New Arrivals' && navDrawerNewArrivals) {
      openMegaDrawer(navDrawerNewArrivals)
    } else if (label === 'Back To School Sale' && navDrawerBackToSchool) {
      openMegaDrawer(navDrawerBackToSchool)
    } else if (label === "By Baby's Stage" && navDrawerBabyStage) {
      openMegaDrawer(navDrawerBabyStage)
    }
  }

  const scheduleOpenFromLink = (link) => {
    if (!isDesktopNav()) return
    clearDrawerHideTimer()
    clearDrawerOpenTimer()
    const delay = getNavOpenDelay()
    drawerOpenTimer = window.setTimeout(() => {
      drawerOpenTimer = null
      activateMegaDrawerFromLink(link)
    }, delay)
  }

  const openFromKeyboardFocus = (link) => {
    if (!isDesktopNav()) return
    clearDrawerHideTimer()
    clearDrawerOpenTimer()
    activateMegaDrawerFromLink(link)
  }

  const headerMenuLinks = Array.from(allMenuLinks)

  const getNextHeaderLink = (link) => {
    const index = headerMenuLinks.indexOf(link)
    if (index === -1) return null
    return headerMenuLinks[index + 1] || null
  }

  const getDrawerForLink = (link) => {
    if (!link) return null
    const href = link.getAttribute('href') || ''
    const labelEl = link.querySelector('span')
    const label = (labelEl ? labelEl.textContent : link.textContent).trim().replace(/\u2122/g, '')
    const megaMenu = link.dataset.megaMenu

    if (megaMenu === 'shop' || href === '/collections/all-items' || label === 'Shop') {
      return navDrawerPrimary || null
    }
    if ((megaMenu === 'bundles' || label === 'Bundle' || label === 'Bundles') && navDrawerBundles) {
      return navDrawerBundles
    }
    if (megaMenu === 'gift-sets' && navDrawerGiftSets) {
      return navDrawerGiftSets
    }
    if ((megaMenu === 'best-sellers' || label === 'Best Sellers') && navDrawerBestSellers) {
      return navDrawerBestSellers
    }
    if ((megaMenu === 'new-arrivals' || label === 'New Arrivals') && navDrawerNewArrivals) {
      return navDrawerNewArrivals
    }
    if ((megaMenu === 'back-to-school' || label === 'Back To School Sale') && navDrawerBackToSchool) {
      return navDrawerBackToSchool
    }
    if ((megaMenu === 'baby-stage' || label === "By Baby's Stage") && navDrawerBabyStage) {
      return navDrawerBabyStage
    }
    return null
  }

  const getActiveDrawerForLink = (link) => {
    const drawer = getDrawerForLink(link)
    if (!drawer || !drawer.classList.contains('nav-drawer--active')) return null
    return drawer
  }

  const getTriggerForDrawer = (drawer) =>
    headerMenuLinks.find((link) => getDrawerForLink(link) === drawer) || null

  const getDrawerFocusables = (drawer) => {
    const drawerBox = drawer?.querySelector('.nav-drawer__box')
    if (!drawerBox) return []

    const megaRoot =
      drawerBox.querySelector(
        '.shop-mega-menu, .best-sellers-mega-menu, .new-arrivals-mega-menu, .back-to-school-mega-menu, .baby-stage-mega-menu, .nav-drawer-bundles'
      ) || drawerBox

    return Array.from(
      megaRoot.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => {
      if (el.closest('.mobile-nav') || el.closest('.nav-drawer__header')) return false
      if (el.closest('[hidden]')) return false
      const style = window.getComputedStyle(el)
      if (style.display === 'none' || style.visibility === 'hidden') return false
      return el.getClientRects().length > 0
    })
  }

  const getFlyoutFocusables = (subMenu) => {
    if (!subMenu) return []
    return Array.from(
      subMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter((el) => {
      const style = window.getComputedStyle(el)
      if (style.display === 'none' || style.visibility === 'hidden') return false
      return el.getClientRects().length > 0
    })
  }

  const focusFirstMegaMenuItem = (drawer) => {
    const focusables = getDrawerFocusables(drawer)
    if (!focusables.length) return false
    focusables[0].focus()
    return true
  }

  const moveFocusToNextNavItem = (trigger) => {
    closeAllDesktopNavDropdowns()
    const next = getNextHeaderLink(trigger)
    if (next) {
      next.focus()
    } else {
      const searchOrCart = document.querySelector('.header-menu-right a, .header-menu-right button')
      if (searchOrCart) searchOrCart.focus()
    }
  }

  const setupDrawerKeyboard = (drawer) => {
    if (!drawer) return
    const drawerBox = drawer.querySelector('.nav-drawer__box')
    if (!drawerBox) return

    drawerBox.addEventListener('keydown', (e) => {
      if (!isDesktopNav() || !drawer.classList.contains('nav-drawer--active')) return
      if (e.key !== 'Tab' && e.key !== 'Escape' && e.key !== 'Esc') return

      const trigger = getTriggerForDrawer(drawer)
      const focusables = getDrawerFocusables(drawer)
      if (!focusables.length) return

      const first = focusables[0]
      const last = focusables[focusables.length - 1]
      const active = document.activeElement

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault()
        closeAllDesktopNavDropdowns()
        if (trigger) trigger.focus()
        return
      }

      if (e.shiftKey && active === first) {
        e.preventDefault()
        if (trigger) trigger.focus()
        return
      }

      if (!e.shiftKey && active === last) {
        e.preventDefault()
        moveFocusToNextNavItem(trigger)
      }
    })
  }

  megaDrawers.forEach((drawer) => setupDrawerKeyboard(drawer))

  document.querySelectorAll('.header-menu-link--mega-trigger').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        e.preventDefault()
      }
    })
  })

  flyoutMenuItems.forEach((item) => {
    const subMenu = item.querySelector('.header-sub-menu')
    if (!subMenu) return
    const link = item.querySelector('.header-menu-link')

    item.addEventListener('mouseenter', () => {
      if (!isDesktopNav()) return
      clearDrawerHideTimer()
      if (link) {
        scheduleOpenFromLink(link)
      }
    })

    item.addEventListener('mouseleave', () => {
      clearDrawerOpenTimer()
    })

    subMenu.addEventListener('mouseenter', () => {
      clearDrawerHideTimer()
      clearDrawerOpenTimer()
      item.classList.remove('header-menu-item--submenu-dismissed')
      item.classList.add('header-menu-item--submenu-open')
      constrainFlyoutSubMenuHeight(subMenu)
    })

    subMenu.addEventListener('keydown', (e) => {
      if (!isDesktopNav() || e.key !== 'Tab') return

      const focusables = getFlyoutFocusables(subMenu)
      if (!focusables.length) return

      const first = focusables[0]
      const last = focusables[focusables.length - 1]
      const active = document.activeElement

      if (e.shiftKey && active === first) {
        e.preventDefault()
        if (link) link.focus()
        return
      }

      if (!e.shiftKey && active === last) {
        e.preventDefault()
        moveFocusToNextNavItem(link)
      }
    })
  })

  // Show correct drawer on hover intent; open immediately on keyboard focus
  allMenuLinks.forEach((link) => {
    const menuItem = link.closest('.header-menu-item')
    const hasFlyout = menuItem && menuItem.querySelector('.header-sub-menu')

    if (!hasFlyout) {
      link.addEventListener('mouseenter', () => {
        scheduleOpenFromLink(link)
      })

      link.addEventListener('mouseleave', () => {
        clearDrawerOpenTimer()
      })
    }

    link.addEventListener('focus', () => {
      openFromKeyboardFocus(link)
    })

    link.addEventListener('keydown', (e) => {
      if (!isDesktopNav()) return
      if (e.key === ' ' && link.getAttribute('role') === 'button') {
        e.preventDefault()
        activateMegaDrawerFromLink(link)
        return
      }
      if (e.key !== 'ArrowDown') return

      const drawer = getActiveDrawerForLink(link)
      if (drawer && focusFirstMegaMenuItem(drawer)) {
        e.preventDefault()
        return
      }

      const subMenu = menuItem?.querySelector('.header-sub-menu')
      const flyoutFocusables = getFlyoutFocusables(subMenu)
      if (flyoutFocusables.length) {
        e.preventDefault()
        flyoutFocusables[0].focus()
      }
    })
  })

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Tab' || e.shiftKey || !isDesktopNav()) return

      const active = document.activeElement
      if (!(active instanceof HTMLElement) || !active.classList.contains('header-menu-link')) return

      const drawer = getActiveDrawerForLink(active)
      if (drawer && focusFirstMegaMenuItem(drawer)) {
        e.preventDefault()
        return
      }

      const menuItem = active.closest('.header-menu-item')
      const subMenu = menuItem?.querySelector('.header-sub-menu')
      if (
        subMenu &&
        menuItem?.classList.contains('header-menu-item--submenu-open') &&
        !menuItem.classList.contains('header-menu-item--submenu-dismissed')
      ) {
        const flyoutFocusables = getFlyoutFocusables(subMenu)
        if (flyoutFocusables.length) {
          e.preventDefault()
          flyoutFocusables[0].focus()
        }
      }
    },
    true
  )

  document.addEventListener('focusin', (e) => {
    if (!isDesktopNav()) return

    const target = e.target
    if (!(target instanceof Node)) return

    const hasActiveDrawer = megaDrawers.some((drawer) =>
      drawer.classList.contains('nav-drawer--active')
    )
    const hasOpenFlyout = Array.from(flyoutMenuItems).some((item) =>
      item.classList.contains('header-menu-item--submenu-open') || item.contains(document.activeElement)
    )

    if (!hasActiveDrawer && !hasOpenFlyout) return

    const inHeader = header && header.contains(target)
    const inDrawer = megaDrawers.some((drawer) => drawer.contains(target))
    const inFlyout = Array.from(flyoutMenuItems).some((item) => item.contains(target))

    if (!inHeader && !inDrawer && !inFlyout) {
      closeAllDesktopNavDropdowns()
    }
  })

  const shopMegaMenu = document.querySelector('.shop-mega-menu')
  if (shopMegaMenu) {
    const shopMegaTabs = shopMegaMenu.querySelectorAll('.shop-mega-menu__tab')
    const shopMegaPanels = shopMegaMenu.querySelectorAll('.shop-mega-menu__panel')

    const activateShopMegaPanel = (tab) => {
      const panelId = tab.dataset.shopMegaTab
      if (!panelId) return

      shopMegaTabs.forEach((t) => {
        t.classList.remove('is-active')
        t.setAttribute('aria-selected', 'false')
        t.setAttribute('tabindex', '-1')
      })

      shopMegaPanels.forEach((panel) => {
        panel.classList.remove('is-active')
        panel.hidden = true
      })

      tab.classList.add('is-active')
      tab.setAttribute('aria-selected', 'true')
      tab.setAttribute('tabindex', '0')

      const panel = shopMegaMenu.querySelector('#' + CSS.escape(panelId))
      if (panel) {
        panel.classList.add('is-active')
        panel.hidden = false
      }
    }

    shopMegaTabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => {
        clearShopTabSwitchTimer()
        shopTabSwitchTimer = window.setTimeout(() => {
          shopTabSwitchTimer = null
          activateShopMegaPanel(tab)
        }, SHOP_TAB_SWITCH_DELAY_MS)
      })

      tab.addEventListener('mouseleave', () => {
        clearShopTabSwitchTimer()
      })

      tab.addEventListener('focus', () => {
        clearShopTabSwitchTimer()
        activateShopMegaPanel(tab)
      })

      tab.addEventListener('click', (e) => {
        e.preventDefault()
        clearShopTabSwitchTimer()
        activateShopMegaPanel(tab)
      })

      tab.addEventListener('keydown', (e) => {
        const tabs = Array.from(shopMegaTabs)
        const currentIndex = tabs.indexOf(tab)
        let nextIndex = currentIndex

        if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length
        else if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
        else if (e.key === 'Home') nextIndex = 0
        else if (e.key === 'End') nextIndex = tabs.length - 1
        else return

        e.preventDefault()
        activateShopMegaPanel(tabs[nextIndex])
        tabs[nextIndex].focus()
      })
    })
  }

  // Delay hide so the pointer can cross the gap between the nav bar and mega menu
  const scheduleHideDrawers = () => {
    clearDrawerHideTimer()
    clearDrawerOpenTimer()
    drawerHideTimer = window.setTimeout(() => {
      drawerHideTimer = null
      const overHeader = header && header.matches(':hover')
      const overPrimary = navDrawerPrimary && navDrawerPrimary.matches(':hover')
      const overBundles = navDrawerBundles && navDrawerBundles.matches(':hover')
      const overGiftSets = navDrawerGiftSets && navDrawerGiftSets.matches(':hover')
      const overBestSellers = navDrawerBestSellers && navDrawerBestSellers.matches(':hover')
      const overNewArrivals = navDrawerNewArrivals && navDrawerNewArrivals.matches(':hover')
      const overBackToSchool = navDrawerBackToSchool && navDrawerBackToSchool.matches(':hover')
      const overBabyStage = navDrawerBabyStage && navDrawerBabyStage.matches(':hover')
      const overFlyout = Array.from(flyoutMenuItems).some((item) => item.matches(':hover'))

      if (
        !overHeader &&
        !overPrimary &&
        !overBundles &&
        !overGiftSets &&
        !overBestSellers &&
        !overNewArrivals &&
        !overBackToSchool &&
        !overBabyStage &&
        !overFlyout
      ) {
        hideAllDrawers()
        clearFlyoutSubMenuOpens()
        clearFlyoutSubMenuDismissals()
      }
    }, NAV_CLOSE_DELAY_MS)
  }

  const drawerHoverRoots = [
    header,
    ...megaDrawers,
    ...Array.from(document.querySelectorAll('.nav-drawer__box'))
  ].filter(Boolean)

  drawerHoverRoots.forEach((root) => {
    root.addEventListener('mouseenter', clearDrawerHideTimer)
    root.addEventListener('mouseleave', scheduleHideDrawers)
  })

  if (navDrawerPrimary) {
    navDrawerPrimary.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerPrimary)
    })
  }

  if (navDrawerBundles) {
    navDrawerBundles.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerBundles)
      navDrawerBundles.setAttribute('aria-hidden', 'false')
      const bundlesTrigger = document.querySelector(
        '.header-menu-link[aria-controls="nav-drawer-bundles"], .header-menu-link[data-mega-menu="bundles"]'
      )
      bundlesTrigger?.setAttribute('aria-expanded', 'true')
    })
  }

  if (navDrawerGiftSets) {
    navDrawerGiftSets.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerGiftSets)
      navDrawerGiftSets.setAttribute('aria-hidden', 'false')
      const giftSetsTrigger = document.querySelector(
        '.header-menu-link[aria-controls="nav-drawer-gift-sets"], .header-menu-link[data-mega-menu="gift-sets"]'
      )
      giftSetsTrigger?.setAttribute('aria-expanded', 'true')
    })
  }

  if (navDrawerBestSellers) {
    navDrawerBestSellers.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerBestSellers)
    })
  }

  if (navDrawerNewArrivals) {
    navDrawerNewArrivals.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerNewArrivals)
    })
  }

  if (navDrawerBackToSchool) {
    navDrawerBackToSchool.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerBackToSchool)
    })
  }

  if (navDrawerBabyStage) {
    navDrawerBabyStage.addEventListener('mouseenter', () => {
      clearDrawerOpenTimer()
      clearDrawerHideTimer()
      hideAllDrawers()
      clearFlyoutSubMenuOpens()
      dismissFlyoutSubMenus()
      openMegaDrawer(navDrawerBabyStage)
    })
  }

  // Close any open mega menu with the Escape key so a tall dropdown can never
  // trap the shopper on short windows.
  document.addEventListener('keydown', (e) => {
    if (!isDesktopNav()) return
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeAllDesktopNavDropdowns()
    }
  })

  // Close when clicking the page outside the header and mega menu panels.
  document.addEventListener('click', (e) => {
    if (!isDesktopNav()) return

    const hasActiveDrawer = megaDrawers.some((drawer) =>
      drawer.classList.contains('nav-drawer--active')
    )
    const hasOpenFlyout = Array.from(flyoutMenuItems).some((item) =>
      item.classList.contains('header-menu-item--submenu-open')
    )

    if (!hasActiveDrawer && !hasOpenFlyout) return

    const inHeader = header && header.contains(e.target)
    const inDrawer = megaDrawers.some((drawer) => drawer.contains(e.target))

    if (!inHeader && !inDrawer) {
      closeAllDesktopNavDropdowns()
    }
  })

  // Keep the open drawer within the viewport when the window is resized.
  window.addEventListener('resize', () => {
    if (isDesktopNav()) {
      constrainActiveDrawer()
    } else {
      clearDrawerHeights()
      clearFlyoutSubMenuHeights()
      clearFlyoutSubMenuOpens()
      clearFlyoutSubMenuDismissals()
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slider"] && !Shopify.designMode) return;
  try {
    
  ;(function heroBannerSyncViewportFill() {
    const hero = document.querySelector('.hero-banner-slider')
    if (!hero) return

    const setTopOffset = () => {
      const top = hero.getBoundingClientRect().top + window.scrollY
      hero.style.setProperty('--hero-top-offset', `${Math.round(top)}px`)
    }

    setTopOffset()
    requestAnimationFrame(() => requestAnimationFrame(setTopOffset))
    window.addEventListener('load', setTopOffset)

    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(setTopOffset, 100)
    })
    document.addEventListener('shopify:section:load', setTopOffset)
  })()

  ;(function () {
  const root = document.querySelector('.hero-banner-slider .embla');
  if (!root) return;

  const viewport = root.querySelector('.embla__viewport');
  if (!viewport) return;

  // Create autoplay plugin separately so we can reset it
  const autoplay = EmblaCarouselAutoplay();

  const embla = EmblaCarousel(viewport, { loop: true }, [
    autoplay,
    EmblaCarouselFade(),
  ]);

  const prev = root.querySelector('.embla__prev');
  const next = root.querySelector('.embla__next');
  const playPause = root.querySelector('.embla__playpause');
  const mobileOverlay = root.querySelector('.hero-banner-slider__mobile-image-overlay');

  const positionMobileNav = () => {
    if (!mobileOverlay) return;

    if (window.innerWidth >= 768) {
      mobileOverlay.style.removeProperty('--hero-mobile-image-height');
      mobileOverlay.style.removeProperty('height');
      viewport.style.removeProperty('height');
      return;
    }

    const slide = embla.slideNodes()[embla.selectedScrollSnap()];
    const image = slide?.querySelector('.hero-banner-slider-slide__image');
    if (!slide || !image) return;

    const slideHeight = Math.round(slide.offsetHeight);
    const imageHeight = Math.round(image.getBoundingClientRect().height);

    viewport.style.height = `${slideHeight}px`;
    mobileOverlay.style.setProperty('--hero-mobile-image-height', `${imageHeight}px`);
    mobileOverlay.style.height = `${imageHeight}px`;
  };

  const scheduleMobileNavPosition = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(positionMobileNav);
    });
  };

  if (playPause) {
    playPause.addEventListener('click', () => {
      const isPlaying = playPause.getAttribute('data-playing') === 'true';
      if (isPlaying) {
        autoplay.stop();
        playPause.setAttribute('data-playing', 'false');
        playPause.setAttribute('aria-label', 'Play slideshow');
      } else {
        autoplay.play();
        playPause.setAttribute('data-playing', 'true');
        playPause.setAttribute('aria-label', 'Pause slideshow');
      }
    });
  }

  prev?.addEventListener('click', () => {
    embla.scrollPrev();
    autoplay.reset();
  });

  next?.addEventListener('click', () => {
    embla.scrollNext();
    autoplay.reset();
  });

  const setArrowState = () => {
    if (!prev || !next) return;
    prev.disabled = !embla.canScrollPrev();
    next.disabled = !embla.canScrollNext();
  };

  const dotsWrap = root.querySelector('.embla__dots');

  const buildDots = () => {
    if (!dotsWrap) return;
    const slideCount = embla.slideNodes().length;

    dotsWrap.innerHTML = Array.from({ length: slideCount }, (_item, index) => {
      const isFirst = index === 0;
      const ariaSelected = isFirst ? 'true' : 'false';
      const tabIndex = isFirst ? '0' : '-1';

      return `
        <button
          class="embla__dot"
          type="button"
          role="tab"
          id="embla-tab-${index}"
          aria-controls="embla-panel-${index}"
          aria-label="Go to slide ${index + 1}"
          aria-selected="${ariaSelected}"
          tabindex="${tabIndex}"
        >
          <span class="embla__dot-inner" aria-hidden="true"></span>
        </button>
      `;
    }).join('');

    dotsWrap.querySelectorAll('.embla__dot').forEach((dot, i) =>
      dot.addEventListener('click', () => {
        embla.scrollTo(i);
        autoplay.reset();
      })
    );
  };

  const selectDot = () => {
    if (!dotsWrap) return;
    const selectedIndex = embla.selectedScrollSnap();
    dotsWrap.querySelectorAll('.embla__dot').forEach((dot, index) => {
      const isSelected = index === selectedIndex;
      dot.classList.toggle('is-selected', isSelected);
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      dot.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  };

  const refresh = () => {
    buildDots();
    setArrowState();
    selectDot();
    scheduleMobileNavPosition();
  };

  embla
    .on('init', refresh)
    .on('reInit', refresh)
    .on('select', () => {
      setArrowState();
      selectDot();
      scheduleMobileNavPosition();
    });

  let navPositionTimer;
  window.addEventListener('resize', () => {
    clearTimeout(navPositionTimer);
    navPositionTimer = setTimeout(scheduleMobileNavPosition, 100);
  });
  window.addEventListener('load', scheduleMobileNavPosition);
  document.addEventListener('shopify:section:load', scheduleMobileNavPosition);

  if (window.ResizeObserver) {
    const navPositionObserver = new ResizeObserver(scheduleMobileNavPosition);
    navPositionObserver.observe(viewport);

    embla.slideNodes().forEach((slide) => {
      navPositionObserver.observe(slide);
      const image = slide.querySelector('.hero-banner-slider-slide__image');
      if (image) navPositionObserver.observe(image);
    });
  }

  viewport.querySelectorAll('.hero-banner-slider-slide__image img').forEach((img) => {
    if (!img.complete) {
      img.addEventListener('load', scheduleMobileNavPosition, { once: true });
    }
  });

  scheduleMobileNavPosition();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-numbered-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHomeNumberedFaqs(root) {
      if (!root || root.dataset.homeFaqsBound === '1') return;
      root.dataset.homeFaqsBound = '1';
      const singleOpen = root.getAttribute('data-single-open') === 'true';

      function setOpen(item, open) {
        const trigger = item.querySelector('[data-home-faq-trigger]');
        const panel = item.querySelector('.home-numbered-faqs__panel');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          panel.removeAttribute('hidden');
          item.classList.add('home-numbered-faqs__item--open');
        } else {
          panel.setAttribute('hidden', '');
          item.classList.remove('home-numbered-faqs__item--open');
        }
      }

      root.querySelectorAll('[data-home-faq-item]').forEach((item) => {
        const trigger = item.querySelector('[data-home-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          const isOpen = item.classList.contains('home-numbered-faqs__item--open');
          if (singleOpen) {
            root.querySelectorAll('[data-home-faq-item]').forEach((other) => {
              setOpen(other, false);
            });
          }
          setOpen(item, !isOpen);
        });
      });
    }

    document.querySelectorAll('[data-home-faqs-root]').forEach(initHomeNumberedFaqs);
    document.addEventListener('shopify:section:load', function (ev) {
      const root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-home-faqs-root]');
      if (root) initHomeNumberedFaqs(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  // Debounce helper
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // --- Quantity Selectors (debounced, by item key) ---
  document.querySelectorAll('.new-cart-item:not([data-free-gift])').forEach((itemEl) => {
    const key = itemEl.dataset.key;
    const input = itemEl.querySelector('.new-cart-quantity__value');
    const btnUp = itemEl.querySelector('.new-cart-quantity__up');
    const btnDown = itemEl.querySelector('.new-cart-quantity__down');

    if (!key || !input || !btnUp || !btnDown) return;

    const updateQty = debounce(async (newQty) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: newQty,
          }),
        });

        if (!res.ok) throw new Error('Cart update failed');

        const cart = await res.json();
        if (newQty === 0 && cart.item_count === 0) {
          wunderkindSDK('emptyCart', {});
        }

        location.reload(); // reload after final update
      } catch (err) {
        console.error('Error updating quantity:', err);
      }
    }, 400); // wait 400ms after last click

    btnUp.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1;
      input.value = currentQty + 1;
      updateQty(parseInt(input.value, 10));
    });

    btnDown.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1;
      const newQty = Math.max(0, currentQty - 1);
      input.value = newQty;
      updateQty(newQty);
    });
  });

  // Remove items
  document.querySelectorAll('.new-cart-item__remove').forEach((el) => {
    el.addEventListener('click', (e) => {
      const cartEl = document.querySelector('.new-cart');
      const itemCount = parseInt(cartEl?.dataset.itemCount, 10);
      const href = el.getAttribute('href');

      if (itemCount === 1 && href) {
        e.preventDefault();
        wunderkindSDK('emptyCart', {});
        setTimeout(() => {
          window.location.href = href;
        }, 500);
      }
    });
  });

  // --- Giftwrap quantity controls (local only, no AJAX) ---
  document.querySelectorAll('.new-cart-wrap').forEach((wrap) => {
    const input = wrap.querySelector('.new-cart-quantity__value');
    const up = wrap.querySelector('.new-cart-quantity__up');
    const down = wrap.querySelector('.new-cart-quantity__down');
    if (!input || !up || !down) return;

    up.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
    });
    down.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, current - 1);
    });
  });

  // --- Free gift selector (BOGOS slider in accordion) ---
  let freeGiftSliderMounted = false;

  function findBogosGiftSliderRoot() {
    return document.querySelector(
      '.shopify-app-block[id*="bogos_io_free_gift_gift_slider"], ' +
        '.shopify-app-block[id*="gift_slider_view"], ' +
        '#shopify-section-1783055088b10cdf0b .shopify-app-block'
    );
  }

  function triggerBogosGiftRefresh() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('bogos:cart-change', { detail: cart }));
        document.dispatchEvent(new CustomEvent('bogos:fetch-cart', { detail: cart }));
        document.dispatchEvent(new CustomEvent('bogos:gifts', { detail: cart }));
      })
      .catch(() => {});
  }

  function refreshBogosGiftSliderLayout() {
    window.dispatchEvent(new Event('resize'));

    document.querySelectorAll('.main-cart-free-gift__mount .glider').forEach((gliderEl) => {
      if (gliderEl._glider?.refresh) {
        gliderEl._glider.refresh(true);
      }
    });
  }

  function suppressBogosGiftSliderUnlessOpen() {
    const freeGiftAccordion = document.querySelector('.new-cart-free-gift');
    const isOpen = freeGiftAccordion?.classList.contains('is-open');
    const mount = document.getElementById('main-cart-bogos-gift-mount');

    document.getElementById('shopify-section-1783055088b10cdf0b')?.style.setProperty('display', 'none', 'important');

    document.querySelectorAll('.slide-container').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });

    document.querySelectorAll('#freegifts-main-page-container').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });

    document.querySelectorAll('.shopify-app-block[id*="gift_slider"]').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });
  }

  function mountBogosGiftSlider(forceRefresh = false) {
    const mount = document.getElementById('main-cart-bogos-gift-mount');
    if (!mount) return;

    const sliderHost = mount.querySelector('.main-cart-free-gift__slider-host');
    const bogosRoot = findBogosGiftSliderRoot();

    if (bogosRoot && !mount.contains(bogosRoot)) {
      if (sliderHost) {
        sliderHost.appendChild(bogosRoot);
      } else {
        mount.appendChild(bogosRoot);
      }
    }

    document.querySelectorAll('#freegifts-main-page-container').forEach((sliderContainer) => {
      if (sliderContainer === sliderHost || mount.contains(sliderContainer)) return;

      const target = sliderHost || mount;
      while (sliderContainer.firstChild) {
        target.appendChild(sliderContainer.firstChild);
      }
      sliderContainer.remove();
    });

    const bogosSection = document.getElementById('shopify-section-1783055088b10cdf0b');
    if (bogosSection && !bogosSection.contains(mount) && !bogosSection.querySelector('.shopify-app-block, .slide-container')) {
      bogosSection.hidden = true;
    }

    if (forceRefresh || !freeGiftSliderMounted) {
      triggerBogosGiftRefresh();
      requestAnimationFrame(() => {
        refreshBogosGiftSliderLayout();
        setTimeout(refreshBogosGiftSliderLayout, 100);
        setTimeout(refreshBogosGiftSliderLayout, 400);
      });
      freeGiftSliderMounted = true;
    }

    suppressBogosGiftSliderUnlessOpen();
  }

  suppressBogosGiftSliderUnlessOpen();

  const bogosVisibilityObserver = new MutationObserver(() => {
    suppressBogosGiftSliderUnlessOpen();
  });
  bogosVisibilityObserver.observe(document.body, { childList: true, subtree: true });

  function cartIsFreeGiftLine(item) {
    if (!item) return false;
    const props = item.properties || {};
    if (Object.keys(props).some((key) => key.toLowerCase().includes('bogos'))) return true;
    const giftHandles = ['the-letter-teether', 'the-teether'];
    if (giftHandles.includes(item.handle) && item.final_line_price === 0) return true;
    const title = `${item.product_title || ''} ${item.title || ''}`.toLowerCase();
    return title.includes('100% off');
  }

  function cartHasFreeGift(cart) {
    return cart.items.some((item) => cartIsFreeGiftLine(item));
  }

  async function enforceFreeGiftQuantity() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const overflow = cart.items.filter((item) => cartIsFreeGiftLine(item) && item.quantity > 1);
      if (!overflow.length) return;

      const updates = {};
      overflow.forEach((item) => {
        updates[item.key] = 1;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      location.reload();
    } catch (err) {
      console.error('Failed to enforce free gift quantity', err);
    }
  }

  function applyFreeGiftQuantityUI() {
    document.querySelectorAll('.new-cart-item:not([data-free-gift])').forEach((row) => {
      const title = (row.querySelector('.new-cart__subheading')?.textContent || '').toLowerCase();
      const priceEl = row.querySelector('.new-cart-item__price');
      const priceText = (priceEl?.textContent || '').trim().toLowerCase();
      const isZeroPrice = priceText === '$0' || priceText === 'free' || priceText === '0';
      const isGiftLine = title.includes('100% off');

      if (!isGiftLine || !isZeroPrice) return;

      row.setAttribute('data-free-gift', '');
      row.classList.add('new-cart-item--free-gift');

      const qty = row.querySelector('.new-cart-quantity:not(.new-cart-quantity--disabled)');
      if (qty) {
        const disabled = qty.cloneNode(true);
        disabled.classList.add('new-cart-quantity--disabled');
        disabled.setAttribute('aria-label', 'Quantity: 1, fixed for free gift');
        disabled.setAttribute('title', 'Quantity is fixed for this free gift');
        const down = disabled.querySelector('.new-cart-quantity__down');
        const up = disabled.querySelector('.new-cart-quantity__up');
        const input = disabled.querySelector('.new-cart-quantity__value');
        if (down) {
          down.disabled = true;
          down.setAttribute('aria-disabled', 'true');
          down.setAttribute('aria-label', 'Decrease quantity (not available for free gifts)');
        }
        if (up) {
          up.disabled = true;
          up.setAttribute('aria-disabled', 'true');
          up.setAttribute('aria-label', 'Increase quantity (not available for free gifts)');
        }
        if (input) {
          input.value = '1';
          input.setAttribute('tabindex', '-1');
        }
        qty.replaceWith(disabled);
      }

      const topLeft = row.querySelector('.new-cart-item__main-top-left');
      if (topLeft && !topLeft.querySelector('.new-cart-item__free-gift-label')) {
        const label = document.createElement('p');
        label.className = 'new-cart-item__free-gift-label';
        label.textContent = 'Free Gift';
        topLeft.appendChild(label);
      }
    });
  }

  enforceFreeGiftQuantity();
  applyFreeGiftQuantityUI();

  document.addEventListener('fg-gifts:updated', async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cartHasFreeGift(cart)) {
        document.getElementById('main-cart-free-gift')?.remove();
      }
      applyFreeGiftQuantityUI();
    } catch (err) {
      console.error('Failed to refresh free gift selector state', err);
    }
  });

  // --- Accordions ---
  const accordions = document.querySelectorAll('.new-cart-accordion');
  accordions.forEach((accordion) => {
    const header = accordion.querySelector('.new-cart-accordion__header');
    const body = accordion.querySelector('.new-cart-accordion__body');
    const isDefaultOpen = accordion.classList.contains('is-default-open');
    const isFreeGift = accordion.hasAttribute('data-free-gift-selector');
    if (isDefaultOpen) {
      if (isFreeGift) {
        mountBogosGiftSlider(true);
        body.style.maxHeight = 'none';
        body.style.overflow = 'visible';
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.style.overflow = 'hidden';
      }
    }

    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('is-open') || isDefaultOpen ? 'true' : 'false');

    header.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        accordion.classList.remove('is-open');
        body.style.maxHeight = null;
        if (isFreeGift) body.style.overflow = '';
        if (isFreeGift) suppressBogosGiftSliderUnlessOpen();
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('is-open');
        if (isFreeGift) {
          mountBogosGiftSlider(true);
          body.style.maxHeight = 'none';
          body.style.overflow = 'visible';
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
        header.setAttribute('aria-expanded', 'true');
      }
    });

    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // --- Gift message save ---
  const giftTextarea = document.querySelector('#giftmessage');
  const giftAccordion = giftTextarea?.closest('.new-cart-accordion');
  if (giftTextarea) {
    if (giftTextarea.value.trim().length > 0 && giftAccordion) {
      giftAccordion.classList.add('is-open');
      const body = giftAccordion.querySelector('.new-cart-accordion__body');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
    }
    let typingTimeout;
    giftTextarea.addEventListener('input', () => {
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(async () => {
        const note = giftTextarea.value.trim();
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note }),
          });
          if (!res.ok) throw new Error('Failed to save gift message');
          console.log('Gift message saved:', note);
        } catch (err) {
          console.error('Error saving gift message:', err);
        }
      }, 600);
    });
  }

  // --- Discount codes ---
  const form = document.querySelector('.new-cart-discounts__form');
  const input = document.querySelector('.new-cart-discounts__input');
  const discountList = document.querySelector('.new-cart-discounts__codes');
  const errorEl = document.querySelector('.new-cart-discounts__error');

  if (form && input) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      errorEl.textContent = '';
      errorEl.classList.remove('new-cart-discounts__error--active');

      const newCode = input.value.trim();
      if (!newCode) {
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Please enter a discount code.';
        return;
      }
      const existingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name')).map((el) =>
        el.textContent.trim()
      );
      if (existingCodes.includes(newCode)) {
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'That code is already applied.';
        return;
      }
      const allCodes = [...existingCodes, newCode].join(',');
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes }),
        });
        if (!res.ok) throw new Error('Failed to apply code');
        const json = await res.json();
        const applied = json.discount_codes?.find(
          (d) => d.code?.toUpperCase() === newCode.toUpperCase() && d.applicable
        );
        if (!applied) {
          errorEl.classList.add('new-cart-discounts__error--active');
          errorEl.textContent = 'Invalid or expired discount code.';
          return;
        }
        location.reload();
      } catch (err) {
        console.error(err);
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Something went wrong. Please try again.';
      }
    });
  }

  // --- Remove discount codes ---
  document.querySelectorAll('.new-cart-code__remove').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const discountList = document.querySelector('.new-cart-discounts__codes');
      const codeToRemove = btn.closest('.new-cart-code').querySelector('.new-cart-code__name').textContent.trim();
      const remainingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name'))
        .map((el) => el.textContent.trim())
        .filter((code) => code !== codeToRemove);
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });
        if (!res.ok) throw new Error('Failed to remove code');
        location.reload();
      } catch (err) {
        console.error(err);
        const errorEl = document.querySelector('.new-cart-discounts__error');
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Error removing discount code. Please try again.';
      }
    });
  });

  // --- Embroidery quantity sync ---
  // The $12 add-on is a separate line item, so its quantity must always equal the
  // total quantity of line items carrying embroidery properties. Reconciling against
  // the server cart keeps the two in sync no matter how the cart was changed.
  const EMBROIDERY_VARIANT_ID = 40890756530242;
  const EMBROIDERY_RECONCILE_FLAG = 'tbEmbroideryReconciled';

  async function reconcileEmbroideryQuantity() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());

      let requiredQty = 0;
      let currentQty = 0;

      cart.items.forEach((item) => {
        if (item.id === EMBROIDERY_VARIANT_ID) {
          currentQty += item.quantity;
        } else if (item.properties && item.properties['Embroidery font']) {
          requiredQty += item.quantity;
        }
      });

      if (requiredQty === currentQty) {
        sessionStorage.removeItem(EMBROIDERY_RECONCILE_FLAG);
        return;
      }

      // Reload at most once per mismatch so a rejected update can never loop.
      if (sessionStorage.getItem(EMBROIDERY_RECONCILE_FLAG)) return;

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [EMBROIDERY_VARIANT_ID]: requiredQty } }),
      });

      if (!res.ok) throw new Error('Cart update failed');

      sessionStorage.setItem(EMBROIDERY_RECONCILE_FLAG, '1');
      location.reload();
    } catch (err) {
      console.error('Error reconciling embroidery quantity:', err);
    }
  }

  reconcileEmbroideryQuantity();

  // --- Pairings variant logic (same as Ajax cart) ---
  document.querySelectorAll('.new-cart-pair').forEach((pair) => {
    const select = pair.querySelector('.new-cart-pair__select');
    const img = pair.querySelector('.new-cart-pair__img');
    const priceEl = pair.querySelector('.new-cart-pair__price');
    const addBtn = pair.querySelector('.new-cart-pair__add');

    // Store product JSON for variant info
    const productHandle = pair.querySelector('a')?.getAttribute('href')?.split('/products/')[1];
    if (!select || !img || !priceEl || !productHandle) return;

    // Fetch full product JSON (Shopify exposes this)
    fetch(`/products/${productHandle}.js`)
      .then((res) => res.json())
      .then((product) => {
        select.addEventListener('change', (e) => {
          const variantId = parseInt(e.target.value, 10);
          const variant = product.variants.find((v) => v.id === variantId);
          if (!variant) return;

          // Update image
          if (variant.featured_image) {
            img.src = variant.featured_image.src + '&width=500';
          } else if (product.featured_image) {
            img.src = product.featured_image + '&width=500';
          }

          // Update price
          priceEl.textContent = Shopify.formatMoney(variant.price, Shopify.money_format).replace('.00', '');

          // Update availability
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Unavailable';
          }
        });
      })
      .catch((err) => console.error('Error loading product JSON:', err));
  });

  // Bogos booster position
  try {
    Shopify.scaHandleConfigValue = {
      bogos_progressing_bar_query: '.main-cart-gift-progress',
      bogos_custom_progress_position: 'in', //before/in/after,
    };
  } catch (err) {}

  (function setupBundleParentCheckoutScrub() {
    const checkoutForm = document.querySelector('form[action="/cart"]');
    if (!checkoutForm || typeof window.tbRemoveBlockedBundleParents !== 'function') return;

    let preparing = false;
    checkoutForm.addEventListener('submit', async function (event) {
      if (event.submitter && event.submitter.name !== 'checkout') return;
      if (preparing) return;
      event.preventDefault();
      preparing = true;
      try {
        await window.tbRemoveBlockedBundleParents();
        checkoutForm.requestSubmit(event.submitter || checkoutForm.querySelector('[name="checkout"]'));
      } catch (e) {
        checkoutForm.requestSubmit(event.submitter || checkoutForm.querySelector('[name="checkout"]'));
      } finally {
        preparing = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
        handleAttributes: [
          { 'aria-label': 'Minimum price' },
          { 'aria-label': 'Maximum price' },
        ],
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      const setFiltersOpen = (isOpen, returnFocus = false) => {
        filtersSidebar.classList.toggle('main-collection-sidebar--active', isOpen)
        filtersToggle.setAttribute('aria-expanded', String(isOpen))
        if (isMobile()) {
          filtersSidebar.setAttribute('aria-hidden', String(!isOpen))
          filtersSidebar.toggleAttribute('inert', !isOpen)
        } else {
          filtersSidebar.removeAttribute('aria-hidden')
          filtersSidebar.removeAttribute('inert')
        }
        if (isOpen) {
          filtersClose.focus()
        } else if (returnFocus) {
          filtersToggle.focus()
        }
      }

      const syncFiltersForViewport = () => {
        if (isMobile()) {
          const isOpen = filtersSidebar.classList.contains('main-collection-sidebar--active')
          filtersSidebar.setAttribute('aria-hidden', String(!isOpen))
          filtersSidebar.toggleAttribute('inert', !isOpen)
          filtersToggle.setAttribute('aria-expanded', String(isOpen))
        } else {
          filtersSidebar.removeAttribute('aria-hidden')
          filtersSidebar.removeAttribute('inert')
          filtersToggle.setAttribute('aria-expanded', 'false')
        }
      }

      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        setFiltersOpen(!filtersSidebar.classList.contains('main-collection-sidebar--active'))
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        setFiltersOpen(false, true)
      })

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isMobile() && filtersSidebar.classList.contains('main-collection-sidebar--active')) {
          setFiltersOpen(false, true)
        }
      })

      window.addEventListener('resize', syncFiltersForViewport)
      syncFiltersForViewport()
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
        header.setAttribute('aria-expanded', String(isActive))
        body.setAttribute('aria-hidden', String(!isActive))
        body.toggleAttribute('inert', !isActive)
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-instructions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.instructions-video').forEach((card) => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.instructions-video__play');
      if (!video || !playBtn) return;

      const startPlayback = () => {
        video.setAttribute('controls', 'controls');
        playBtn.style.display = 'none';
        video.setAttribute('playsinline', '');
        video.play().catch(() => {
          video.setAttribute('controls', 'controls');
        });
      };

      playBtn.addEventListener('click', startPlayback);
      video.addEventListener('click', () => {
        if (video.paused) {
          startPlayback();
        }
      });

      const resetOverlay = () => {
        if (video.ended || video.paused) {
          video.removeAttribute('controls');
          playBtn.style.display = 'flex';
        }
      };
      video.addEventListener('ended', resetOverlay);
      video.addEventListener('pause', resetOverlay);
    });

    const searchInput = document.getElementById('instructions-search');
    const grid = document.getElementById('instructions-videos-grid');
    const noResults = document.getElementById('instructions-no-results');
    const categoryLinks = document.querySelectorAll('.instructions__categories a');

    if (!searchInput || !grid) return;

    const filterVideos = () => {
      const query = searchInput.value.trim().toLowerCase();
      let visibleCount = 0;
      let currentCategory = '';

      grid.querySelectorAll(':scope > h2, :scope > .instructions-video').forEach((el) => {
        if (el.matches('h2')) {
          currentCategory = el.dataset.instructionsCategory?.toLowerCase() || el.textContent.trim().toLowerCase();
          return;
        }

        const name = el.dataset.instructionsVideoName?.toLowerCase() || '';
        const matches =
          !query || name.includes(query) || (currentCategory && currentCategory.includes(query));

        el.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      const headings = [...grid.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        const nextHeading = headings[index + 1];
        const videos = [];
        let node = heading.nextElementSibling;

        while (node && node !== nextHeading) {
          if (node.classList.contains('instructions-video')) {
            videos.push(node);
          }
          node = node.nextElementSibling;
        }

        const hasVisible = videos.some((video) => !video.hidden);
        heading.hidden = !hasVisible;
      });

      categoryLinks.forEach((link) => {
        const id = link.getAttribute('href')?.slice(1);
        const heading = id ? document.getElementById(id) : null;
        const listItem = link.closest('li');
        if (listItem) {
          listItem.hidden = heading ? heading.hidden : false;
        }
      });

      if (noResults) {
        noResults.hidden = !query || visibleCount > 0;
      }
    };

    searchInput.addEventListener('input', filterVideos);
    searchInput.addEventListener('search', filterVideos);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.main-product-bundles');
    if (!root) return;

    // Wunderkind – Bundle "collection" view
    try {
      const bundleRoot = document.querySelector('[data-bundle-collection-ids]');
      if (bundleRoot && window.wunderkindSDK) {
        const ids = bundleRoot.getAttribute('data-bundle-collection-ids').split(',').filter(Boolean);

        if (ids.length) {
          wunderkindSDK('viewCategory', {
            'items:ids': ids,
            'page:url': window.location.href,
          });
        }
      }
    } catch (err) {
      console.warn('[wunderkind] bundle viewCategory failed', err);
    }

    // Bundles
    const moneyFormat = root.getAttribute('data-money-format');
    const moneyFormatExample = root.getAttribute('data-money-format-example');

    function closeAllSelects() {
      document
        .querySelectorAll('.main-product-bundles-select')
        .forEach((sel) => sel.classList.remove('main-product-bundles-select--active'));
    }

    function recalcBundleTotals() {
      const selectedEls = document.querySelectorAll('.main-product-bundles-select__selected');
      const addBtn = document.querySelector('.main-product-bundles__add');
      const preorderNoticeEl = document.querySelector('.main-product-bundles__preorder-notice');
      const preorderNoticeTextEl = preorderNoticeEl?.querySelector('p');
      if (!selectedEls.length || !addBtn) return;

      const discountPercent = Number(addBtn.dataset.discountPercent || 0) / 100;
      let originalTotal = 0;
      let bundleAvailable = true;
      let bundleHasPreorder = false;
      let firstPreorderNotice = '';

      selectedEls.forEach((selected) => {
        const productData = JSON.parse(selected.dataset.product);
        const variantId = Number(selected.dataset.variantId);
        const variant = productData.variants.find((v) => v.id === variantId);
        if (!variant) return;

        originalTotal += variant.price;

        const preorderIds = (selected.dataset.preorderVariants || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
        const isPreorder = preorderIds.includes(String(variantId));

        if (!variant.available && !isPreorder) {
          bundleAvailable = false;
        }

        if (isPreorder) {
          bundleHasPreorder = true;

          if (!firstPreorderNotice) {
            const selectedPreorderBadge = selected.querySelector('.main-product-bundles-select__preorder');
            firstPreorderNotice = selectedPreorderBadge?.getAttribute('data-preorder-notice') || '';
          }
        }
      });

      const discountedTotal = Math.round(originalTotal * (1 - discountPercent));

      addBtn.querySelector('.main-product-bundles__add-price').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        discountedTotal,
        true
      );

      addBtn.querySelector('.main-product-bundles__add-compare').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        originalTotal,
        true
      );

      // 🔥 FORCE state every time
      addBtn.disabled = !bundleAvailable;
      addBtn.setAttribute('aria-disabled', String(!bundleAvailable));

      addBtn.querySelector('.main-product-bundles__add-text').textContent = bundleAvailable
        ? bundleHasPreorder
          ? 'Pre-Order Now'
          : 'Add to Cart'
        : 'Sold Out';

      if (preorderNoticeEl && preorderNoticeTextEl) {
        if (bundleHasPreorder && firstPreorderNotice) {
          preorderNoticeTextEl.textContent = firstPreorderNotice;
          preorderNoticeEl.classList.add('main-product-bundles__preorder-notice--active');
        } else {
          preorderNoticeTextEl.textContent = '';
          preorderNoticeEl.classList.remove('main-product-bundles__preorder-notice--active');
        }
      }
    }

    function readLowMap(productId) {
      const el = document.getElementById(`product-inventory-${productId}`);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (e) {
        console.warn('Invalid JSON in product-inventory-', productId, e);
        return null;
      }
    }

    function syncLowBadge(selectEl) {
      const productRow = selectEl.closest('.main-product-bundles__product');
      if (!productRow) return;

      const productId = productRow.dataset.productId;
      const badge = productRow.querySelector('.main-product-bundles__product-low');
      if (!productId || !badge) return;

      const selected = selectEl.querySelector('.main-product-bundles-select__selected');
      const variantId = selected?.dataset?.variantId;
      if (!variantId) return;

      const lowMap = readLowMap(productId);
      if (!lowMap) return;

      // Your JSON is keyed by strings: "123": true/false
      const isLow = Boolean(lowMap[String(variantId)]);
      badge.classList.toggle('main-product-bundles__product-low--active', isLow);
    }

    const selects = document.querySelectorAll('.main-product-bundles-select');
    if (!selects.length) return;

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.main-product-bundles-select')) closeAllSelects();
    });

    selects.forEach((select) => {
      const selected = select.querySelector('.main-product-bundles-select__selected');
      const options = select.querySelectorAll(
        '.main-product-bundles-select__options .main-product-bundles-select__option'
      );

      if (!selected || !options.length) return;

      selected.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = select.classList.contains('main-product-bundles-select--active');
        closeAllSelects();
        if (!isOpen) select.classList.add('main-product-bundles-select--active');
      });

      options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();

          const variantId = option.dataset.variantId;
          if (!variantId) return;

          // Checked state
          options.forEach((o) => o.classList.remove('main-product-bundles-select__option--checked'));
          option.classList.add('main-product-bundles-select__option--checked');

          // Update variant id
          selected.dataset.variantId = variantId;

          // Update title
          const nextTitle = option.querySelector('.main-product-bundles-select__option-title')?.textContent || '';
          const selectedTitleEl = selected.querySelector('.main-product-bundles-select__option-title');
          if (selectedTitleEl) selectedTitleEl.textContent = nextTitle;

          // Update swatch
          const newSwatchImg = option.querySelector('.main-product-bundles-select__option-swatch img');
          const selectedSwatchEl = selected.querySelector('.main-product-bundles-select__option-swatch');
          if (selectedSwatchEl) {
            selectedSwatchEl.innerHTML = newSwatchImg ? newSwatchImg.outerHTML : '';
          }

          // ✅ Update SOLD OUT badge in the selected row
          const productData = JSON.parse(selected.dataset.product);
          const variant = productData.variants.find((v) => v.id === Number(variantId));

          // ✅ Update SOLD OUT badge in the selected row (UI-driven)
          const selectedRow = selected.querySelector('.main-product-bundles-select__option');
          const existingSold = selectedRow?.querySelector('.main-product-bundles-select__sold');

          // Check if the CLICKED OPTION has a sold out badge
          const optionSold = option.querySelector('.main-product-bundles-select__sold');

          if (optionSold) {
            if (!existingSold && selectedRow) {
              const sold = document.createElement('div');
              sold.className = 'main-product-bundles-select__sold';
              sold.textContent = 'Sold Out';
              selectedRow.appendChild(sold);
            }
          } else {
            if (existingSold) existingSold.remove();
          }

          // ✅ Update PREORDER badge in the selected row
          const existingPreorder = selectedRow?.querySelector('.main-product-bundles-select__preorder');
          const optionPreorder = option.querySelector('.main-product-bundles-select__preorder');

          if (optionPreorder) {
            if (!existingPreorder && selectedRow) {
              const preorder = document.createElement('div');
              preorder.className = 'main-product-bundles-select__preorder';
              preorder.textContent = 'Pre-Order';
              preorder.setAttribute(
                'data-preorder-notice',
                optionPreorder.getAttribute('data-preorder-notice') || ''
              );
              selectedRow.appendChild(preorder);
            }
            if (existingPreorder) {
              existingPreorder.setAttribute(
                'data-preorder-notice',
                optionPreorder.getAttribute('data-preorder-notice') || ''
              );
            }
            if (existingSold) existingSold.remove();
          } else if (existingPreorder) {
            existingPreorder.remove();
          }

          // ✅ Sync LITE badge into selected row
          const existingLite = selectedRow?.querySelector('.main-product-bundles-select__lite');
          const optionLite = option.querySelector('.main-product-bundles-select__lite');

          if (optionLite) {
            if (!existingLite && selectedRow) {
              const lite = document.createElement('div');
              lite.className = 'main-product-bundles-select__lite';
              lite.textContent = optionLite.textContent;
              selectedRow.appendChild(lite);
            }
          } else {
            if (existingLite) existingLite.remove();
          }

          // Update mini product image
          const img = option
            .closest('.main-product-bundles__product')
            ?.querySelector('.main-product-bundles__product-image img');

          if (img && variant?.featured_image?.src) {
            img.src = variant.featured_image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/, '$1?width=300');
          }

          recalcBundleTotals();
          syncLowBadge(select);

          select.classList.remove('main-product-bundles-select--active');
        });
      });
    });

    recalcBundleTotals();

    const addBtn = document.querySelector('.main-product-bundles__add');
    if (!addBtn) return;

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;

      const textEl = addBtn.querySelector('.main-product-bundles__add-text');
      const originalText = textEl.textContent;

      addBtn.disabled = true;
      textEl.textContent = 'Adding';

      // --------------------------------------------------
      // 1️⃣ Build cart items + capture bundle variants ONCE
      // --------------------------------------------------
      const items = [];
      const bundleVariants = [];

      document.querySelectorAll('.main-product-bundles-select__selected').forEach((sel) => {
        const variantId = Number(sel.dataset.variantId);
        if (!variantId) return;

        items.push({ id: variantId, quantity: 1 });

        try {
          const productData = JSON.parse(sel.dataset.product);
          const variant = productData.variants.find((v) => v.id === variantId);
          if (variant) {
            bundleVariants.push({ productData, variant });
          }
        } catch (e) {
          console.warn('[bundle] invalid product JSON', e);
        }
      });

      try {
        // --------------------------------------------------
        // 2️⃣ Add all bundle items to cart
        // --------------------------------------------------
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) throw new Error('Cart add failed');

        // --------------------------------------------------
        // 3️⃣ Bundlr ENABLED
        // --------------------------------------------------
        if (window.bndlr?.getCheckoutInfo) {
          window.bndlr.getCheckoutInfo(async ({ code }) => {
            if (code) {
              const newCode = code.trim().toUpperCase();
              const existingCodes = Array.from(document.querySelectorAll('.ac-new-discount-code__name')).map((el) =>
                el.textContent.trim().toUpperCase()
              );

              if (!existingCodes.includes(newCode)) {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    discount: [...existingCodes, newCode].join(','),
                  }),
                });
              }
            }

            await window.acUpdateContent?.();
            window.acOpenCart?.();

            // 🔥 FIRE WUNDERKIND (AFTER EVERYTHING SUCCEEDS)
            if (window.wunderkindSDK) {
              bundleVariants.forEach(({ productData, variant }) => {
                try {
                  wunderkindSDK('addToCart', {
                    'item:id': String(productData.id),
                    'item:itemgroupid': String(productData.id),
                    'item:feedid': String(variant.id),
                    quantity: 1,
                    price: variant.price / 100,
                    currency: Shopify.currency.active,
                  });
                } catch (e) {
                  console.warn('[wunderkind] addToCart failed', e);
                }
              });
            }

            addBtn.disabled = false;
            textEl.textContent = originalText;
          });
        }
        // --------------------------------------------------
        // 4️⃣ Bundlr DISABLED
        // --------------------------------------------------
        else {
          await window.acUpdateContent?.();
          window.acOpenCart?.();

          // 🔥 FIRE WUNDERKIND
          if (window.wunderkindSDK) {
            bundleVariants.forEach(({ productData, variant }) => {
              try {
                wunderkindSDK('addToCart', { 'item:id': `${productData.id}` });
              } catch (e) {
                console.warn('[wunderkind] addToCart failed', e);
              }
            });
          }

          addBtn.disabled = false;
          textEl.textContent = originalText;
        }
      } catch (err) {
        console.error(err);
        await window.acUpdateContent?.();
        window.acOpenCart?.();
        addBtn.disabled = false;
        textEl.textContent = originalText;
      }
    });

    // Embla
    const viewport = root.querySelector('.embla__viewport');
    const thumbs = root.querySelectorAll('.main-product-new-image-thumbnail');
    const dotsContainer = root.querySelector('.embla__dots');
    const prevBtn = root.querySelector('.embla__button--prev');
    const nextBtn = root.querySelector('.embla__button--next');

    if (!viewport) return;

    const embla = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

    // Dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      embla.slideNodes().forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show product image ${i + 1} of ${embla.slideNodes().length}`);
        dot.addEventListener('click', () => embla.scrollTo(i));
        dotsContainer.appendChild(dot);
      });
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollNext();
      });
    }

    function syncUI() {
      const index = embla.selectedScrollSnap();

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.embla__dot').forEach((dot, i) => {
          dot.classList.toggle('is-selected', i === index);
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('main-product-new-image-thumbnail--active', i === index);
      });
    }

    embla.on('select', syncUI);
    syncUI();

    // Thumbnail click
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.emblaIndex);
        if (!isNaN(index)) embla.scrollTo(index);
      });
    });

    // Accordions

    const bundleAccordions = root.querySelectorAll('.main-product-bundles__accordion');

    bundleAccordions.forEach((accordion) => {
      const header = accordion.querySelector('.main-product-bundles__accordion-header');
      const body = accordion.querySelector('.main-product-bundles__accordion-body');

      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isActive = accordion.classList.contains('main-product-bundles__accordion--active');

        // Close all other accordions (optional, matches PDP behavior)
        bundleAccordions.forEach((acc) => {
          acc.classList.remove('main-product-bundles__accordion--active');
          const accBody = acc.querySelector('.main-product-bundles__accordion-body');
          if (accBody) accBody.style.maxHeight = '0';
        });

        // Toggle this accordion
        if (!isActive) {
          accordion.classList.add('main-product-bundles__accordion--active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mystery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.main-product-new');
    if (!root) return;

    /* -----------------------------
     ACCORDIONS
  ------------------------------ */
    const accordions = root.querySelectorAll('.main-product-new-content__accordion');

    accordions.forEach((accordion) => {
      const header = accordion.querySelector('.main-product-new-content__accordion-header');
      const body = accordion.querySelector('.main-product-new-content__accordion-body');
      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

        if (isActive) {
          accordion.classList.remove('main-product-new-content__accordion--active');
          body.style.maxHeight = '0px';
        } else {
          accordion.classList.add('main-product-new-content__accordion--active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    /* -----------------------------
     PRODUCT JSON
  ------------------------------ */
    const productJsonEl = document.getElementById('product-json');
    if (!productJsonEl) return;

    const productData = JSON.parse(productJsonEl.textContent);
    const variants = productData.variants || [];

    /* -----------------------------
     VARIANT → ADD TO CART
     (select OR hidden input)
  ------------------------------ */
    const form = root.querySelector('form[action^="/cart/add"]');
    if (form) {
      const variantInput = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');

      const addButton = form.querySelector('.main-product-new-content__add');

      const updateAddToCartState = (variantId) => {
        const variant = variants.find((v) => String(v.id) === String(variantId));
        if (!variant || !addButton) return;

        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add to Cart';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      };

      if (variantInput) {
        // Init on load
        updateAddToCartState(variantInput.value);

        // Listen only if it's a select
        if (variantInput.tagName === 'SELECT') {
          variantInput.addEventListener('change', (e) => {
            updateAddToCartState(e.target.value);
          });
        }
      }
    }

    /* -----------------------------
     MYSTERY PRODUCT SELECT → REDIRECT
  ------------------------------ */
    const productSelect = root.querySelector('.mystery-option--product select');

    if (productSelect) {
      productSelect.addEventListener('change', (e) => {
        const targetUrl = e.target.value;
        if (!targetUrl) return;

        if (window.location.pathname !== targetUrl) {
          window.location.href = targetUrl;
        }
      });
    }

    /* -----------------------------
     PAIRS WELL WITH
  ------------------------------ */
    const pairingBlocks = root.querySelectorAll('.main-product-new-content__pairing');

    pairingBlocks.forEach((pairingBlock) => {
      const productJson = pairingBlock.dataset.json;
      if (!productJson) return;

      let pairingProduct;
      try {
        pairingProduct = JSON.parse(productJson);
      } catch (e) {
        return;
      }

      const selectEl = pairingBlock.querySelector('select[name="id"]');
      const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
      const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
      const addButton = pairingBlock.querySelector('button[type="submit"]');

      if (!selectEl || !priceEl || !addButton) return;

      const formatMoney = (cents) => {
        return (cents / 100).toFixed(2).replace('.00', '');
      };

      const updatePairingUI = (variantId) => {
        const variant = pairingProduct.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        // Price
        priceEl.textContent = formatMoney(variant.price);

        // Image
        if (variant.featured_image) {
          imageEl.src = variant.featured_image.src + '&width=130';
          imageEl.alt = variant.featured_image.alt || pairingProduct.title;
        } else if (pairingProduct.featured_image) {
          imageEl.src = pairingProduct.featured_image.src + '&width=130';
          imageEl.alt = pairingProduct.title;
        }

        // Button
        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      };

      // Init
      updatePairingUI(selectEl.value);

      // On change
      selectEl.addEventListener('change', (e) => {
        updatePairingUI(e.target.value);
      });
    });

    /* -----------------------------
 VARIANT → PRICE UPDATE (GLOBAL FORMATTER)
------------------------------ */

    const priceEl = root.querySelector('.main-product-new-content__price');
    const compareEl = root.querySelector('.main-product-new-content__compare');
    const variantSelect = root.querySelector('select[name="id"]');

    const moneyFormat = root.getAttribute('data-money-format');
    const moneyFormatExample = root.getAttribute('data-money-format-example');

    const updatePriceUI = (variantId) => {
      const variant = variants.find((v) => String(v.id) === String(variantId));
      if (!variant || !priceEl) return;

      // Price
      priceEl.textContent = window.formatMoneyLatest(moneyFormat, moneyFormatExample, variant.price);

      // Compare-at
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = window.formatMoneyLatest(moneyFormat, moneyFormatExample, variant.compare_at_price);

        priceEl.classList.add('main-product-new-content__price--active');
        compareEl.classList.add('main-product-new-content__compare--active');
      } else {
        compareEl.textContent = '';
        priceEl.classList.remove('main-product-new-content__price--active');
        compareEl.classList.remove('main-product-new-content__compare--active');
      }
    };

    // Init on load
    if (variantSelect) {
      updatePriceUI(variantSelect.value);

      variantSelect.addEventListener('change', (e) => {
        updatePriceUI(e.target.value);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new-ab-test"] && !Shopify.designMode) return;
  try {
    
  // State
  let emblaInstance = null;

  // Elements
  const rootEl = document.querySelector('.main-product-new');
  const idControl = rootEl.querySelector('[name="id"]');

  const allEmblaWrappers = rootEl.querySelectorAll('.embla-wrapper');
  const swatchInputs = rootEl.querySelectorAll('.swatch__input');
  const price = rootEl.querySelector('.main-product-new-content__price');
  const compare = rootEl.querySelector('.main-product-new-content__compare');
  const selectedOptionLabels = rootEl.querySelectorAll('.main-product-new-content__option-label-selection');
  const add = rootEl.querySelector('.main-product-new-content__add');
  const quantityInput = rootEl.querySelector('.main-product-new-content__quantity-input');
  const quantityMinus = rootEl.querySelector('.main-product-new-content__quantity-btn--minus');
  const quantityPlus = rootEl.querySelector('.main-product-new-content__quantity-btn--plus');
  const pairingBlocks = document.querySelectorAll('.main-product-new-content__pairing');
  const accordions = document.querySelectorAll('.main-product-new-content__accordion');
  const allPrevBtns = document.querySelectorAll('.embla__button--prev');
  const allNextBtns = document.querySelectorAll('.embla__button--next');
  // Disabled: Tushbaby Lite tooltip (markup is commented out in the Color option legend)
  // const tushbabyTooltip = rootEl.querySelector('.tushbaby-lite-tooltip');

  // Data
  const productJsonString = document.querySelector('#product-json').textContent;
  const productData = JSON.parse(productJsonString);
  const productInventoryJsonString = document.querySelector('#product-inventory').textContent;
  const productInventoryJson = JSON.parse(productInventoryJsonString);
  const variantPreorderMapString = document.querySelector('#variant-preorder-map').textContent;
  const variantPreorderMap = JSON.parse(variantPreorderMapString);
  const hiddenVariantIds = JSON.parse(document.querySelector('#hidden-variant-ids')?.textContent || '[]');
  const hiddenVariantIdSet = new Set(hiddenVariantIds.map(String));
  const ginghamHoodConfig = JSON.parse(document.querySelector('#gingham-hood-variants')?.textContent || 'null');

  function getGinghamOptionKey() {
    if (!ginghamHoodConfig?.optionPosition) return 'option1';
    return `option${ginghamHoodConfig.optionPosition}`;
  }

  function getVariantGinghamValue(variant) {
    if (!variant || !ginghamHoodConfig) return null;
    return variant[getGinghamOptionKey()];
  }

  function isGinghamFamilyVariant(variant) {
    const val = getVariantGinghamValue(variant);
    return val === 'Gingham' || val === 'SSGingham';
  }

  function isGinghamHoodOptionRow(optionIndex) {
    if (!ginghamHoodConfig) return false;
    return Number(optionIndex) + 1 === Number(ginghamHoodConfig.optionPosition);
  }

  function getPairedGinghamVariant(variant) {
    if (!ginghamHoodConfig || !variant) return null;

    const position = Number(ginghamHoodConfig.optionPosition);
    const optionKey = `option${position}`;
    if (variant[optionKey] !== 'SSGingham') return null;

    return (
      allVariantData.find((candidate) => {
        if (candidate[optionKey] !== 'Gingham') return false;

        for (let i = 1; i <= 3; i++) {
          if (i === position) continue;
          const optionValue = variant[`option${i}`];
          if (optionValue != null && optionValue !== '' && candidate[`option${i}`] !== optionValue) {
            return false;
          }
        }

        return true;
      }) || null
    );
  }

  function getImageVariant(variant) {
    if (ginghamHoodConfig?.useOwnVariantImages) {
      return variant;
    }

    return getPairedGinghamVariant(variant) || variant;
  }

  function getImageVariantId(variant) {
    return String(getImageVariant(variant).id);
  }

  const allVariantData = productData.variants || [];
  const variantData = allVariantData.filter((variant) => !hiddenVariantIdSet.has(String(variant.id)));
  const liftoffV2DisplayHandles = new Set([
    'liftoff-toddler-sling',
    'liftoff-and-pack',
    'liftoff-and-mini-pack',
    'tushbaby-hip-carrier-and-liftoff-sling',
  ]);

  function formatLiftoffDisplayName(name) {
    if (name == null || name === '') return name;
    if (!liftoffV2DisplayHandles.has(productData.handle)) return name;
    return String(name).replace(/ ?v2/gi, '').trim();
  }
  const moneyFormat = rootEl.getAttribute('data-money-format');
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example');
  const lowInventoryThresholdString = rootEl.getAttribute('data-low-inventory-threshold');
  const lowInventoryThreshold = lowInventoryThresholdString ? Number(lowInventoryThresholdString) : 150;
  const stickyBar = document.querySelector('.sticky-add-to-cart');
  const stickyBarTriggerPoint = 1300;
  const stickyBarSelect = document.querySelector('.sticky-add-to-cart__select');
  const stickySelect = document.querySelector('.sticky-add-to-cart__select');
  const stickyImg = document.querySelector('.sticky-add-to-cart__image img');
  const embroideryColorOptions = rootEl.querySelectorAll('.main-product-new-embroidery__color');
  const embroideryColorMapEl = document.querySelector('#embroidery-thread-colors-by-variant');
  const embroideryColorAvailabilityByVariantId = JSON.parse(embroideryColorMapEl?.textContent || '{}');

  const variantCustomFirstImages = JSON.parse(document.querySelector('#variant-custom-first-images').textContent);
  const variantUvPrintedMap = JSON.parse(document.querySelector('#variant-uv-printed-map')?.textContent || '{}');
  const embroideryToggleLabel = rootEl.querySelector('.main-product-new-embroidery-toggle__checkbox-label');
  const EMBROIDERY_TOGGLE_LABEL_DEFAULT = 'Add a name or monogram (+$12)';
  const EMBROIDERY_TOGGLE_LABEL_UV_PRINTED = 'Personalize with Premium UV Printing';

  function updateEmbroideryToggleLabel(variantId) {
    if (!embroideryToggleLabel) return;
    const isUvPrinted = Boolean(variantUvPrintedMap[String(variantId)]);
    embroideryToggleLabel.textContent = isUvPrinted
      ? EMBROIDERY_TOGGLE_LABEL_UV_PRINTED
      : EMBROIDERY_TOGGLE_LABEL_DEFAULT;
  }

  const DEFAULT_EMBROIDERY_COLORS = new Set(['black', 'silver', 'gold']);
  const EMBROIDERY_PREVIEW_COLOR_CLASSES = [
    'black',
    'silver',
    'gold',
    'pink',
    'blue',
    'black-solid',
    'silver-solid',
    'gold-solid',
    'pink-solid',
    'blue-solid',
  ];

  function embroideryColorToPreviewClass(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function parseEmbroideryThreadColorList(rawValue) {
    if (rawValue == null || rawValue === '') return null;

    let list = rawValue;
    if (!Array.isArray(list) && typeof list === 'object' && Array.isArray(list.value)) {
      list = list.value;
    }

    const values = Array.isArray(list)
      ? list
      : String(list)
          .split(/[,•|]/)
          .map((value) => value.trim())
          .filter(Boolean);

    return values.length ? values : null;
  }

  function getAllowedEmbroideryColorsForVariant(variantId) {
    const rawValue = embroideryColorAvailabilityByVariantId[String(variantId)];
    const values = parseEmbroideryThreadColorList(rawValue);

    if (!values) return DEFAULT_EMBROIDERY_COLORS;

    return new Set(values.map((value) => String(value).toLowerCase()));
  }

  function updateEmbroideryColorOptions(variantId) {
    if (!embroideryColorOptions.length) return;

    const allowedColors = getAllowedEmbroideryColorsForVariant(variantId);
    let firstVisibleInput = null;
    let hasCheckedVisible = false;

    embroideryColorOptions.forEach((colorOption) => {
      const input = colorOption.querySelector('input');
      if (!input) return;

      const colorName = String(input.value || '').toLowerCase();
      const isVisible = allowedColors.has(colorName);

      colorOption.style.display = isVisible ? '' : 'none';
      input.disabled = !isVisible;

      if (isVisible) {
        if (!firstVisibleInput) firstVisibleInput = input;
        if (input.checked) hasCheckedVisible = true;
      } else if (input.checked) {
        input.checked = false;
      }
    });

    if (!hasCheckedVisible && firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Events
  if (quantityInput && quantityMinus && quantityPlus) {
    quantityMinus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      if (current > 1) {
        quantityInput.value = current - 1;
      }
    });

    quantityPlus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
    });
  }
  swatchInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (input.closest('[data-hood-option]')) return;

      const swatches = input.closest('.main-product-new-content__option-swatches');
      if (!swatches) return;

      const fieldset = swatches.parentElement;
      const legend = swatches.previousElementSibling;
      const label = legend?.querySelector('.main-product-new-content__option-label-selection');
      const optionIndex = swatches.getAttribute('data-option-index');

      if (ginghamHoodConfig && isGinghamHoodOptionRow(optionIndex)) {
        updateHoodOptionVisibility(input.value, { resetHoodDefault: input.value === ginghamHoodConfig.colorValue });
      }

      const matchedVariant = findMatchingVariant();
      console.log('variant changed', matchedVariant);
      if (!matchedVariant) return;

      let labelText = matchedVariant[`option${Number(optionIndex) + 1}`];
      if (ginghamHoodConfig && isGinghamHoodOptionRow(optionIndex) && labelText === 'SSGingham') {
        labelText = ginghamHoodConfig.colorValue;
      }
      if (label) label.textContent = formatLiftoffDisplayName(labelText);

      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  rootEl.querySelectorAll('[data-hood-option] .swatch__input').forEach((input) => {
    input.addEventListener('change', () => {
      const hoodFieldset = input.closest('[data-hood-option]');
      const hoodLabel = hoodFieldset?.querySelector('[data-hood-option-label]');
      if (hoodLabel) {
        hoodLabel.textContent =
          input.value === 'SSGingham' ? 'Gingham with Sunshade' : 'Gingham';
      }

      const matchedVariant = findMatchingVariant();
      if (!matchedVariant) return;

      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant, {
          skipImageUpdate: !ginghamHoodConfig?.useOwnVariantImages,
        });
      }
    });
  });

  // Thumbnail click → scroll Embla and update active state
  document.querySelectorAll('.main-product-new-image-thumbnail').forEach((thumb) => {
    const thumbImage = thumb.querySelector('img');
    const thumbLabel = thumbImage?.getAttribute('alt') || 'View product image';

    if (!thumb.hasAttribute('role')) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', thumbLabel);
    }

    const activateThumbnail = () => {
      const index = parseInt(thumb.getAttribute('data-embla-index'), 10);
      if (emblaInstance && !isNaN(index)) {
        emblaInstance.scrollTo(index);
      }

      const thumbnailGroup = thumb.closest('.main-product-new-image-thumbnails');
      if (!thumbnailGroup) return;

      thumbnailGroup.querySelectorAll('.main-product-new-image-thumbnail').forEach((el) => {
        el.classList.remove('main-product-new-image-thumbnail--active');
      });

      thumb.classList.add('main-product-new-image-thumbnail--active');
    };

    thumb.addEventListener('click', activateThumbnail);
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateThumbnail();
      }
    });
  });

  // Attach arrow event listeners once on page load
  allPrevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollPrev();
    });
  });

  allNextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollNext();
    });
  });

  // Embroidery add-on price (cents) — update here if the embroidery product price changes
  const EMBROIDERY_PRICE_CENTS = 1200;

  function updatePriceWithEmbroidery(variant, isEmbroideryChecked) {
    if (!price || !variant) return;
    const addOn = isEmbroideryChecked ? EMBROIDERY_PRICE_CENTS : 0;
    const displayPrice = variant.price + addOn;
    const displayCompare = (variant.compare_at_price || 0) + addOn;

    price.textContent = formatMoney(moneyFormat, moneyFormatExample, displayPrice);
    compare.textContent = displayCompare > 0 ? formatMoney(moneyFormat, moneyFormatExample, displayCompare) : '';

    if (variant.compare_at_price > variant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

  }

  // Helpers
  function updateActiveThumbnail(variantId) {
    if (!emblaInstance) return;
    const selectedIndex = emblaInstance.selectedScrollSnap();

    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
    if (!activeThumbBlock) return;

    const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
    allThumbs.forEach((thumb, i) => {
      if (i === selectedIndex) {
        thumb.classList.add('main-product-new-image-thumbnail--active');
      } else {
        thumb.classList.remove('main-product-new-image-thumbnail--active');
      }
    });
  }

  function updateStickyCTA(newVariant) {
    const stickyBtn = document.querySelector('.sticky-add-to-cart button[type="submit"]');
    const label = stickyBtn?.querySelector('.sticky-add-to-cart__label');

    if (!stickyBtn || !label) return;

    const isPreorder = isVariantPreorder(newVariant);

    if (!newVariant.available && !isPreorder) {
      stickyBtn.disabled = true;
      label.textContent = 'Sold Out';
      return;
    }

    stickyBtn.disabled = false;

    if (isPreorder) {
      label.textContent = 'Pre-Order Now';
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  function isVariantPreorder(variantOrId) {
    const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
    if (!variantId) return false;
    return Boolean(variantPreorderMap[String(variantId)]);
  }

  function handleVariantChange(newVariant, options = {}) {
    if (!idControl) return;

    const skipImageUpdate = options.skipImageUpdate === true;

    // 🔁 Sync swatch radios to the new variant
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option:not([data-hood-option])');

    const ginghamOptionIndex = ginghamHoodConfig ? Number(ginghamHoodConfig.optionPosition) - 1 : -1;
    const ginghamVal = getVariantGinghamValue(newVariant);

    optionFields.forEach((field, index) => {
      let value = newVariant[`option${index + 1}`];
      if (!value) return;

      if (ginghamHoodConfig && index === ginghamOptionIndex && value === 'SSGingham') {
        value = ginghamHoodConfig.colorValue;
      }

      const radio = field.querySelector(`input[value="${CSS.escape(value)}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
      }

      // Update label text
      const label = field.querySelector('.main-product-new-content__option-label-selection');
      if (label) {
        const nextLabel =
          ginghamHoodConfig && ginghamVal === 'SSGingham' && index === ginghamOptionIndex
            ? ginghamHoodConfig.colorValue
            : newVariant[`option${index + 1}`];
        label.textContent = formatLiftoffDisplayName(nextLabel);
      }
    });

    syncHoodOptionFromVariant(newVariant);

    // Change input value
    idControl.value = newVariant.id;
    updateEmbroideryColorOptions(newVariant.id);

    // Change the url
    setUrlParam('variant', newVariant.id);

    if (!skipImageUpdate) {
      const imageVariantId = getImageVariantId(newVariant);

      // Update the carousel
      initEmblaForVariant(imageVariantId);

      // Update thumbnails
      rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
        thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
      });
      const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${imageVariantId}`);
      if (activeThumbBlock) {
        activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');

        // Set the active slide
        activeThumbBlock.querySelectorAll(`.main-product-new-image-thumbnail`).forEach((el, i) => {
          if (i == 0) {
            el.classList.add('main-product-new-image-thumbnail--active');
          } else {
            el.classList.remove('main-product-new-image-thumbnail--active');
          }
        });
      }
    }

    // Update the price
    if (price) {
      price.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.price);
    }
    if (compare) {
      compare.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.compare_at_price);
    }

    if (price && compare) {
      if (newVariant.compare_at_price > newVariant.price) {
        price.classList.add('main-product-new-content__price--active');
        compare.classList.add('main-product-new-content__compare--active');
      } else {
        price.classList.remove('main-product-new-content__price--active');
        compare.classList.remove('main-product-new-content__compare--active');
      }
    }

    // Update preorder
    const preorderActiveClass = 'main-product-new-content__preorder-notice--active';

    rootEl.querySelectorAll('.main-product-new-content__preorder-notice').forEach((el) => {
      el.classList.remove(preorderActiveClass);
    });

    const preorder = rootEl.querySelector(`.main-product-new-content__preorder-notice--${newVariant.id}`);
    const isPreorder = isVariantPreorder(newVariant);

    if (isPreorder && preorder) {
      preorder.classList.add(preorderActiveClass);
    }

    // Update low inventory
    const lowInventoryEls = rootEl.querySelectorAll('.main-product-new__low-inventory');

    if (lowInventoryEls.length) {
      const manualPreorderAttr = add?.getAttribute('data-manual-preorder') || '';
      const manualPreorderVariantIds = manualPreorderAttr
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      const lowInventoryActiveClass = 'main-product-new__low-inventory--active';
      const variantInventory = productInventoryJson[newVariant.id];
      const isForcePreorder = manualPreorderVariantIds.includes(newVariant.id.toString()) || isPreorder;

      lowInventoryEls.forEach((lowInventoryEl) => {
        if (!isForcePreorder && variantInventory < lowInventoryThreshold && variantInventory > 0) {
          lowInventoryEl.textContent = 'ONLY A FEW LEFT';
          lowInventoryEl.classList.add(lowInventoryActiveClass);
        } else {
          lowInventoryEl.textContent = '';
          lowInventoryEl.classList.remove(lowInventoryActiveClass);
        }
      });
    }

    function updateAccordionContent(type, variantId, defaultClass, accordionSelector) {
      // Remove all active states
      rootEl.querySelectorAll(`.main-product-new-content__${type}`).forEach((el) => {
        el.classList.remove(`main-product-new-content__${type}--active`);
      });

      // Activate variant-specific or fallback
      const variantBlock = document.querySelector(`.main-product-new-content__${type}--${variantId}`);
      if (variantBlock) {
        variantBlock.classList.add(`main-product-new-content__${type}--active`);
      } else {
        const defaultBlock = document.querySelector(`.main-product-new-content__${defaultClass}`);
        if (defaultBlock) defaultBlock.classList.add(`main-product-new-content__${type}--active`);
      }

      // Recalculate accordion height only if open
      const accordion = document.querySelector(accordionSelector);
      if (accordion && accordion.classList.contains('main-product-new-content__accordion--active')) {
        const body = accordion.querySelector('.main-product-new-content__accordion-body');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }

    updateAccordionContent(
      'details',
      newVariant.id,
      'details--default',
      '.main-product-new-content__accordion--details'
    );
    updateAccordionContent(
      'materials',
      newVariant.id,
      'materials--default',
      '.main-product-new-content__accordion--materials'
    );
    updateAccordionContent('safety', newVariant.id, 'safety--default', '.main-product-new-content__accordion--safety');

    updateAccordionContent(
      'description',
      newVariant.id,
      'description--default',
      '.main-product-new-content__accordion--description'
    );

    // Update the add button label/state
    const addLabel = add?.querySelector('.main-product-new-content__add-label');
    if (addLabel) {
      if (isPreorder) {
        addLabel.textContent = 'Pre-Order Now';
        add.disabled = false;
      } else if (newVariant.available) {
        addLabel.textContent = 'Add to Cart';
        add.disabled = false;
      } else {
        addLabel.textContent = 'Sold Out';
        add.disabled = true;
      }
    }

    // Update variant notes
    const noteCls = 'main-product-new-content__variant-note';
    const noteActiveCls = noteCls + '--active';
    const newNote = document.querySelector(`.${noteCls}--${newVariant.id}`);
    const oldNote = document.querySelector(`.${noteActiveCls}`);

    if (oldNote) oldNote.classList.remove(noteActiveCls);
    if (newNote) newNote.classList.add(noteActiveCls);

    // Update the embroidery image
    const embroideryWrapCls = 'main-product-new-embroidery-wrap';
    const embroideryWrap = document.querySelector(`.${embroideryWrapCls}`);

    if (embroideryWrap) {
      const embroideryWrapActiveCls = 'main-product-new-embroidery-wrap--active';
      const baseFabricCls = 'main-product-new-embroidery__fabric';
      const embroideryFabric = rootEl.querySelector(`.${baseFabricCls}--${newVariant.id}`);

      if (embroideryFabric) {
        updateEmbroideryToggleLabel(newVariant.id);

        // Display section
        document.querySelector(`.${embroideryWrapCls}`).classList.add(embroideryWrapActiveCls);

        // Display correct fabric image
        rootEl.querySelectorAll(`.${baseFabricCls}--active`).forEach((el) => {
          el.classList.remove(`${baseFabricCls}--active`);
        });
        embroideryFabric.classList.add(`${baseFabricCls}--active`);
      } else {
        // Hide section
        document.querySelector(`.${embroideryWrapCls}`)?.classList.remove(embroideryWrapActiveCls);
        document.querySelector('.main-product-new-embroidery')?.classList.remove('main-product-new-embroidery--active');

        // Hide embroidery-specific thumbnails
        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        // Untick toggle
        const embroideryCheckbox = document.querySelector('.main-product-new-embroidery-toggle__checkbox');
        if (embroideryCheckbox) embroideryCheckbox.checked = false;

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text')?.removeAttribute('name');
      }
    }

    // Disabled: Tushbaby Lite tooltip toggle. Variant 40092713287746 no longer
    // exists on this product, so the tooltip could never become visible.
    // Update the variant id before re-enabling.
    // if (tushbabyTooltip) {
    //   if (newVariant.id === 40092713287746) {
    //     tushbabyTooltip.classList.add('tushbaby-lite-tooltip--active');
    //   } else {
    //     tushbabyTooltip.classList.remove('tushbaby-lite-tooltip--active');
    //   }
    // }

    // Send variant wunderkind event
    try {
      const variant = findMatchingVariant();

      // wunderkindSDK('viewItem', {
      //   'item:id': `item-${productData.id}`,
      //   'item:itemgroupid': `group-item-${productData.id}`,
      // })

      wunderkindSDK('selectItem', {
        'item:id': `${productData.id}`,
        'item:itemgroupid': `${productData.id}`,
        'item:feedid': `${variant.id}`,
      });
    } catch (err) {
      console.log('Failed to send wunderkind:', err);
    }

    // Sticky bar stuff
    try {
      if (stickySelect && stickySelect.value !== newVariant.id.toString()) {
        stickySelect.value = newVariant.id;
      }

      if (stickyImg && !skipImageUpdate) {
        const imageVariant = getImageVariant(newVariant);
        let imgSrc = null;

        // 1) Variant featured image (Shopify JSON usually gives { src })
        if (imageVariant.featured_image?.src) {
          imgSrc = imageVariant.featured_image.src + '&width=300';
        } else if (typeof imageVariant.featured_image === 'string') {
          imgSrc = imageVariant.featured_image + '&width=300';
        }

        // 2) Fallback: first custom metafield image for that variant (from our JSON map)
        if (!imgSrc) {
          const custom = variantCustomFirstImages?.[imageVariant.id];
          if (custom) imgSrc = custom; // already has width=300
        }

        // 3) Fallback: product featured image
        if (!imgSrc && productData.featured_image) {
          imgSrc = 'https:' + productData.featured_image + '&width=300';
        }

        if (imgSrc) {
          stickyImg.src = imgSrc;
          stickyImg.alt = newVariant.title || productData.title;
        }
      }

      updateStickyCTA(newVariant);
    } catch (err) {}
  }

  function updateMuteButton(video) {
    const button = video.closest('.main-product-new-video')?.querySelector('.main-product-new-video__mute');
    if (!button) return;

    const isMuted = Boolean(video.muted);
    button.classList.toggle('is-muted', isMuted);
    button.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
    button.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  function applyVideoMuteState(video) {
    const preferUnmuted = video.dataset.userUnmuted === 'true';
    video.muted = !preferUnmuted;
    video.defaultMuted = video.muted;
    if (video.muted) {
      video.setAttribute('muted', '');
    } else {
      video.removeAttribute('muted');
    }
    updateMuteButton(video);
  }

  function playProductGalleryVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    applyVideoMuteState(video);

    const tryPlay = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          if (!video.muted) {
            video.dataset.userUnmuted = 'false';
            applyVideoMuteState(video);
            video.play().catch(() => {});
          }
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
      return;
    }

    video.addEventListener('loadeddata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay, { once: true });
    try {
      video.load();
    } catch (err) {}
    tryPlay();
  }

  function pauseProductGalleryVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.autoplay = false;
    video.pause();
    try {
      if (video.readyState >= 1) video.currentTime = 0;
    } catch (err) {}
  }

  function syncProductGalleryVideos(embla) {
    const selectedIndex = embla.selectedScrollSnap();
    embla.slideNodes().forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === selectedIndex) {
        playProductGalleryVideo(video);
      } else {
        pauseProductGalleryVideo(video);
      }
    });
  }

  rootEl.addEventListener('click', (event) => {
    const button = event.target.closest('.main-product-new-video__mute');
    if (!button || !rootEl.contains(button)) return;

    event.preventDefault();
    event.stopPropagation();

    const video = button.closest('.main-product-new-video')?.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    video.dataset.userUnmuted = video.muted ? 'false' : 'true';
    applyVideoMuteState(video);

    if (!video.muted) {
      video.play().catch(() => {
        video.dataset.userUnmuted = 'false';
        applyVideoMuteState(video);
      });
    }
  });

  function initEmblaForVariant(variantId) {
    const targetWrapper = document.querySelector(`.embla-wrapper[data-variant-id="${variantId}"]`);
    if (!targetWrapper) return;

    // Hide all Embla wrappers
    allEmblaWrappers.forEach((wrapper) => {
      wrapper.style.display = wrapper.dataset.variantId === variantId ? 'block' : 'none';
    });

    // Destroy previous instance
    if (emblaInstance) emblaInstance.destroy();

    // Find the correct viewport
    const viewport = targetWrapper.querySelector('.embla__viewport');

    if (viewport) {
      requestAnimationFrame(() => {
        emblaInstance = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

        targetWrapper.querySelectorAll('video').forEach((video) => {
          if (video.dataset.userUnmuted !== 'true') {
            video.muted = true;
            video.defaultMuted = true;
          }
          video.playsInline = true;
          video.preload = 'auto';
          updateMuteButton(video);
        });

        // Setup dots
        const dotsContainer = targetWrapper.querySelector('.embla__dots');
        const slideCount = emblaInstance.slideNodes().length;
        dotsContainer.innerHTML = ''; // Clear previous dots

        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Show product image ${i + 1} of ${slideCount}`);
          dot.addEventListener('click', () => emblaInstance.scrollTo(i));
          dotsContainer.appendChild(dot);
        }

        function updateUI() {
          const selectedIndex = emblaInstance.selectedScrollSnap();

          // Update thumbnails
          const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
          if (activeThumbBlock) {
            const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
            allThumbs.forEach((thumb, i) => {
              thumb.classList.toggle('main-product-new-image-thumbnail--active', i === selectedIndex);
            });
          }

          // Update dots
          const allDots = dotsContainer.querySelectorAll('.embla__dot');
          allDots.forEach((dot, i) => {
            dot.classList.toggle('is-selected', i === selectedIndex);
            if (i === selectedIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          syncProductGalleryVideos(emblaInstance);
        }

        emblaInstance.on('select', updateUI);
        emblaInstance.on('settle', updateUI);
        updateUI();
      });
    }
  }

  function getHoodOptionValue() {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || hoodFieldset.hidden) return null;

    const checked = hoodFieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function updateHoodOptionVisibility(colorValue, options = {}) {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || !ginghamHoodConfig) return;

    const isGingham = colorValue === ginghamHoodConfig.colorValue;
    hoodFieldset.classList.toggle('main-product-new-content__hood-option--visible', isGingham);

    if (isGingham) {
      hoodFieldset.hidden = false;
      hoodFieldset.removeAttribute('hidden');
    } else {
      hoodFieldset.hidden = true;
    }

    if (!isGingham) return;

    if (options.resetHoodDefault) {
      const withHoodRadio = hoodFieldset.querySelector('input[value="Gingham"]');
      const hoodLabel = hoodFieldset.querySelector('[data-hood-option-label]');
      if (withHoodRadio) withHoodRadio.checked = true;
      if (hoodLabel) hoodLabel.textContent = 'Gingham';
    }
  }

  function syncHoodOptionFromVariant(newVariant) {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || !ginghamHoodConfig) return;

    const ginghamVal = getVariantGinghamValue(newVariant);
    const isGinghamFamily = ginghamVal === 'Gingham' || ginghamVal === 'SSGingham';
    updateHoodOptionVisibility(isGinghamFamily ? ginghamHoodConfig.colorValue : ginghamVal);

    if (!isGinghamFamily) return;

    const hoodValue = ginghamVal === 'SSGingham' ? 'SSGingham' : 'Gingham';
    const radio = hoodFieldset.querySelector(`input[value="${CSS.escape(hoodValue)}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
    }

    const hoodLabel = hoodFieldset.querySelector('[data-hood-option-label]');
    if (hoodLabel) {
      hoodLabel.textContent =
        hoodValue === 'SSGingham' ? 'Gingham with Sunshade' : 'Gingham';
    }
  }

  function findMatchingVariant() {
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option:not([data-hood-option])');
    const selectedValues = [];

    optionFields.forEach((field, i) => {
      const checked = field.querySelector('input:checked');
      if (!checked) return;

      let val = checked.value;
      if (ginghamHoodConfig && isGinghamHoodOptionRow(i) && val === ginghamHoodConfig.colorValue) {
        const hoodValue = getHoodOptionValue();
        if (hoodValue === 'SSGingham') {
          val = 'SSGingham';
        }
      }

      selectedValues[i] = val;
    });

    if (selectedValues.length !== optionFields.length || selectedValues.some((val) => val == null)) {
      return null;
    }

    return variantData.find((variant) => {
      return selectedValues.every((val, i) => variant[`option${i + 1}`] === val);
    });
  }

  // Pairings
  pairingBlocks.forEach((pairingBlock) => {
    let productData;
    try {
      productData = JSON.parse(pairingBlock.dataset.json);
    } catch (err) {
      return;
    }

    const selectEl = pairingBlock.querySelector('select[name="id"]');
    const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
    const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
    const addButton = pairingBlock.querySelector('button[type="submit"]');

    const resolvePairingImageSrc = (image) => {
      if (!image) return null;
      const raw = typeof image === 'string' ? image : image.src;
      if (!raw) return null;
      const withProtocol = raw.startsWith('//') ? `https:${raw}` : raw;
      if (withProtocol.includes('width=')) return withProtocol;
      return withProtocol.includes('?') ? `${withProtocol}&width=130` : `${withProtocol}?width=130`;
    };

    const updatePairingUI = (variantId) => {
      const variant = productData.variants.find((v) => v.id == Number(variantId));
      if (!variant) return;

      if (priceEl) {
        priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '');
      }

      if (imageEl) {
        const imgSrc = resolvePairingImageSrc(variant.featured_image) || resolvePairingImageSrc(productData.featured_image);
        if (imgSrc) {
          imageEl.src = imgSrc;
          imageEl.alt =
            (typeof variant.featured_image === 'object' && variant.featured_image?.alt) || productData.title;
        }
      }

      if (addButton) {
        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      }
    };

    // Single-variant pairings use a hidden input, not a select
    if (selectEl) {
      selectEl.addEventListener('change', (e) => {
        updatePairingUI(e.target.value);
      });
    }
  });

  // Accordions
  accordions.forEach((accordion, accordionIndex) => {
    const header = accordion.querySelector('.main-product-new-content__accordion-header');
    const body = accordion.querySelector('.main-product-new-content__accordion-body');
    const heading = header?.querySelector('h3');
    const bodyId = `product-accordion-body-${accordionIndex}`;

    if (!header || !body) return;

    body.id = bodyId;
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('main-product-new-content__accordion--active') ? 'true' : 'false');
    header.setAttribute('aria-controls', bodyId);
    if (heading) header.setAttribute('aria-label', heading.textContent.trim());

    const toggleAccordion = () => {
      const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

      if (isActive) {
        accordion.classList.remove('main-product-new-content__accordion--active');
        body.style.maxHeight = '0';
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('main-product-new-content__accordion--active');
        body.style.maxHeight = body.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }
    };

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
  });

  // Open first accordion on load when setting is enabled
  const accordionsWrapper = document.querySelector(
    '.main-product-new-content__accordions-wrapper[data-open-first-on-load="true"]'
  );
  if (accordionsWrapper) {
    const firstAccordion = accordionsWrapper.querySelector('.main-product-new-content__accordion');
    if (firstAccordion) {
      const body = firstAccordion.querySelector('.main-product-new-content__accordion-body');
      const header = firstAccordion.querySelector('.main-product-new-content__accordion-header');
      firstAccordion.classList.add('main-product-new-content__accordion--active');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
      if (header) header.setAttribute('aria-expanded', 'true');
    }
  }

  // Embroidery
  const embroidery = document.querySelector('.main-product-new-embroidery');

  if (embroidery && idControl) {
    const embroideryActiveCls = 'main-product-new-embroidery--active';
    const embroideryToggle = document.querySelector('#embroidery__checkbox');

    if (embroideryToggle) {
      embroideryToggle.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
          embroidery.classList.add(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'block';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery font]');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery color]');
          });

          document.getElementById('embroidery-text').setAttribute('name', 'properties[Embroidery text]');
        } else {
          embroidery.classList.remove(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'none';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.getElementById('embroidery-text').removeAttribute('name');
        }

        // Update displayed price when checkbox is toggled (+$12 when checked)
        const currentVariant = variantData.find((v) => String(v.id) === String(idControl?.value));
        if (currentVariant) updatePriceWithEmbroidery(currentVariant, isChecked);
      });
    }

    // Thread color
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery color]"]')) {
        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove(...EMBROIDERY_PREVIEW_COLOR_CLASSES);
        preview.classList.add(embroideryColorToPreviewClass(event.target.value));
      }
    });

    // Font
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery font]"]')) {
        const font = event.target.value.toLowerCase().replace(' ', '-');

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('font-helvetica', 'font-athletic-flair', 'font-flair');
        preview.classList.add(`font-${font}`);
      }
    });

    function getEmbroideryCharacterUnits(text) {
      return Array.from(text || '').reduce((total, char) => {
        return total + (/[A-Z]/.test(char) ? 2 : 1);
      }, 0);
    }

    function truncateEmbroideryTextByUnits(text, maxUnits) {
      let units = 0;
      let result = '';

      for (const char of Array.from(text || '')) {
        const charUnits = /[A-Z]/.test(char) ? 2 : 1;
        if (units + charUnits > maxUnits) break;
        result += char;
        units += charUnits;
      }

      return result;
    }

    // Live text
    const embroideryTextInput = document.getElementById('embroidery-text');
    if (embroideryTextInput) {
      embroideryTextInput.addEventListener('input', function (event) {
        const limitedValue = truncateEmbroideryTextByUnits(event.target.value, 10);
        if (event.target.value !== limitedValue) {
          event.target.value = limitedValue;
        }

        const preview = document.getElementById('embroidery-text-preview');
        if (preview) preview.textContent = limitedValue;
        const charCount = getEmbroideryCharacterUnits(limitedValue);
        let fontSize = 70;
        if (charCount > 4) fontSize -= charCount * 2;
        if (preview) preview.style.fontSize = fontSize + 'px';
      });
    }
  }

  // Init on first load
  if (idControl) {
    let initialVariant = allVariantData.find((variant) => String(variant.id) === String(idControl.value));
    const initialWrapper = initialVariant
      ? document.querySelector(`.embla-wrapper[data-variant-id="${initialVariant.id}"]`)
      : null;

    if (
      !initialVariant ||
      hiddenVariantIdSet.has(String(initialVariant.id)) ||
      !initialWrapper
    ) {
      initialVariant = variantData[0] || null;
      if (initialVariant) {
        handleVariantChange(initialVariant);
      }
    } else {
      const imageVariantId = getImageVariantId(initialVariant);
      initEmblaForVariant(imageVariantId);

      rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
        thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
      });
      const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${imageVariantId}`);
      if (activeThumbBlock) {
        activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');
        activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail').forEach((el, i) => {
          el.classList.toggle('main-product-new-image-thumbnail--active', i === 0);
        });
      }

      updateEmbroideryColorOptions(idControl.value);
      syncHoodOptionFromVariant(initialVariant);
    }

    if (!initialVariant && ginghamHoodConfig) {
      const ginghamOptionIndex = Number(ginghamHoodConfig.optionPosition) - 1;
      const colorField = rootEl.querySelector(
        `.main-product-new-content__option[data-option-index="${ginghamOptionIndex}"]`
      );
      const checkedColor = colorField?.querySelector('input:checked');
      if (checkedColor) updateHoodOptionVisibility(checkedColor.value);
    }
  }

  // Wunderkind initial item views
  try {
    wunderkindSDK('item', {
      id: `${productData.id}`,
      copy: productData?.title,
      category: 'Global',
      url: window.location.origin + window.location.pathname,
      imageurl: 'https:' + productData?.featured_image,
      instock: productData?.available ? 'true' : 'false',
    });

    const variant = findMatchingVariant();

    wunderkindSDK('viewItem', {
      'item:id': `${productData.id}`,
      'item:itemgroupid': `${productData.id}`,
    });
  } catch (err) {
    console.log('Failed to send wunderkind:', err);
  }

  // Sticky bar
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY >= stickyBarTriggerPoint) {
        stickyBar.classList.add('sticky-add-to-cart--active');
      } else {
        stickyBar.classList.remove('sticky-add-to-cart--active');
      }
    });
  }

  if (stickyBarSelect) {
    stickyBarSelect.addEventListener('change', (e) => {
      const variantId = Number(e.target.value);
      const variant = variantData.find((v) => v.id === variantId);
      if (variant) handleVariantChange(variant);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"] && !Shopify.designMode) return;
  try {
    
  // State
  let emblaInstance = null;

  // Elements
  const rootEl = document.querySelector('.main-product-new');
  const idControl = rootEl.querySelector('[name="id"]');

  const allEmblaWrappers = rootEl.querySelectorAll('.embla-wrapper');
  const swatchInputs = rootEl.querySelectorAll('.swatch__input');
  const price = rootEl.querySelector('.main-product-new-content__price');
  const compare = rootEl.querySelector('.main-product-new-content__compare');
  const selectedOptionLabels = rootEl.querySelectorAll('.main-product-new-content__option-label-selection');
  const add = rootEl.querySelector('.main-product-new-content__add');
  const pairingBlocks = document.querySelectorAll('.main-product-new-content__pairing');
  const accordions = document.querySelectorAll('.main-product-new-content__accordion');
  const allPrevBtns = document.querySelectorAll('.embla__button--prev');
  const allNextBtns = document.querySelectorAll('.embla__button--next');
  // Disabled: Tushbaby Lite tooltip (markup is commented out in the Color option legend)
  // const tushbabyTooltip = rootEl.querySelector('.tushbaby-lite-tooltip');

  // Data
  const productJsonString = document.querySelector('#product-json').textContent;
  const productData = JSON.parse(productJsonString);
  const productInventoryJsonString = document.querySelector('#product-inventory').textContent;
  const productInventoryJson = JSON.parse(productInventoryJsonString);
  const variantPreorderMapString = document.querySelector('#variant-preorder-map').textContent;
  const variantPreorderMap = JSON.parse(variantPreorderMapString);
  const variantData = productData.variants;
  const moneyFormat = rootEl.getAttribute('data-money-format');
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example');
  const lowInventoryThresholdString = rootEl.getAttribute('data-low-inventory-threshold');
  const lowInventoryThreshold = lowInventoryThresholdString ? Number(lowInventoryThresholdString) : 150;
  const stickyBar = document.querySelector('.sticky-add-to-cart');
  const stickyBarTriggerPoint = 1300;
  const stickyBarSelect = document.querySelector('.sticky-add-to-cart__select');
  const stickySelect = document.querySelector('.sticky-add-to-cart__select');
  const stickyImg = document.querySelector('.sticky-add-to-cart__image img');
  const embroideryColorOptions = rootEl.querySelectorAll('.main-product-new-embroidery__color');
  const embroideryColorMapEl = document.querySelector('#embroidery-thread-colors-by-variant');
  const embroideryColorAvailabilityByVariantId = JSON.parse(embroideryColorMapEl?.textContent || '{}');

  const variantCustomFirstImages = JSON.parse(document.querySelector('#variant-custom-first-images').textContent);
  const variantUvPrintedMap = JSON.parse(document.querySelector('#variant-uv-printed-map')?.textContent || '{}');
  const embroideryToggleLabel = rootEl.querySelector('.main-product-new-embroidery-toggle__checkbox-label');
  const EMBROIDERY_TOGGLE_LABEL_DEFAULT = 'Add a name or monogram (+$12)';
  const EMBROIDERY_TOGGLE_LABEL_UV_PRINTED = 'Personalize with Premium UV Printing';

  function updateEmbroideryToggleLabel(variantId) {
    if (!embroideryToggleLabel) return;
    const isUvPrinted = Boolean(variantUvPrintedMap[String(variantId)]);
    embroideryToggleLabel.textContent = isUvPrinted
      ? EMBROIDERY_TOGGLE_LABEL_UV_PRINTED
      : EMBROIDERY_TOGGLE_LABEL_DEFAULT;
  }

  const DEFAULT_EMBROIDERY_COLORS = new Set(['black', 'silver', 'gold']);
  const EMBROIDERY_PREVIEW_COLOR_CLASSES = [
    'black',
    'silver',
    'gold',
    'pink',
    'blue',
    'black-solid',
    'silver-solid',
    'gold-solid',
    'pink-solid',
    'blue-solid',
  ];

  function embroideryColorToPreviewClass(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function parseEmbroideryThreadColorList(rawValue) {
    if (rawValue == null || rawValue === '') return null;

    let list = rawValue;
    if (!Array.isArray(list) && typeof list === 'object' && Array.isArray(list.value)) {
      list = list.value;
    }

    const values = Array.isArray(list)
      ? list
      : String(list)
          .split(/[,•|]/)
          .map((value) => value.trim())
          .filter(Boolean);

    return values.length ? values : null;
  }

  function getAllowedEmbroideryColorsForVariant(variantId) {
    const rawValue = embroideryColorAvailabilityByVariantId[String(variantId)];
    const values = parseEmbroideryThreadColorList(rawValue);

    if (!values) return DEFAULT_EMBROIDERY_COLORS;

    return new Set(values.map((value) => String(value).toLowerCase()));
  }

  function updateEmbroideryColorOptions(variantId) {
    if (!embroideryColorOptions.length) return;

    const allowedColors = getAllowedEmbroideryColorsForVariant(variantId);
    let firstVisibleInput = null;
    let hasCheckedVisible = false;

    embroideryColorOptions.forEach((colorOption) => {
      const input = colorOption.querySelector('input');
      if (!input) return;

      const colorName = String(input.value || '').toLowerCase();
      const isVisible = allowedColors.has(colorName);

      colorOption.style.display = isVisible ? '' : 'none';
      input.disabled = !isVisible;

      if (isVisible) {
        if (!firstVisibleInput) firstVisibleInput = input;
        if (input.checked) hasCheckedVisible = true;
      } else if (input.checked) {
        input.checked = false;
      }
    });

    if (!hasCheckedVisible && firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Events
  swatchInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const matchedVariant = findMatchingVariant();
      console.log('variant changed', matchedVariant);
      if (!matchedVariant) return;

      const swatches = input.closest('.main-product-new-content__option-swatches');
      const fieldset = swatches.parentElement;
      const legend = swatches.previousElementSibling;
      const label = legend.querySelector('.main-product-new-content__option-label-selection');
      const optionIndex = swatches.getAttribute('data-option-index');

      label.textContent = matchedVariant[`option${Number(optionIndex) + 1}`];
      
      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  // Thumbnail click → scroll Embla and update active state
  document.querySelectorAll('.main-product-new-image-thumbnail').forEach((thumb) => {
    const thumbImage = thumb.querySelector('img');
    const thumbLabel = thumbImage?.getAttribute('alt') || 'View product image';

    if (!thumb.hasAttribute('role')) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', thumbLabel);
    }

    const activateThumbnail = () => {
      const index = parseInt(thumb.getAttribute('data-embla-index'), 10);
      if (emblaInstance && !isNaN(index)) {
        emblaInstance.scrollTo(index);
      }

      const thumbnailGroup = thumb.closest('.main-product-new-image-thumbnails');
      if (!thumbnailGroup) return;

      thumbnailGroup.querySelectorAll('.main-product-new-image-thumbnail').forEach((el) => {
        el.classList.remove('main-product-new-image-thumbnail--active');
      });

      thumb.classList.add('main-product-new-image-thumbnail--active');
    };

    thumb.addEventListener('click', activateThumbnail);
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateThumbnail();
      }
    });
  });

  // Attach arrow event listeners once on page load
  allPrevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollPrev();
    });
  });

  allNextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollNext();
    });
  });

  // Embroidery add-on price (cents) — update here if the embroidery product price changes
  const EMBROIDERY_PRICE_CENTS = 1200;

  function updatePriceWithEmbroidery(variant, isEmbroideryChecked) {
    if (!price || !variant) return;
    const addOn = isEmbroideryChecked ? EMBROIDERY_PRICE_CENTS : 0;
    const displayPrice = variant.price + addOn;
    const displayCompare = (variant.compare_at_price || 0) + addOn;

    price.textContent = formatMoney(moneyFormat, moneyFormatExample, displayPrice);
    compare.textContent = displayCompare > 0 ? formatMoney(moneyFormat, moneyFormatExample, displayCompare) : '';

    if (variant.compare_at_price > variant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

  }

  // Helpers
  function updateActiveThumbnail(variantId) {
    if (!emblaInstance) return;
    const selectedIndex = emblaInstance.selectedScrollSnap();

    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
    if (!activeThumbBlock) return;

    const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
    allThumbs.forEach((thumb, i) => {
      if (i === selectedIndex) {
        thumb.classList.add('main-product-new-image-thumbnail--active');
      } else {
        thumb.classList.remove('main-product-new-image-thumbnail--active');
      }
    });
  }

  function updateStickyCTA(newVariant) {
    const stickyBtn = document.querySelector('.sticky-add-to-cart button[type="submit"]');
    const label = stickyBtn?.querySelector('.sticky-add-to-cart__label');
    if (!stickyBtn || !label) return;

    const isPreorder = isVariantPreorder(newVariant);

    if (!newVariant.available && !isPreorder) {
      stickyBtn.disabled = true;
      label.textContent = 'Sold Out';
      return;
    }

    stickyBtn.disabled = false;

    if (isPreorder) {
      label.textContent = 'Pre-Order Now';
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  function isVariantPreorder(variantOrId) {
    const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
    if (!variantId) return false;
    return Boolean(variantPreorderMap[String(variantId)]);
  }

  function handleVariantChange(newVariant) {
    if (!idControl) return;

    // 🔁 Sync swatch radios to the new variant
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option');

    optionFields.forEach((field, index) => {
      const value = newVariant[`option${index + 1}`];
      if (!value) return;

      const radio = field.querySelector(`input[value="${CSS.escape(value)}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
      }

      // Update label text
      const label = field.querySelector('.main-product-new-content__option-label-selection');
      if (label) label.textContent = value;
    });

    // Change input value
    idControl.value = newVariant.id;
    updateEmbroideryColorOptions(newVariant.id);

    // Change the url
    setUrlParam('variant', newVariant.id);

    // Update the carousel
    initEmblaForVariant(newVariant.id.toString());

    // Update thumbnails
    rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
      thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
    });
    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${newVariant.id}`);
    if (activeThumbBlock) {
      activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');

      // Set the active slide
      activeThumbBlock.querySelectorAll(`.main-product-new-image-thumbnail`).forEach((el, i) => {
        if (i == 0) {
          el.classList.add('main-product-new-image-thumbnail--active');
        } else {
          el.classList.remove('main-product-new-image-thumbnail--active');
        }
      });
    }

    // Update the price
    price.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.price);
    compare.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.compare_at_price);

    if (newVariant.compare_at_price > newVariant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

    // Update preorder
    const preorderActiveClass = 'main-product-new-content__preorder-notice--active';

    rootEl.querySelectorAll('.main-product-new-content__preorder-notice').forEach((el) => {
      el.classList.remove(preorderActiveClass);
    });

    const preorder = rootEl.querySelector(`.main-product-new-content__preorder-notice--${newVariant.id}`);
    const isPreorder = isVariantPreorder(newVariant);

    if (isPreorder && preorder) {
      preorder.classList.add(preorderActiveClass);
    }

    // Update low inventory
    const lowInventoryEls = rootEl.querySelectorAll('.main-product-new__low-inventory');

    if (lowInventoryEls.length) {
      const manualPreorderAttr = add?.getAttribute('data-manual-preorder') || '';
      const manualPreorderVariantIds = manualPreorderAttr
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      const lowInventoryActiveClass = 'main-product-new__low-inventory--active';
      const variantInventory = productInventoryJson[newVariant.id];
      const isForcePreorder = manualPreorderVariantIds.includes(newVariant.id.toString()) || isPreorder;

      lowInventoryEls.forEach((lowInventoryEl) => {
        if (!isForcePreorder && variantInventory < lowInventoryThreshold && variantInventory > 0) {
          lowInventoryEl.textContent = 'ONLY A FEW LEFT';
          lowInventoryEl.classList.add(lowInventoryActiveClass);
        } else {
          lowInventoryEl.textContent = '';
          lowInventoryEl.classList.remove(lowInventoryActiveClass);
        }
      });
    }

    function updateAccordionContent(type, variantId, defaultClass, accordionSelector) {
      // Remove all active states
      rootEl.querySelectorAll(`.main-product-new-content__${type}`).forEach((el) => {
        el.classList.remove(`main-product-new-content__${type}--active`);
      });

      // Activate variant-specific or fallback
      const variantBlock = document.querySelector(`.main-product-new-content__${type}--${variantId}`);
      if (variantBlock) {
        variantBlock.classList.add(`main-product-new-content__${type}--active`);
      } else {
        const defaultBlock = document.querySelector(`.main-product-new-content__${defaultClass}`);
        if (defaultBlock) defaultBlock.classList.add(`main-product-new-content__${type}--active`);
      }

      // Recalculate accordion height only if open
      const accordion = document.querySelector(accordionSelector);
      if (accordion && accordion.classList.contains('main-product-new-content__accordion--active')) {
        const body = accordion.querySelector('.main-product-new-content__accordion-body');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }

    updateAccordionContent(
      'details',
      newVariant.id,
      'details--default',
      '.main-product-new-content__accordion--details'
    );
    updateAccordionContent(
      'materials',
      newVariant.id,
      'materials--default',
      '.main-product-new-content__accordion--materials'
    );
    updateAccordionContent('safety', newVariant.id, 'safety--default', '.main-product-new-content__accordion--safety');

    updateAccordionContent(
      'description',
      newVariant.id,
      'description--default',
      '.main-product-new-content__accordion--description'
    );

    // Update the add button
    if (isPreorder) {
      add.textContent = 'Pre-Order Now';
      add.disabled = false;
    } else if (newVariant.available) {
      add.textContent = 'Add to Cart';
      add.disabled = false;
    } else {
      add.textContent = 'Sold Out';
      add.disabled = true;
    }

    // Update variant notes
    const noteCls = 'main-product-new-content__variant-note';
    const noteActiveCls = noteCls + '--active';
    const newNote = document.querySelector(`.${noteCls}--${newVariant.id}`);
    const oldNote = document.querySelector(`.${noteActiveCls}`);

    if (oldNote) oldNote.classList.remove(noteActiveCls);
    if (newNote) newNote.classList.add(noteActiveCls);

    // Update the embroidery image
    const embroideryWrapCls = 'main-product-new-embroidery-wrap';
    const embroideryWrap = document.querySelector(`.${embroideryWrapCls}`);

    if (embroideryWrap) {
      const embroideryWrapActiveCls = 'main-product-new-embroidery-wrap--active';
      const baseFabricCls = 'main-product-new-embroidery__fabric';
      const embroideryFabric = rootEl.querySelector(`.${baseFabricCls}--${newVariant.id}`);

      if (embroideryFabric) {
        updateEmbroideryToggleLabel(newVariant.id);

        // Display section
        document.querySelector(`.${embroideryWrapCls}`).classList.add(embroideryWrapActiveCls);

        // Display correct fabric image
        rootEl.querySelectorAll(`.${baseFabricCls}--active`).forEach((el) => {
          el.classList.remove(`${baseFabricCls}--active`);
        });
        embroideryFabric.classList.add(`${baseFabricCls}--active`);
      } else {
        // Hide section
        document.querySelector(`.${embroideryWrapCls}`)?.classList.remove(embroideryWrapActiveCls);
        document.querySelector('.main-product-new-embroidery')?.classList.remove('main-product-new-embroidery--active');

        // Hide embroidery-specific thumbnails
        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        // Untick toggle
        const embroideryCheckbox = document.querySelector('.main-product-new-embroidery-toggle__checkbox');
        if (embroideryCheckbox) embroideryCheckbox.checked = false;

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text')?.removeAttribute('name');
      }
    }

    // Disabled: Tushbaby Lite tooltip toggle. Variant 40092713287746 no longer
    // exists on this product, so the tooltip could never become visible.
    // Update the variant id before re-enabling.
    // if (tushbabyTooltip) {
    //   if (newVariant.id === 40092713287746) {
    //     tushbabyTooltip.classList.add('tushbaby-lite-tooltip--active');
    //   } else {
    //     tushbabyTooltip.classList.remove('tushbaby-lite-tooltip--active');
    //   }
    // }

    // Send variant wunderkind event
    try {
      const variant = findMatchingVariant();

      // wunderkindSDK('viewItem', {
      //   'item:id': `item-${productData.id}`,
      //   'item:itemgroupid': `group-item-${productData.id}`,
      // })

      wunderkindSDK('selectItem', {
        'item:id': `${productData.id}`,
        'item:itemgroupid': `${productData.id}`,
        'item:feedid': `${variant.id}`,
      });
    } catch (err) {
      console.log('Failed to send wunderkind:', err);
    }

    // Sticky bar stuff
    try {
      if (stickySelect && stickySelect.value !== newVariant.id.toString()) {
        stickySelect.value = newVariant.id;
      }

      if (stickyImg) {
        let imgSrc = null;

        // 1) Variant featured image (Shopify JSON usually gives { src })
        if (newVariant.featured_image?.src) {
          imgSrc = newVariant.featured_image.src + '&width=300';
        } else if (typeof newVariant.featured_image === 'string') {
          imgSrc = newVariant.featured_image + '&width=300';
        }

        // 2) Fallback: first custom metafield image for that variant (from our JSON map)
        if (!imgSrc) {
          const custom = variantCustomFirstImages?.[newVariant.id];
          if (custom) imgSrc = custom; // already has width=300
        }

        // 3) Fallback: product featured image
        if (!imgSrc && productData.featured_image) {
          imgSrc = 'https:' + productData.featured_image + '&width=300';
        }

        if (imgSrc) {
          stickyImg.src = imgSrc;
          stickyImg.alt = newVariant.title || productData.title;
        }
      }

      updateStickyCTA(newVariant);
    } catch (err) {}
  }

  function updateMuteButton(video) {
    const button = video.closest('.main-product-new-video')?.querySelector('.main-product-new-video__mute');
    if (!button) return;

    const isMuted = Boolean(video.muted);
    button.classList.toggle('is-muted', isMuted);
    button.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
    button.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  function applyVideoMuteState(video) {
    const preferUnmuted = video.dataset.userUnmuted === 'true';
    video.muted = !preferUnmuted;
    video.defaultMuted = video.muted;
    if (video.muted) {
      video.setAttribute('muted', '');
    } else {
      video.removeAttribute('muted');
    }
    updateMuteButton(video);
  }

  function playProductGalleryVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    applyVideoMuteState(video);

    const tryPlay = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          if (!video.muted) {
            video.dataset.userUnmuted = 'false';
            applyVideoMuteState(video);
            video.play().catch(() => {});
          }
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
      return;
    }

    video.addEventListener('loadeddata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay, { once: true });
    try {
      video.load();
    } catch (err) {}
    tryPlay();
  }

  function pauseProductGalleryVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.autoplay = false;
    video.pause();
    try {
      if (video.readyState >= 1) video.currentTime = 0;
    } catch (err) {}
  }

  function syncProductGalleryVideos(embla) {
    const selectedIndex = embla.selectedScrollSnap();
    embla.slideNodes().forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === selectedIndex) {
        playProductGalleryVideo(video);
      } else {
        pauseProductGalleryVideo(video);
      }
    });
  }

  rootEl.addEventListener('click', (event) => {
    const button = event.target.closest('.main-product-new-video__mute');
    if (!button || !rootEl.contains(button)) return;

    event.preventDefault();
    event.stopPropagation();

    const video = button.closest('.main-product-new-video')?.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    video.dataset.userUnmuted = video.muted ? 'false' : 'true';
    applyVideoMuteState(video);

    if (!video.muted) {
      video.play().catch(() => {
        video.dataset.userUnmuted = 'false';
        applyVideoMuteState(video);
      });
    }
  });

  function initEmblaForVariant(variantId) {
    // Hide all Embla wrappers
    allEmblaWrappers.forEach((wrapper) => {
      wrapper.style.display = wrapper.dataset.variantId === variantId ? 'block' : 'none';
    });

    // Destroy previous instance
    if (emblaInstance) emblaInstance.destroy();

    // Find the correct viewport
    const targetWrapper = document.querySelector(`.embla-wrapper[data-variant-id="${variantId}"]`);
    const viewport = targetWrapper.querySelector('.embla__viewport');

    if (viewport) {
      requestAnimationFrame(() => {
        emblaInstance = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

        targetWrapper.querySelectorAll('video').forEach((video) => {
          if (video.dataset.userUnmuted !== 'true') {
            video.muted = true;
            video.defaultMuted = true;
          }
          video.playsInline = true;
          video.preload = 'auto';
          updateMuteButton(video);
        });

        // Setup dots
        const dotsContainer = targetWrapper.querySelector('.embla__dots');
        const slideCount = emblaInstance.slideNodes().length;
        dotsContainer.innerHTML = ''; // Clear previous dots

        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Show product image ${i + 1} of ${slideCount}`);
          dot.addEventListener('click', () => emblaInstance.scrollTo(i));
          dotsContainer.appendChild(dot);
        }

        function updateUI() {
          const selectedIndex = emblaInstance.selectedScrollSnap();

          // Update thumbnails
          const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
          if (activeThumbBlock) {
            const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
            allThumbs.forEach((thumb, i) => {
              thumb.classList.toggle('main-product-new-image-thumbnail--active', i === selectedIndex);
            });
          }

          // Update dots
          const allDots = dotsContainer.querySelectorAll('.embla__dot');
          allDots.forEach((dot, i) => {
            dot.classList.toggle('is-selected', i === selectedIndex);
            if (i === selectedIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          syncProductGalleryVideos(emblaInstance);
        }

        emblaInstance.on('select', updateUI);
        emblaInstance.on('settle', updateUI);
        updateUI();
      });
    }
  }

  function findMatchingVariant() {
    const optionFields = document.querySelectorAll('.main-product-new-content__option');
    const selectedValues = [];

    optionFields.forEach((field, i) => {
      const checked = field.querySelector('input:checked');
      if (checked) selectedValues[i] = checked.value;
    });

    return variantData.find((variant) => {
      return selectedValues.every((val, i) => variant[`option${i + 1}`] === val);
    });
  }

  // Pairings
  pairingBlocks.forEach((pairingBlock) => {
    let productData;
    try {
      productData = JSON.parse(pairingBlock.dataset.json);
    } catch (err) {
      return;
    }

    const selectEl = pairingBlock.querySelector('select[name="id"]');
    const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
    const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
    const addButton = pairingBlock.querySelector('button[type="submit"]');

    const resolvePairingImageSrc = (image) => {
      if (!image) return null;
      const raw = typeof image === 'string' ? image : image.src;
      if (!raw) return null;
      const withProtocol = raw.startsWith('//') ? `https:${raw}` : raw;
      if (withProtocol.includes('width=')) return withProtocol;
      return withProtocol.includes('?') ? `${withProtocol}&width=130` : `${withProtocol}?width=130`;
    };

    const updatePairingUI = (variantId) => {
      const variant = productData.variants.find((v) => v.id == Number(variantId));
      if (!variant) return;

      if (priceEl) {
        priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '');
      }

      if (imageEl) {
        const imgSrc = resolvePairingImageSrc(variant.featured_image) || resolvePairingImageSrc(productData.featured_image);
        if (imgSrc) {
          imageEl.src = imgSrc;
          imageEl.alt =
            (typeof variant.featured_image === 'object' && variant.featured_image?.alt) || productData.title;
        }
      }

      if (addButton) {
        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      }
    };

    // Single-variant pairings use a hidden input, not a select
    if (selectEl) {
      selectEl.addEventListener('change', (e) => {
        updatePairingUI(e.target.value);
      });
    }
  });

  // Accordions
  accordions.forEach((accordion, accordionIndex) => {
    const header = accordion.querySelector('.main-product-new-content__accordion-header');
    const body = accordion.querySelector('.main-product-new-content__accordion-body');
    const heading = header?.querySelector('h3');
    const bodyId = `product-accordion-body-${accordionIndex}`;

    if (!header || !body) return;

    body.id = bodyId;
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('main-product-new-content__accordion--active') ? 'true' : 'false');
    header.setAttribute('aria-controls', bodyId);
    if (heading) header.setAttribute('aria-label', heading.textContent.trim());

    const toggleAccordion = () => {
      const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

      if (isActive) {
        accordion.classList.remove('main-product-new-content__accordion--active');
        body.style.maxHeight = '0';
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('main-product-new-content__accordion--active');
        body.style.maxHeight = body.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }
    };

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
  });

  // Embroidery
  const embroidery = document.querySelector('.main-product-new-embroidery');

  if (embroidery && idControl) {
    const embroideryActiveCls = 'main-product-new-embroidery--active';
    const embroideryToggle = document.querySelector('#embroidery__checkbox');

    if (embroideryToggle) {
      embroideryToggle.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
          embroidery.classList.add(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'block';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery font]');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery color]');
          });

          document.getElementById('embroidery-text').setAttribute('name', 'properties[Embroidery text]');
        } else {
          embroidery.classList.remove(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'none';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.getElementById('embroidery-text').removeAttribute('name');
        }

        // Update displayed price when checkbox is toggled (+$12 when checked)
        const currentVariant = variantData.find((v) => String(v.id) === String(idControl?.value));
        if (currentVariant) updatePriceWithEmbroidery(currentVariant, isChecked);
      });
    }

    // Thread color
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery color]"]')) {
        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove(...EMBROIDERY_PREVIEW_COLOR_CLASSES);
        preview.classList.add(embroideryColorToPreviewClass(event.target.value));
      }
    });

    // Font
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery font]"]')) {
        const font = event.target.value.toLowerCase().replace(' ', '-');

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('font-helvetica', 'font-athletic-flair', 'font-flair');
        preview.classList.add(`font-${font}`);
      }
    });

    function getEmbroideryCharacterUnits(text) {
      return Array.from(text || '').reduce((total, char) => {
        return total + (/[A-Z]/.test(char) ? 2 : 1);
      }, 0);
    }

    function truncateEmbroideryTextByUnits(text, maxUnits) {
      let units = 0;
      let result = '';

      for (const char of Array.from(text || '')) {
        const charUnits = /[A-Z]/.test(char) ? 2 : 1;
        if (units + charUnits > maxUnits) break;
        result += char;
        units += charUnits;
      }

      return result;
    }

    // Live text
    const embroideryTextInput = document.getElementById('embroidery-text');
    if (embroideryTextInput) {
      embroideryTextInput.addEventListener('input', function (event) {
        const limitedValue = truncateEmbroideryTextByUnits(event.target.value, 10);
        if (event.target.value !== limitedValue) {
          event.target.value = limitedValue;
        }

        const preview = document.getElementById('embroidery-text-preview');
        if (preview) preview.textContent = limitedValue;
        const charCount = getEmbroideryCharacterUnits(limitedValue);
        let fontSize = 70;
        if (charCount > 4) fontSize -= charCount * 2;
        if (preview) preview.style.fontSize = fontSize + 'px';
      });
    }
  }

  // Init on first load
  if (idControl) {
    initEmblaForVariant(idControl.value);
    updateEmbroideryColorOptions(idControl.value);
  }

  // Wunderkind initial item views
  try {
    wunderkindSDK('item', {
      id: `${productData.id}`,
      copy: productData?.title,
      category: 'Global',
      url: window.location.origin + window.location.pathname,
      imageurl: 'https:' + productData?.featured_image,
      instock: productData?.available ? 'true' : 'false',
    });

    const variant = findMatchingVariant();

    wunderkindSDK('viewItem', {
      'item:id': `${productData.id}`,
      'item:itemgroupid': `${productData.id}`,
    });
  } catch (err) {
    console.log('Failed to send wunderkind:', err);
  }

  // Sticky bar
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY >= stickyBarTriggerPoint) {
        stickyBar.classList.add('sticky-add-to-cart--active');
      } else {
        stickyBar.classList.remove('sticky-add-to-cart--active');
      }
    });
  }

  if (stickyBarSelect) {
    stickyBarSelect.addEventListener('change', (e) => {
      const variantId = Number(e.target.value);
      const variant = variantData.find((v) => v.id === variantId);
      if (variant) handleVariantChange(variant);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
        handleAttributes: [
          { 'aria-label': 'Minimum price' },
          { 'aria-label': 'Maximum price' },
        ],
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      const setFiltersOpen = (isOpen, returnFocus = false) => {
        filtersSidebar.classList.toggle('main-collection-sidebar--active', isOpen)
        filtersToggle.setAttribute('aria-expanded', String(isOpen))
        if (isMobile()) {
          filtersSidebar.setAttribute('aria-hidden', String(!isOpen))
          filtersSidebar.toggleAttribute('inert', !isOpen)
        } else {
          filtersSidebar.removeAttribute('aria-hidden')
          filtersSidebar.removeAttribute('inert')
        }
        if (isOpen) {
          filtersClose.focus()
        } else if (returnFocus) {
          filtersToggle.focus()
        }
      }

      const syncFiltersForViewport = () => {
        if (isMobile()) {
          const isOpen = filtersSidebar.classList.contains('main-collection-sidebar--active')
          filtersSidebar.setAttribute('aria-hidden', String(!isOpen))
          filtersSidebar.toggleAttribute('inert', !isOpen)
          filtersToggle.setAttribute('aria-expanded', String(isOpen))
        } else {
          filtersSidebar.removeAttribute('aria-hidden')
          filtersSidebar.removeAttribute('inert')
          filtersToggle.setAttribute('aria-expanded', 'false')
        }
      }

      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        setFiltersOpen(!filtersSidebar.classList.contains('main-collection-sidebar--active'))
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        setFiltersOpen(false, true)
      })

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isMobile() && filtersSidebar.classList.contains('main-collection-sidebar--active')) {
          setFiltersOpen(false, true)
        }
      })

      window.addEventListener('resize', syncFiltersForViewport)
      syncFiltersForViewport()
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
        header.setAttribute('aria-expanded', String(isActive))
        body.setAttribute('aria-hidden', String(!isActive))
        body.toggleAttribute('inert', !isActive)
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question');

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header');
    const body = faq.querySelector('.faq-new-question__body');
    const bodyInner = faq.querySelector('.faq-new-question__body-inner');

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active');

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active');
        f.querySelector('.faq-new-question__body').style.maxHeight = '0';
      });

      if (!isActive) {
        faq.classList.add('faq-new-question--active');
        body.style.maxHeight = bodyInner.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-sale-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-also"] && !Shopify.designMode) return;
  try {
    
  (function () {
  const rootEl = document.querySelector('.product-also')
  if (!rootEl) return

  const moneyFormat = rootEl.getAttribute('data-money-format')
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example')

  // Product Also Blocks
  document.querySelectorAll('.product-also-product').forEach((productBlock) => {
    const productData = JSON.parse(productBlock.dataset.json)
    const selectEl = productBlock.querySelector('select[name="id"]')
    const priceEl = productBlock.querySelector('p')
    const imageEl = productBlock.querySelector('img')
    const addButton = productBlock.querySelector('button[type="submit"]')

    const updateProductAlsoUI = (variantId) => {
      const variant = productData.variants.find((v) => {
        return v.id === Number(variantId)
      })
      if (!variant) return

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '')

      // Update image
      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=750'
        imageEl.alt = variant.featured_image.alt || productData.title
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=750'
        imageEl.alt = productData.featured_image.alt || productData.title
      }

      // Update add button
      if (variant.available) {
        addButton.disabled = false
        addButton.textContent = 'Add to Cart'
      } else {
        addButton.disabled = true
        addButton.textContent = 'Sold Out'
      }
    }

    // On select change (single-variant products render a hidden input instead of a select)
    if (selectEl) {
      selectEl.addEventListener('change', (e) => {
        updateProductAlsoUI(e.target.value)
      })
    }
  })
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-picks-for-you"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const FEED_VIEW = 'top-picks';
    const REQUEST_ATTEMPTS = 3;
    const REQUEST_TIMEOUT = 15000;
    const FAILED_CLICKS_BEFORE_FALLBACK_LINK = 2;

    function sleep(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function toPositiveInt(value, fallback) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) && n > 0 ? n : fallback;
    }

    async function requestText(url) {
      let lastError = null;

      for (let attempt = 0; attempt < REQUEST_ATTEMPTS; attempt++) {
        if (attempt > 0) await sleep(250 * attempt * attempt);

        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = controller
          ? setTimeout(function () {
              controller.abort();
            }, REQUEST_TIMEOUT)
          : null;

        try {
          const res = await fetch(url, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller ? controller.signal : undefined,
          });
          if (res.status === 404) return null;
          if (!res.ok) {
            lastError = new Error('HTTP ' + res.status);
            continue;
          }
          return await res.text();
        } catch (err) {
          lastError = err;
        } finally {
          if (timer) clearTimeout(timer);
        }
      }

      console.warn('[top-picks] request failed', url, lastError);
      return null;
    }

    function parseCards(html, containerSelector) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const container = doc.querySelector(containerSelector);
      if (!container) return null;
      return {
        cards: Array.prototype.slice.call(container.querySelectorAll('[data-top-picks-card]')),
        hasNext: container.getAttribute('data-has-next') === 'true',
      };
    }

    function initTopPicksLoadMore(root) {
      if (!root || root.dataset.topPicksLoadMoreInit === '1') return;
      root.dataset.topPicksLoadMoreInit = '1';

      try {
        if (typeof window.initTopPicksCards === 'function') {
          window.initTopPicksCards(root);
        }
      } catch (err) {
        console.error('[top-picks] card init failed', err);
      }

      const grid = root.querySelector('[data-top-picks-grid]');
      let btn = root.querySelector('[data-top-picks-load-more]');
      if (!grid || !btn) return;

      const countEl = root.querySelector('[data-top-picks-count]');
      const progress = root.querySelector('[data-top-picks-progress]');
      const progressWrap = root.querySelector('[data-top-picks-progress-wrap]');
      const loadLabel = root.querySelector('[data-top-picks-load-label]');
      const idleLabel = loadLabel ? loadLabel.textContent.trim() : '';

      const sectionId = root.getAttribute('data-shopify-section-id') || '';
      const perPage = toPositiveInt(root.getAttribute('data-per-page'), 8);
      const total = toPositiveInt(root.getAttribute('data-total'), 0);
      const quickShopLabel = root.getAttribute('data-quick-shop-label') || '';
      const learnMoreLabel = root.getAttribute('data-learn-more-label') || '';
      const viewAllLabel = root.getAttribute('data-view-all-label') || 'View All Products';

      let rootUrl = root.getAttribute('data-root-url') || '/';
      if (rootUrl.slice(-1) !== '/') rootUrl += '/';
      const handle = root.getAttribute('data-collection-handle') || '';
      const collectionUrl =
        root.getAttribute('data-collection-url') || (handle ? rootUrl + 'collections/' + handle : '');

      const claimedHandles = Object.create(null);
      const initialCards = grid.querySelectorAll('[data-top-picks-card]');
      Array.prototype.forEach.call(initialCards, function (card) {
        const key = card.getAttribute('data-product-handle');
        if (key) claimedHandles[key] = true;
      });

      let loaded = initialCards.length;
      let busy = false;
      let exhausted = false;
      let degraded = false;
      let failedClicks = 0;

      // Chosen on the first successful load, then reused so page arithmetic stays consistent.
      let strategy = '';

      let feedPage = 0;
      let feedDone = false;
      const feedQueue = [];

      let sectionPage = 1;

      // Products already rendered or already waiting in the queue, keyed by handle. Position in
      // the feed is never trusted, so a stray ?page= on the host URL cannot cause duplicates.
      function claim(card) {
        const key = card.getAttribute('data-product-handle');
        if (!key) return true;
        if (claimedHandles[key]) return false;
        claimedHandles[key] = true;
        return true;
      }

      function setLoading(isLoading) {
        if (degraded) return;
        btn.disabled = isLoading;
        btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (loadLabel) loadLabel.textContent = isLoading ? 'Loading…' : idleLabel;
      }

      function updateUi() {
        const shown = total > 0 ? Math.min(loaded, total) : loaded;
        if (countEl) countEl.textContent = String(shown);
        if (total > 0) {
          if (progress) progress.style.width = Math.min(100, (loaded / total) * 100) + '%';
          if (progressWrap) progressWrap.setAttribute('aria-valuenow', String(shown));
        }
        if (degraded) return;
        btn.hidden = exhausted || (total > 0 && loaded >= total);
      }

      function applyLabels(card) {
        const quickShop = card.querySelector('[data-frc-quick-shop]');
        if (quickShop && quickShopLabel && !quickShop.hasAttribute('disabled')) {
          quickShop.textContent = quickShopLabel;
        }

        const learnMore = card.querySelector('.top-picks-card__learn-more');
        if (learnMore && learnMoreLabel) {
          const context = learnMore.querySelector('.visually-hidden');
          learnMore.textContent = learnMoreLabel;
          if (context) learnMore.appendChild(context);
        }
      }

      function appendCards(cards) {
        if (!cards || !cards.length) return 0;

        const fragment = document.createDocumentFragment();
        const added = [];

        cards.forEach(function (node) {
          const card = document.importNode(node, true);
          applyLabels(card);
          fragment.appendChild(card);
          added.push(card);
        });

        if (!added.length) return 0;
        grid.appendChild(fragment);

        added.forEach(function (card) {
          try {
            if (typeof window.bindTopPicksCard === 'function') {
              window.bindTopPicksCard(card, root);
            }
          } catch (err) {
            console.error('[top-picks] bind card failed', err);
          }
        });

        return added.length;
      }

      async function readFeedPage(page) {
        if (!collectionUrl) return null;
        const url = new URL(collectionUrl, window.location.origin);
        url.searchParams.set('view', FEED_VIEW);
        if (page > 1) url.searchParams.set('page', String(page));

        const html = await requestText(url.toString());
        if (html == null) return null;
        // A missing alternate template renders the standard collection page instead of a 404.
        return parseCards(html, '[data-top-picks-feed]');
      }

      async function readSectionPage(page) {
        if (!sectionId) return null;
        const url = new URL(window.location.pathname, window.location.origin);
        new URL(window.location.href).searchParams.forEach(function (value, key) {
          if (key === 'page' || key === 'sections' || key === 'section_id' || key === 'view') return;
          url.searchParams.set(key, value);
        });
        url.searchParams.set('sections', sectionId);
        url.searchParams.set('page', String(page));

        const body = await requestText(url.toString());
        if (body == null) return null;

        let payload = null;
        try {
          payload = JSON.parse(body);
        } catch (err) {
          return null;
        }
        if (!payload || typeof payload !== 'object') return null;

        let html = payload[sectionId];
        if (typeof html !== 'string') {
          const keys = Object.keys(payload);
          if (keys.length === 1 && typeof payload[keys[0]] === 'string') html = payload[keys[0]];
        }
        if (typeof html !== 'string' || !html) return null;

        const parsed = parseCards(html, '[data-top-picks-grid]');
        if (!parsed) return null;
        return { cards: parsed.cards, hasNext: parsed.cards.length >= perPage };
      }

      async function collectFromFeed(need) {
        const out = [];

        while (out.length < need) {
          while (feedQueue.length && out.length < need) out.push(feedQueue.shift());
          if (out.length >= need || feedDone) break;

          const result = await readFeedPage(feedPage + 1);
          if (!result) return out.length ? out : null;

          feedPage += 1;
          // The feed restarts at the top of the collection, so its first page overlaps whatever
          // was rendered server-side.
          result.cards.forEach(function (card) {
            if (claim(card)) feedQueue.push(card);
          });
          if (!result.hasNext || !result.cards.length) feedDone = true;
        }

        while (feedQueue.length && out.length < need) out.push(feedQueue.shift());
        if (feedDone && !feedQueue.length) exhausted = true;
        return out;
      }

      async function collectFromSection(need) {
        const out = [];

        while (out.length < need && !exhausted) {
          const result = await readSectionPage(sectionPage + 1);
          if (!result) return out.length ? out : null;

          sectionPage += 1;
          const before = out.length;
          result.cards.forEach(function (card) {
            if (claim(card)) out.push(card);
          });
          // A page that repeats what is already shown means this host URL ignores ?page=.
          if (out.length === before) return out.length ? out : null;
          if (!result.hasNext || !result.cards.length) exhausted = true;
        }

        return out;
      }

      async function collect(need) {
        if (strategy === 'feed') return collectFromFeed(need);
        if (strategy === 'section') return collectFromSection(need);

        const fromFeed = await collectFromFeed(need);
        if (fromFeed && fromFeed.length) {
          strategy = 'feed';
          return fromFeed;
        }

        const fromSection = await collectFromSection(need);
        if (fromSection && fromSection.length) {
          strategy = 'section';
          return fromSection;
        }

        return fromFeed && fromSection ? [] : null;
      }

      function degradeToLink() {
        if (degraded) return;
        degraded = true;

        if (!collectionUrl || !btn.parentNode) {
          btn.hidden = true;
          return;
        }

        const link = document.createElement('a');
        link.className = btn.className;
        link.href = collectionUrl;
        link.textContent = viewAllLabel;
        btn.parentNode.replaceChild(link, btn);
        btn = link;
      }

      btn.addEventListener('click', async function () {
        if (busy || degraded || btn.hidden) return;
        busy = true;
        setLoading(true);

        try {
          const cards = await collect(perPage);
          const added = appendCards(cards || []);

          if (added > 0) {
            loaded += added;
            failedClicks = 0;
          } else if (cards === null) {
            failedClicks += 1;
            if (failedClicks >= FAILED_CLICKS_BEFORE_FALLBACK_LINK) degradeToLink();
          } else {
            // Every product is already on the page.
            exhausted = true;
          }

          updateUi();
        } catch (err) {
          console.error('[top-picks] load more failed', err);
          failedClicks += 1;
          if (failedClicks >= FAILED_CLICKS_BEFORE_FALLBACK_LINK) degradeToLink();
        } finally {
          busy = false;
          setLoading(false);
        }
      });

      updateUi();
    }

    function initAll() {
      document.querySelectorAll('[data-top-picks-root]').forEach(initTopPicksLoadMore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      const root =
        ev.target && ev.target.querySelector ? ev.target.querySelector('[data-top-picks-root]') : null;
      if (root) {
        delete root.dataset.topPicksLoadMoreInit;
        delete root.dataset.topPicksCardsInit;
        initTopPicksLoadMore(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
